
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import Header from "@/components/Header.vue";
import {propertyTypes} from "@/services/properties";
import properties, {codes} from "@/services/properties/global/vita-investimento";
import data, { selectChoices } from "@/services/data/global/vita-investimento";
import categories from "@/services/categories";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import { isNil } from "ramda";
import { format } from "date-fns";
import TextField from "@/components/TextField.vue";
import TextArea from "@/components/TextArea.vue";
import ComboBox from "@/components/ComboBox.vue";
import DatePicker from "@/components/DatePicker.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import Frazionamento from "@/components/Frazionamento.vue";
import StringList from "@/components/StringList.vue";
import StringListFlex from "@/components/StringListFlex.vue";
import TextFieldSign from "@/components/TextFieldSign.vue";
import { PnetInput } from "@previnet/vue-input";
import RangeValuesFlex from "@/components/RangeValuesFlex.vue";
import NestedRangeValuesFlex from "@/components/NestedRangeValuesFlex.vue";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['productId', 'user', 'customCategory', 'customLabel'],
  components: {
    Header,
    TextField,
    ComboBox,
    DatePicker,
    MultiComboBox,
    Frazionamento,
    StringList,
    TextFieldSign,
    TextArea,
    PnetInput,
    RangeValuesFlex,
    NestedRangeValuesFlex,
    StringListFlex,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      errorMsg: null as any,
      okMsg: null as any,
      modalErrorMsg: null as any,
      modalErrorTitle: null as any,
      ...properties,
      ...data,
      selectChoices,
      propertyTypes,
      it,
      ND: "n.d.",
      productIdSelected: this.$props.productId,
      propList: [],
      esitoRegistrazione: null as any,
      categories,
      precFlagPiuVersioni: undefined as any,
      precFlagProdCommercio: undefined as any,
      precFlagTipologiaSottostanti: {
        gestioneSeparata: undefined,
        fondiInterni: undefined,
        oicr: undefined,
        etf: undefined,
      },
      precFlagTipologiaPremio: {
        PIC: undefined,
        PAC: undefined,
        PICePAC: undefined,
        PICoPAC: undefined,
        PICeventualePAC: undefined,
        PACeventualePIC: undefined,
      },
      precFlagRendMinGarantito: {
        riconosciutoAnnualmente: undefined,
        riconosciutoAdEvento: undefined,
        nonRiconosciuto: undefined,
      },
      precFlagOpzioniContrattualiTipologia: {
        cedola: undefined,
        decumulo: undefined,
        rendita: undefined,
        stopLoss: undefined,
        takeProfit: undefined,
        progressiveInvestment: undefined,
        automaticRebalance: undefined,
        downtrendOpportunity: undefined,
        lifeCycle: undefined,
        switch: undefined,
        altreOpzioniContrattuali: undefined,
      },
      precFlagGaranzieAssicurativeTipologia: {
        maggiorazioneCasoMorteStandard: undefined,
        maggiorazioneCasoMortePerInfortunio: undefined,
        maggiorazioneCasoMortePerIncidenteStradale: undefined,
        maggiorazioneCasoMortePerMinusvalenza: undefined,
        TCMStandAlone: undefined,
        longTermCare: undefined,
        dreadDisease: undefined,
        invaliditaInabilita: undefined,
        altreGaranzieAssicurative: undefined,
      },
      precFlagTipologiaFondiInterni: {
        azionari: undefined,
        obbligazionari: undefined,
        bilanciati: undefined,
        flessibili: undefined,
        monetari: undefined,
      },
      precTipologiaCaricamentoPIC: undefined,
      precTipologiaCaricamentoPAC: undefined,
      massiveFile: undefined,
      massiveLoaded: false,
      massiveResult: null as any,
    };
  },
  methods: {
    isNil,
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    printString: function(prop: any) {
      let retValue = undefined;
      if (prop.valueSign !== undefined && prop.valueSign !== null) {
        retValue = prop.valueSignLeft ? prop.valueSign + " " + prop.value : prop.value + prop.valueSign;
      } else {
        retValue = prop.value;
      }

      if (retValue === undefined || retValue === null || retValue === "") {
        return retValue;
      }

      const z = retValue.replaceAll("\n", "<br/>");
      return z;
    },
    home: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    openModalConfirm: function() {
      const vm = this as any;
      if (vm.checkFields() == true) {
        vm.valorizzaTendine();
        vm.preparePropList();
        if (vm.errorMsg == null && vm.propList.length > 0) {
          vm.$bvModal.show("modal-confirm");
        }
      }
    },
    closeModalConfirm() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm");
    },
    openModalMassivo: function() {
      const vm = this as any;
      vm.massiveFile = undefined;
      vm.massiveLoaded = false;
      vm.massiveResult = null;
      vm.$bvModal.show("modal-massive");
    },
    closeModalMassivo() {
      const vm = this as any;
      vm.$bvModal.hide("modal-massive");
    },
    openModalError(msg: any, title: any) {
      const vm = this as any;
      if (msg === undefined) {
        vm.modalErrorMsg = "Non è stato possibile salvare i dati.";
      } else {
        vm.modalErrorMsg = msg;
      }
      if (title === undefined) {
        vm.modalErrorTitle = "ERRORE";
      } else {
        vm.modalErrorTitle = title;
      }
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    openModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.show("modal-confirm-outcome");
    },
    closeModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-outcome");
    },
    onClickReturnConfirmOutcome() {
      const vm = this as any;
      vm.closeModalConfirmOutcome();
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    multivaluesContain(multivalues: any, values: any) {
      if (multivalues != null && values != null) {
        return multivalues.filter(function(e: any) {
          return values.indexOf(e.code) >= 0;
        }).length > 0;
      }

      return false;
    },
    checkFields() {
      const vm = this as any;

      let numErr = 0;

      vm.errorMsg = null;
      vm.okMsg = null;
      if (
        properties.prodottoProperty.value == undefined ||
        properties.prodottoProperty.value == null ||
        properties.prodottoProperty.value == ""
      ) {
        vm.errorMsg =
          "Il campo " + properties.prodottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      if (
        properties.codProdottoProperty.value == undefined ||
        properties.codProdottoProperty.value == null ||
        properties.codProdottoProperty.value == ""
      ) {
        vm.errorMsg =
          "Il campo " + properties.codProdottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      let retValue = true;
      if (numErr > 0) {
        retValue = false;
      } else {
        vm.okMsg = "Prodotto " + properties.prodottoProperty.value + " registrato";
      }

      return retValue;
    },
    isPiuVersioni() {
      const vm = this as any;
      if (selectChoices.piuVersioni.code == '1.1b') {
        return true;
      } else if (selectChoices.piuVersioni.code == '1.2b') {
        return false;
      }
      return undefined;
    },
    initPiuVersioni() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precFlagPiuVersioni === undefined) {
        vm.precFlagPiuVersioni = vm.isPiuVersioni();
      }
    },
    changePiuVersioni() {
      const vm = this as any;

      const isChangedPiuVersioni = vm.precFlagPiuVersioni != vm.isPiuVersioni();

      vm.precFlagPiuVersioni = vm.isPiuVersioni();

      if (isChangedPiuVersioni) {
        if (selectChoices.piuVersioni.code == '1.2b') {
          properties.codProdCollegatiProperty.value = vm.ND;
        } else {
          properties.codProdCollegatiProperty.value = "";
        }
      }
    },
    isGestioneSeparata() {
      let isGestioneSeparata = false;
      for (let ts of selectChoices.tipologiaSottostanti as any){
        if (ts.code == "7.1") {
          isGestioneSeparata = true;
          break;
        }
      }

      return isGestioneSeparata;
    },
    isFondiInterni() {
      let isFondiInterni = false;
      for (let ts of selectChoices.tipologiaSottostanti as any){
        if (ts.code == "7.2") {
          isFondiInterni = true;
          break;
        }
      }

      return isFondiInterni;
    },
    isOICR() {
      let isOICR = false;
      for (let ts of selectChoices.tipologiaSottostanti as any){
        if (ts.code == "7.3") {
          isOICR = true;
          break;
        }
      }

      return isOICR;
    },
    isETF() {
      let isETF = false;
      for (let ts of selectChoices.tipologiaSottostanti as any){
        if (ts.code == "7.4") {
          isETF = true;
          break;
        }
      }

      return isETF;
    },
    initTipologiaSottostanti() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precFlagTipologiaSottostanti.gestioneSeparata === undefined) {
        vm.precFlagTipologiaSottostanti.gestioneSeparata = vm.isGestioneSeparata();
      }
      if (vm.precFlagTipologiaSottostanti.fondiInterni === undefined) {
        vm.precFlagTipologiaSottostanti.fondiInterni = vm.isFondiInterni();
      }
      if (vm.precFlagTipologiaSottostanti.oicr === undefined) {
        vm.precFlagTipologiaSottostanti.oicr = vm.isOICR();
      }
      if (vm.precFlagTipologiaSottostanti.etf === undefined) {
        vm.precFlagTipologiaSottostanti.etf = vm.isETF();
      }
    },
    changeTipologiaSottostanti() {
      const vm = this as any;

      const isChangedGestioneSeparata = vm.precFlagTipologiaSottostanti.gestioneSeparata != vm.isGestioneSeparata();
      const isChangedFondiInterni = vm.precFlagTipologiaSottostanti.fondiInterni != vm.isFondiInterni();
      const isChangedOICR = vm.precFlagTipologiaSottostanti.oicr != vm.isOICR();
      const isChangedETF = vm.precFlagTipologiaSottostanti.etf != vm.isETF();

      vm.precFlagTipologiaSottostanti.gestioneSeparata = vm.isGestioneSeparata();
      vm.precFlagTipologiaSottostanti.fondiInterni = vm.isFondiInterni();
      vm.precFlagTipologiaSottostanti.oicr = vm.isOICR();
      vm.precFlagTipologiaSottostanti.etf = vm.isETF();

      if (!vm.isGestioneSeparata()) {
        properties.invMinGestioneSeparataProperty.value = vm.ND; properties.invMinGestioneSeparataProperty.valueSign = "";
        properties.invMaxGestioneSeparataProperty.value = vm.ND; properties.invMaxGestioneSeparataProperty.valueSign = "";
        properties.gestioneSeparataProperty.value = vm.ND;
        properties.ultimoRendCertGestioneSeparataProperty.value = vm.ND; properties.ultimoRendCertGestioneSeparataProperty.valueSign = "";
        properties.annoRendCertGestioneSeparataProperty.value = vm.ND;
        selectChoices.rendMinGarantito.code = "30"; selectChoices.rendMinGarantito.description = vm.ND;
        properties.rendMinGarantitoProperty.code = "30"; properties.rendMinGarantitoProperty.value = vm.ND;
        properties.rendMinGarantitoMisuraProperty.value = vm.ND;
        selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali.code = "32"; selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali.description = vm.ND;
        properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty.code = "32"; properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty.value = vm.ND;
        properties.consolidamentoAnnuoRivalutazioniContrattualiProperty.value = vm.ND;
        selectChoices.fondoUtili.code = "34"; selectChoices.fondoUtili.description = vm.ND;
        properties.fondoUtiliProperty.code = "34"; properties.fondoUtiliProperty.value = vm.ND;
        selectChoices.tipologiaCommissioneGestioneSeparata.code = "91"; selectChoices.tipologiaCommissioneGestioneSeparata.description = vm.ND;
        properties.tipologiaCommissioneGestioneSeparataProperty.code = "91"; properties.tipologiaCommissioneGestioneSeparataProperty.value = vm.ND;
        properties.commissioneGestioneSeparataProperty.value = vm.ND;
        properties.commissioneGestioneSeparataProperty.valueSign = ""; 
        properties.commissioneGestioneSeparataProperty.stringList = [
          { value: "", showSign: false, valueSign: "", valueSignReadonly: false, valueSignLeft: false, showLabel: false, valueLabel: "", valueLabelReadonly: false, valueLabelFix: false},
          { value: "", showSign: false, valueSign: "", valueSignReadonly: false, valueSignLeft: false, showLabel: false, valueLabel: "", valueLabelReadonly: false, valueLabelFix: false},
        ];
        properties.commissioneGestioneSeparataProperty.rangeValuesFlex = [];
        properties.retrocessioneGestioneSeparataProperty.value = vm.ND;
        properties.retrocessioneGestioneSeparataProperty.stringList = [];
      } else if (isChangedGestioneSeparata) {
        properties.invMinGestioneSeparataProperty.value = ""; properties.invMinGestioneSeparataProperty.valueSign = "%";
        properties.invMaxGestioneSeparataProperty.value = ""; properties.invMaxGestioneSeparataProperty.valueSign = "%";
        properties.gestioneSeparataProperty.value = "";
        properties.ultimoRendCertGestioneSeparataProperty.value = ""; properties.ultimoRendCertGestioneSeparataProperty.valueSign = "%";
        properties.annoRendCertGestioneSeparataProperty.value = "";
        selectChoices.rendMinGarantito.code = ""; selectChoices.rendMinGarantito.description = "";
        properties.rendMinGarantitoProperty.code = "30"; properties.rendMinGarantitoProperty.value = "";
        properties.rendMinGarantitoMisuraProperty.value = "";
        selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali.code = ""; selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali.description = "";
        properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty.code = "32"; properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty.value = "";
        properties.consolidamentoAnnuoRivalutazioniContrattualiProperty.value = "";
        selectChoices.fondoUtili.code = ""; selectChoices.fondoUtili.description = "";
        properties.fondoUtiliProperty.code = "34"; properties.fondoUtiliProperty.value = "";
        selectChoices.tipologiaCommissioneGestioneSeparata.code = ""; selectChoices.tipologiaCommissioneGestioneSeparata.description = "";
        properties.tipologiaCommissioneGestioneSeparataProperty.code = "91"; properties.tipologiaCommissioneGestioneSeparataProperty.value = "";
        properties.commissioneGestioneSeparataProperty.value = "";
        properties.commissioneGestioneSeparataProperty.valueSign = ""; 
        properties.commissioneGestioneSeparataProperty.stringList = [
          { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "", valueLabelReadonly: false, valueLabelFix: true},
          { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "Commissione Min.", valueLabelReadonly: false, valueLabelFix: true},
        ];
        properties.commissioneGestioneSeparataProperty.rangeValuesFlex = [];
        properties.retrocessioneGestioneSeparataProperty.value = "";
        properties.retrocessioneGestioneSeparataProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
      }

      if (!(vm.isFondiInterni() || vm.isOICR() || vm.isETF())) {
        properties.invMinRamoIIIProperty.value = vm.ND; properties.invMinRamoIIIProperty.valueSign = "";
        properties.invMaxRamoIIIProperty.value = vm.ND; properties.invMaxRamoIIIProperty.valueSign = "";
        selectChoices.presenzaProtezioneCapitale.code = "39"; selectChoices.presenzaProtezioneCapitale.description = vm.ND;
        properties.presenzaProtezioneCapitaleProperty.code = "39"; properties.presenzaProtezioneCapitaleProperty.value = vm.ND;
        properties.protezioneCapitaleProperty.value = vm.ND;
        properties.retrocessioneRamoIIIProperty.value = vm.ND;
        properties.retrocessioneRamoIIIProperty.stringList = [];
      } else if (isChangedFondiInterni && isChangedOICR && isChangedETF) {
        properties.invMinRamoIIIProperty.value = ""; properties.invMinRamoIIIProperty.valueSign = "%";
        properties.invMaxRamoIIIProperty.value = ""; properties.invMaxRamoIIIProperty.valueSign = "%";
        selectChoices.presenzaProtezioneCapitale.code = ""; selectChoices.presenzaProtezioneCapitale.description = "";
        properties.presenzaProtezioneCapitaleProperty.code = "39"; properties.presenzaProtezioneCapitaleProperty.value = "";
        properties.protezioneCapitaleProperty.value = "";
      } else if (isChangedFondiInterni || isChangedOICR || isChangedETF) {
        if (properties.invMinRamoIIIProperty.value == vm.ND) {
          properties.invMinRamoIIIProperty.value = ""; properties.invMinRamoIIIProperty.valueSign = "%";
        }
        if (properties.invMaxRamoIIIProperty.value == vm.ND) {
          properties.invMaxRamoIIIProperty.value = ""; properties.invMaxRamoIIIProperty.valueSign = "%";
        }
        if (properties.presenzaProtezioneCapitaleProperty.value == vm.ND) {
          selectChoices.presenzaProtezioneCapitale.code = ""; selectChoices.presenzaProtezioneCapitale.description = "";
          properties.presenzaProtezioneCapitaleProperty.code = "39"; properties.presenzaProtezioneCapitaleProperty.value = "";
        }
        if (properties.protezioneCapitaleProperty.value == vm.ND) {
          properties.protezioneCapitaleProperty.value = "";
        }
        properties.retrocessioneRamoIIIProperty.value = "";
        properties.retrocessioneRamoIIIProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
      }

      if (!vm.isFondiInterni()) {
        properties.numFondiInterniProperty.value = vm.ND;
        selectChoices.tipologiaFondiInterni = [];
        properties.tipologiaFondiInterniProperty.value = vm.ND;
        properties.tipologiaFondiInterniProperty.values = [];
        selectChoices.tipologiaCommissioneFondiInterni.code = "93"; selectChoices.tipologiaCommissioneFondiInterni.description = vm.ND;
        properties.tipologiaCommissioneFondiInterniProperty.code = "93"; properties.tipologiaCommissioneFondiInterniProperty.value = vm.ND;
        properties.commissioneFondiInterniAzionariProperty.value = vm.ND;
        properties.commissioneFondiInterniAzionariProperty.valueSign = "";
        properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = [];
        properties.commissioneFondiInterniObbligazionariProperty.value = vm.ND;
        properties.commissioneFondiInterniObbligazionariProperty.valueSign = "";
        properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = [];
        properties.commissioneFondiInterniBilanciatiProperty.value = vm.ND;
        properties.commissioneFondiInterniBilanciatiProperty.valueSign = "";
        properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = [];
        properties.commissioneFondiInterniFlessibiliProperty.value = vm.ND;
        properties.commissioneFondiInterniFlessibiliProperty.valueSign = "";
        properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = [];
        properties.commissioneFondiInterniMonetariProperty.value = vm.ND;
        properties.commissioneFondiInterniMonetariProperty.valueSign = "";
        properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = [];
        properties.commissioneSottostantiFondiInterniProperty.value = vm.ND;
        properties.commissioneSottostantiFondiInterniProperty.stringList = [];
      } else if (isChangedFondiInterni) {
        properties.numFondiInterniProperty.value = "";
        selectChoices.tipologiaFondiInterni = [];
        properties.tipologiaFondiInterniProperty.value = "";
        properties.tipologiaFondiInterniProperty.values = [];
        selectChoices.tipologiaCommissioneFondiInterni.code = ""; selectChoices.tipologiaCommissioneFondiInterni.description = "";
        properties.tipologiaCommissioneFondiInterniProperty.code = "93"; properties.tipologiaCommissioneFondiInterniProperty.value = "";
        properties.commissioneFondiInterniAzionariProperty.value = "";
        properties.commissioneFondiInterniAzionariProperty.valueSign = "";
        properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = [];
        properties.commissioneFondiInterniObbligazionariProperty.value = "";
        properties.commissioneFondiInterniObbligazionariProperty.valueSign = "";
        properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = [];
        properties.commissioneFondiInterniBilanciatiProperty.value = "";
        properties.commissioneFondiInterniBilanciatiProperty.valueSign = "";
        properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = [];
        properties.commissioneFondiInterniFlessibiliProperty.value = "";
        properties.commissioneFondiInterniFlessibiliProperty.valueSign = "";
        properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = [];
        properties.commissioneFondiInterniMonetariProperty.value = "";
        properties.commissioneFondiInterniMonetariProperty.valueSign = "";
        properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = [];
        properties.commissioneSottostantiFondiInterniProperty.value = "";
        properties.commissioneSottostantiFondiInterniProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Max." }];
      }

      if (!(vm.isOICR() || vm.isETF())) {
        selectChoices.numOICRETF.code = "38"; selectChoices.numOICRETF.description = vm.ND;
        properties.numOICRETFProperty.code = "38"; properties.numOICRETFProperty.value = vm.ND;
        selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code = "100"; selectChoices.tipologiaSpeseGestionePolizzaOICRETF.description = vm.ND;
        properties.tipologiaSpeseGestionePolizzaOICRETFProperty.code = "100"; properties.tipologiaSpeseGestionePolizzaOICRETFProperty.value = vm.ND;
        properties.speseGestionePolizzaOICRETFAzionariProperty.value = vm.ND;
        properties.speseGestionePolizzaOICRETFAzionariProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = [];
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.value = vm.ND;
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = [];
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.value = vm.ND;
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = [];
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.value = vm.ND;
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = [];
        properties.speseGestionePolizzaOICRETFMonetariProperty.value = vm.ND;
        properties.speseGestionePolizzaOICRETFMonetariProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = [];
        properties.commissioneOICRETFProperty.value = vm.ND;
        properties.commissioneOICRETFProperty.stringList = [];
      } else if (isChangedOICR && isChangedETF) {
        selectChoices.numOICRETF.code = ""; selectChoices.numOICRETF.description = "";
        properties.numOICRETFProperty.code = "38"; properties.numOICRETFProperty.value = "";
      } else if (isChangedOICR || isChangedETF) {
        if (properties.numOICRETFProperty.value == vm.ND) {
          selectChoices.numOICRETF.code = ""; selectChoices.numOICRETF.description = "";
          properties.numOICRETFProperty.code = "38"; properties.numOICRETFProperty.value = "";
        }
        selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code = ""; selectChoices.tipologiaSpeseGestionePolizzaOICRETF.description = "";
        properties.tipologiaSpeseGestionePolizzaOICRETFProperty.code = "100"; properties.tipologiaSpeseGestionePolizzaOICRETFProperty.value = "";
        properties.speseGestionePolizzaOICRETFAzionariProperty.value = "";
        properties.speseGestionePolizzaOICRETFAzionariProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = [];
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.value = "";
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = [];
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.value = "";
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = [];
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.value = "";
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = [];
        properties.speseGestionePolizzaOICRETFMonetariProperty.value = "";
        properties.speseGestionePolizzaOICRETFMonetariProperty.valueSign = "";
        properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = [];
        if (vm.isTipologiaSpeseGestPolOICRETFPercentualeFissa()) {
          properties.speseGestionePolizzaOICRETFAzionariProperty.valueSign = "%";
          properties.speseGestionePolizzaOICRETFObbligazionariProperty.valueSign = "%";
          properties.speseGestionePolizzaOICRETFBilanciatiProperty.valueSign = "%";
          properties.speseGestionePolizzaOICRETFFlessibiliProperty.valueSign = "%";
          properties.speseGestionePolizzaOICRETFMonetariProperty.valueSign = "%";
        } else if (vm.isTipologiaSpeseGestPolOICRETFFasceCumuloCapitale() ||
          vm.isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitale() ||
          vm.isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnui()) {
          properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
          properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
          properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
          properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
          properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        } else if (vm.isTipologiaSpeseGestPolOICRETFPercentualeFunzioneDelTempo()) {
          properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
          properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
          properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
          properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
          properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        } else if (vm.isTipologiaSpeseGestPolOICRETFFasceCumuloCapitaleFunzioneDelTempo() ||
          vm.isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitaleFunzioneDelTempo()) {
          properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
          properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
          properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
          properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
          properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        } else if (vm.isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnuiFunzioneDelTempo()) {
          properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
          properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
          properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
          properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
          properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        }
        properties.commissioneOICRETFProperty.value = "";
        properties.commissioneOICRETFProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
      }
    },
    isRendMinGarantitoND() {
      let isND = false;

      if (selectChoices.rendMinGarantito.code == "30") {
        isND = true;
      }
      return isND;
    },
    isRendMinGarantitoRiconosciutoAnnualmente() {
      let isRiconosciutoAnnualmente = false;

      if (selectChoices.rendMinGarantito.code == "30.1") {
        isRiconosciutoAnnualmente = true;
      }
      return isRiconosciutoAnnualmente;
    },
    isRendMinGarantitoRiconosciutoAdEvento() {
      let isRiconosciutoAdEvento = false;

      if (selectChoices.rendMinGarantito.code == "30.2") {
        isRiconosciutoAdEvento = true;
      }
      return isRiconosciutoAdEvento;
    },
    isRendMinGarantitoNonRiconosciuto() {
      let isNonRiconosciuto = false;

      if (selectChoices.rendMinGarantito.code == "30.3") {
        isNonRiconosciuto = true;
      }
      return isNonRiconosciuto;
    },
    initRendMinGarantito() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precFlagRendMinGarantito.riconosciutoAnnualmente === undefined) {
        vm.precFlagRendMinGarantito.riconosciutoAnnualmente = vm.isRendMinGarantitoRiconosciutoAnnualmente();
      }
      if (vm.precFlagRendMinGarantito.riconosciutoAdEvento === undefined) {
        vm.precFlagRendMinGarantito.riconosciutoAdEvento = vm.isRendMinGarantitoRiconosciutoAdEvento();
      }
      if (vm.precFlagRendMinGarantito.nonRiconosciuto === undefined) {
        vm.precFlagRendMinGarantito.nonRiconosciuto = vm.isRendMinGarantitoNonRiconosciuto();
      }
    },    
    changeRendMinGarantito() {
      const vm = this as any;

      const isRiconosciutoAnnualmente = vm.isRendMinGarantitoRiconosciutoAnnualmente();
      const isRiconosciutoAdEvento = vm.isRendMinGarantitoRiconosciutoAdEvento();
      const isNonRiconosciuto = vm.isRendMinGarantitoNonRiconosciuto();

      const isChangedRiconosciutoAnnualmente = vm.precFlagRendMinGarantito.riconosciutoAnnualmente != isRiconosciutoAnnualmente;
      const isChangedRiconosciutoAdEvento = vm.precFlagRendMinGarantito.riconosciutoAdEvento != isRiconosciutoAdEvento;
      const isChangedNonRiconosciuto = vm.precFlagRendMinGarantito.nonRiconosciuto != isNonRiconosciuto;

      vm.precFlagRendMinGarantito.riconosciutoAnnualmente = isRiconosciutoAnnualmente;
      vm.precFlagRendMinGarantito.riconosciutoAdEvento = isRiconosciutoAdEvento;
      vm.precFlagRendMinGarantito.nonRiconosciuto = isNonRiconosciuto;

      if (isChangedRiconosciutoAnnualmente ||
          isChangedRiconosciutoAdEvento ||
          isChangedNonRiconosciuto) {
        properties.rendMinGarantitoMisuraProperty.value = "";
      }

      if (vm.isRendMinGarantitoNonRiconosciuto()) {
        properties.rendMinGarantitoMisuraProperty.value = "Non riconosciuto";
      } else if (vm.isRendMinGarantitoND()) {
        properties.rendMinGarantitoMisuraProperty.value = vm.ND;
      }
    },
    isPresConsolidamentoAnnuoRivalContrattNonRiconosciuto() {
      let isNonRiconosciuto = false;

      if (selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali.code == "32.2") {
        isNonRiconosciuto = true;
      }
      return isNonRiconosciuto;
    },
    changePresConsolidamentoAnnuoRivalContratt() {
      const vm = this as any;

      properties.consolidamentoAnnuoRivalutazioniContrattualiProperty.value = "";

      if (vm.isPresConsolidamentoAnnuoRivalContrattNonRiconosciuto()) {
        properties.consolidamentoAnnuoRivalutazioniContrattualiProperty.value = "Non riconosciuto";
      }
    },
    isPresProtezioneCapitaleNonRiconosciuto() {
      let isNonRiconosciuto = false;

      if (selectChoices.presenzaProtezioneCapitale.code == "39.2") {
        isNonRiconosciuto = true;
      }
      return isNonRiconosciuto;
    },
    changePresProtezioneCapitale() {
      const vm = this as any;

      properties.protezioneCapitaleProperty.value = "";

      if (vm.isPresProtezioneCapitaleNonRiconosciuto()) {
        properties.protezioneCapitaleProperty.value = "Non presente";
      }
    },
    isOpzioniContrattualiCedola() {
      let isCedola = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.1") {
          isCedola = true;
          break;
        }
      }
      return isCedola;
    },
    isOpzioniContrattualiDecumulo() {
      let isDecumulo = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.2") {
          isDecumulo = true;
          break;
        }
      }
      return isDecumulo;
    },
    isOpzioniContrattualiRendita() {
      let isRendita = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.3") {
          isRendita = true;
          break;
        }
      }
      return isRendita;
    },
    isOpzioniContrattualiStopLoss() {
      let isStopLoss = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.4") {
          isStopLoss = true;
          break;
        }
      }
      return isStopLoss;
    },
    isOpzioniContrattualiTakeProfit() {
      let isTakeProfit = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.5") {
          isTakeProfit = true;
          break;
        }
      }
      return isTakeProfit;
    },
    isOpzioniContrattualiProgressiveInvestment() {
      let isProgressiveInvestment = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.6") {
          isProgressiveInvestment = true;
          break;
        }
      }
      return isProgressiveInvestment;
    },
    isOpzioniContrattualiAutomaticRebalance() {
      let isAutomaticRebalance = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.7") {
          isAutomaticRebalance = true;
          break;
        }
      }
      return isAutomaticRebalance;
    },
    isOpzioniContrattualiDowntrendOpportunity() {
      let isDowntrendOpportunity = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.8") {
          isDowntrendOpportunity = true;
          break;
        }
      }
      return isDowntrendOpportunity;
    },
    isOpzioniContrattualiLifeCycle() {
      let isLifeCycle = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.9") {
          isLifeCycle = true;
          break;
        }
      }
      return isLifeCycle;
    },
    isOpzioniContrattualiSwitch() {
      let isSwitch = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.12") {
          isSwitch = true;
          break;
        }
      }
      return isSwitch;
    },
    isOpzioniContrattualiAltreOpzioni() {
      let isAltreOpzioni = false;
      for (let o of selectChoices.opzioniContrattualiTipologia as any){
        if (o.code == "45.10") {
          isAltreOpzioni = true;
          break;
        }
      }
      return isAltreOpzioni;
    },
    initOpzioniContrattualiTipologia() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precFlagOpzioniContrattualiTipologia.cedola === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.cedola = vm.isOpzioniContrattualiCedola();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.decumulo === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.decumulo = vm.isOpzioniContrattualiDecumulo();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.rendita === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.rendita = vm.isOpzioniContrattualiRendita();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.stopLoss === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.stopLoss = vm.isOpzioniContrattualiStopLoss();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.takeProfit === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.takeProfit = vm.isOpzioniContrattualiTakeProfit();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.progressiveInvestment === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.progressiveInvestment = vm.isOpzioniContrattualiProgressiveInvestment();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.automaticRebalance === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.automaticRebalance = vm.isOpzioniContrattualiAutomaticRebalance();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.downtrendOpportunity === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.downtrendOpportunity = vm.isOpzioniContrattualiDowntrendOpportunity();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.lifeCycle === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.lifeCycle = vm.isOpzioniContrattualiLifeCycle();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.switch === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.switch = vm.isOpzioniContrattualiSwitch();
      }
      if (vm.precFlagOpzioniContrattualiTipologia.altreOpzioniContrattuali === undefined) {
        vm.precFlagOpzioniContrattualiTipologia.altreOpzioniContrattuali = vm.isOpzioniContrattualiAltreOpzioni();
      }
    },
    changeOpzioniContrattualiTipologia() {
      const vm = this as any;

      const isOpzioniContrattualiCedola = vm.isOpzioniContrattualiCedola();
      const isOpzioniContrattualiDecumulo = vm.isOpzioniContrattualiDecumulo();
      const isOpzioniContrattualiRendita = vm.isOpzioniContrattualiRendita();
      const isOpzioniContrattualiStopLoss = vm.isOpzioniContrattualiStopLoss();
      const isOpzioniContrattualiTakeProfit = vm.isOpzioniContrattualiTakeProfit();
      const isOpzioniContrattualiProgressiveInvestment = vm.isOpzioniContrattualiProgressiveInvestment();
      const isOpzioniContrattualiAutomaticRebalance = vm.isOpzioniContrattualiAutomaticRebalance();
      const isOpzioniContrattualiDowntrendOpportunity = vm.isOpzioniContrattualiDowntrendOpportunity();
      const isOpzioniContrattualiLifeCycle = vm.isOpzioniContrattualiLifeCycle();
      const isOpzioniContrattualiSwitch = vm.isOpzioniContrattualiSwitch();
      const isOpzioniContrattualiAltreOpzioni = vm.isOpzioniContrattualiAltreOpzioni();

      const isChangedCedola = vm.precFlagOpzioniContrattualiTipologia.cedola != isOpzioniContrattualiCedola;
      const isChangedDecumulo = vm.precFlagOpzioniContrattualiTipologia.decumulo != isOpzioniContrattualiDecumulo;
      const isChangedRendita = vm.precFlagOpzioniContrattualiTipologia.rendita != isOpzioniContrattualiRendita;
      const isChangedStopLoss = vm.precFlagOpzioniContrattualiTipologia.stopLoss != isOpzioniContrattualiStopLoss;
      const isChangedTakeProfit = vm.precFlagOpzioniContrattualiTipologia.takeProfit != isOpzioniContrattualiTakeProfit;
      const isChangedProgressiveInvestment = vm.precFlagOpzioniContrattualiTipologia.progressiveInvestment != isOpzioniContrattualiProgressiveInvestment;
      const isChangedAutomaticRebalance = vm.precFlagOpzioniContrattualiTipologia.automaticRebalance != isOpzioniContrattualiAutomaticRebalance;
      const isChangedDowntrendOpportunity = vm.precFlagOpzioniContrattualiTipologia.downtrendOpportunity != isOpzioniContrattualiDowntrendOpportunity;
      const isChangedLifeCycle = vm.precFlagOpzioniContrattualiTipologia.lifeCycle != isOpzioniContrattualiLifeCycle;
      const isChangedSwitch = vm.precFlagOpzioniContrattualiTipologia.switch != isOpzioniContrattualiSwitch;
      const isChangedAltreOpzioni = vm.precFlagOpzioniContrattualiTipologia.altreOpzioniContrattuali != isOpzioniContrattualiAltreOpzioni;

      vm.precFlagOpzioniContrattualiTipologia.cedola = isOpzioniContrattualiCedola;
      vm.precFlagOpzioniContrattualiTipologia.decumulo = isOpzioniContrattualiDecumulo;
      vm.precFlagOpzioniContrattualiTipologia.rendita = isOpzioniContrattualiRendita;
      vm.precFlagOpzioniContrattualiTipologia.stopLoss = isOpzioniContrattualiStopLoss;
      vm.precFlagOpzioniContrattualiTipologia.takeProfit = isOpzioniContrattualiTakeProfit;
      vm.precFlagOpzioniContrattualiTipologia.progressiveInvestment = isOpzioniContrattualiProgressiveInvestment;
      vm.precFlagOpzioniContrattualiTipologia.automaticRebalance = isOpzioniContrattualiAutomaticRebalance;
      vm.precFlagOpzioniContrattualiTipologia.downtrendOpportunity = isOpzioniContrattualiDowntrendOpportunity;
      vm.precFlagOpzioniContrattualiTipologia.lifeCycle = isOpzioniContrattualiLifeCycle;
      vm.precFlagOpzioniContrattualiTipologia.switch = isOpzioniContrattualiSwitch;
      vm.precFlagOpzioniContrattualiTipologia.altreOpzioniContrattuali = isOpzioniContrattualiAltreOpzioni;

      if (!isOpzioniContrattualiCedola) {
        properties.cedolaProperty.value = vm.ND;
      } else if (isChangedCedola) {
        properties.cedolaProperty.value = "";
      }

      if (!isOpzioniContrattualiDecumulo) {
        properties.decumuloProperty.value = vm.ND;
      } else if (isChangedDecumulo) {
        properties.decumuloProperty.value = "";
      }

      if (!isOpzioniContrattualiRendita) {
        properties.renditaProperty.value = vm.ND;
      } else if (isChangedRendita) {
        properties.renditaProperty.value = "";
      }

      if (!isOpzioniContrattualiStopLoss) {
        properties.stopLossProperty.value = vm.ND;
      } else if (isChangedStopLoss) {
        properties.stopLossProperty.value = "";
      }

      if (!isOpzioniContrattualiTakeProfit) {
        properties.takeProfitProperty.value = vm.ND;
      } else if (isChangedTakeProfit) {
        properties.takeProfitProperty.value = "";
      }

      if (!isOpzioniContrattualiProgressiveInvestment) {
        properties.progressiveInvestmentProperty.value = vm.ND;
      } else if (isChangedProgressiveInvestment) {
        properties.progressiveInvestmentProperty.value = "";
      }

      if (!isOpzioniContrattualiAutomaticRebalance) {
        properties.automaticRebalanceProperty.value = vm.ND;
      } else if (isChangedAutomaticRebalance) {
        properties.automaticRebalanceProperty.value = "";
      }

      if (!isOpzioniContrattualiDowntrendOpportunity) {
        properties.downtrendOpportunityProperty.value = vm.ND;
      } else if (isChangedDowntrendOpportunity) {
        properties.downtrendOpportunityProperty.value = "";
      }

      if (!isOpzioniContrattualiLifeCycle) {
        properties.lifeCycleProperty.value = vm.ND;
      } else if (isChangedLifeCycle) {
        properties.lifeCycleProperty.value = "";
      }

      if (!isOpzioniContrattualiSwitch) {
        properties.switchProperty.value = vm.ND;
      } else if (isChangedSwitch) {
        properties.switchProperty.value = "";
      }

      if (!isOpzioniContrattualiAltreOpzioni) {
        properties.altreOpzioniContrattualiProperty.value = vm.ND;
      } else if (isChangedAltreOpzioni) {
        properties.altreOpzioniContrattualiProperty.value = "";
      }
    },
    isMaggiorazioneCasoMorteStandard() {
      let isMaggiorazioneCasoMorteStandard = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.1") {
          isMaggiorazioneCasoMorteStandard = true;
          break;
        }
      }
      return isMaggiorazioneCasoMorteStandard;
    },
    isMaggiorazioneCasoMortePerInfortunio() {
      let isMaggiorazioneCasoMortePerInfortunio = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.2") {
          isMaggiorazioneCasoMortePerInfortunio = true;
          break;
        }
      }
      return isMaggiorazioneCasoMortePerInfortunio;
    },
    isMaggiorazioneCasoMortePerIncidenteStradale() {
      let isMaggiorazioneCasoMortePerIncidenteStradale = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.3") {
          isMaggiorazioneCasoMortePerIncidenteStradale = true;
          break;
        }
      }
      return isMaggiorazioneCasoMortePerIncidenteStradale;
    },
    isMaggiorazioneCasoMortePerMinusvalenza() {
      let isMaggiorazioneCasoMortePerMinusvalenza = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.4") {
          isMaggiorazioneCasoMortePerMinusvalenza = true;
          break;
        }
      }
      return isMaggiorazioneCasoMortePerMinusvalenza;
    },
    isTCMStandAlone() {
      let isTCMStandAlone = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.5") {
          isTCMStandAlone = true;
          break;
        }
      }
      return isTCMStandAlone;
    },
    isLongTermCare() {
      let isLongTermCare = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.6") {
          isLongTermCare = true;
          break;
        }
      }
      return isLongTermCare;
    },
    isDreadDisease() {
      let isDreadDisease = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.7") {
          isDreadDisease = true;
          break;
        }
      }
      return isDreadDisease;
    },
    isInvaliditaInabilita() {
      let isInvaliditaInabilita = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.8") {
          isInvaliditaInabilita = true;
          break;
        }
      }
      return isInvaliditaInabilita;
    },
    isAltreGaranzieAssicurative() {
      let isAltreGaranzieAssicurative = false;
      for (let g of selectChoices.garanzieAssicurativeTipologia as any){
        if (g.code == "62.9") {
          isAltreGaranzieAssicurative = true;
          break;
        }
      }
      return isAltreGaranzieAssicurative;
    },
    initGaranzieAssicurativeTipologia() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMorteStandard === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMorteStandard = vm.isMaggiorazioneCasoMorteStandard();
      }
      if (vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerInfortunio === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerInfortunio = vm.isMaggiorazioneCasoMortePerInfortunio();
      }
      if (vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerIncidenteStradale === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerIncidenteStradale = vm.isMaggiorazioneCasoMortePerIncidenteStradale();
      }
      if (vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerMinusvalenza === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerMinusvalenza = vm.isMaggiorazioneCasoMortePerMinusvalenza();
      }
      if (vm.precFlagGaranzieAssicurativeTipologia.TCMStandAlone === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.TCMStandAlone = vm.isTCMStandAlone();
      }
      if (vm.precFlagGaranzieAssicurativeTipologia.longTermCare === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.longTermCare = vm.isLongTermCare();
      }
      if (vm.precFlagGaranzieAssicurativeTipologia.dreadDisease === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.dreadDisease = vm.isDreadDisease();
      }
      if (vm.precFlagGaranzieAssicurativeTipologia.invaliditaInabilita === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.invaliditaInabilita = vm.isInvaliditaInabilita();
      }
      if (vm.precFlagGaranzieAssicurativeTipologia.altreGaranzieAssicurative === undefined) {
        vm.precFlagGaranzieAssicurativeTipologia.altreGaranzieAssicurative = vm.isAltreGaranzieAssicurative();
      }
    },
    changeGaranzieAssicurativeTipologia() {
      const vm = this as any;

      const isMaggiorazioneCasoMorteStandard = vm.isMaggiorazioneCasoMorteStandard();
      const isMaggiorazioneCasoMortePerInfortunio = vm.isMaggiorazioneCasoMortePerInfortunio();
      const isMaggiorazioneCasoMortePerIncidenteStradale = vm.isMaggiorazioneCasoMortePerIncidenteStradale();
      const isMaggiorazioneCasoMortePerMinusvalenza = vm.isMaggiorazioneCasoMortePerMinusvalenza();
      const isTCMStandAlone = vm.isTCMStandAlone();
      const isLongTermCare = vm.isLongTermCare();
      const isDreadDisease = vm.isDreadDisease();
      const isInvaliditaInabilita = vm.isInvaliditaInabilita();
      const isAltreGaranzieAssicurative = vm.isAltreGaranzieAssicurative();

      const isChangedMaggiorazioneCasoMorteStandard = vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMorteStandard != isMaggiorazioneCasoMorteStandard;
      const isChangedMaggiorazioneCasoMortePerInfortunio = vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerInfortunio != isMaggiorazioneCasoMortePerInfortunio;
      const isChangedMaggiorazioneCasoMortePerIncidenteStradale = vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerIncidenteStradale != isMaggiorazioneCasoMortePerIncidenteStradale;
      const isChangedMaggiorazioneCasoMortePerMinusvalenza = vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerMinusvalenza != isMaggiorazioneCasoMortePerMinusvalenza;
      const isChangedTCMStandAlone = vm.precFlagGaranzieAssicurativeTipologia.TCMStandAlone != isTCMStandAlone;
      const isChangedLongTermCare = vm.precFlagGaranzieAssicurativeTipologia.longTermCare != isLongTermCare;
      const isChangedDreadDisease = vm.precFlagGaranzieAssicurativeTipologia.dreadDisease != isDreadDisease;
      const isChangedInvaliditaInabilita = vm.precFlagGaranzieAssicurativeTipologia.invaliditaInabilita != isInvaliditaInabilita;
      const isChangedAltreGaranzieAssicurative = vm.precFlagGaranzieAssicurativeTipologia.altreGaranzieAssicurative != isAltreGaranzieAssicurative;

      vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMorteStandard = isMaggiorazioneCasoMorteStandard;
      vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerInfortunio = isMaggiorazioneCasoMortePerInfortunio;
      vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerIncidenteStradale = isMaggiorazioneCasoMortePerIncidenteStradale;
      vm.precFlagGaranzieAssicurativeTipologia.maggiorazioneCasoMortePerMinusvalenza = isMaggiorazioneCasoMortePerMinusvalenza;
      vm.precFlagGaranzieAssicurativeTipologia.TCMStandAlone = isTCMStandAlone;
      vm.precFlagGaranzieAssicurativeTipologia.longTermCare = isLongTermCare;
      vm.precFlagGaranzieAssicurativeTipologia.dreadDisease = isDreadDisease;
      vm.precFlagGaranzieAssicurativeTipologia.invaliditaInabilita = isInvaliditaInabilita;
      vm.precFlagGaranzieAssicurativeTipologia.altreGaranzieAssicurative = isAltreGaranzieAssicurative;

      if (!isMaggiorazioneCasoMorteStandard) {
        selectChoices.maggiorazioneCasoMorteStandard.code = "63"; selectChoices.maggiorazioneCasoMorteStandard.description = vm.ND;
        properties.maggiorazioneCasoMorteStandardProperty.code = "63"; properties.maggiorazioneCasoMorteStandardProperty.value = vm.ND;
        properties.maggiorazioneCasoMorteStandardPrestazioneProperty.value = vm.ND; properties.maggiorazioneCasoMorteStandardPrestazioneProperty.stringList = [];
        properties.costoMaggiorazioneCasoMorteStandardProperty.value = vm.ND; properties.costoMaggiorazioneCasoMorteStandardProperty.valueSign = "";
      } else if (isChangedMaggiorazioneCasoMorteStandard) {
        selectChoices.maggiorazioneCasoMorteStandard.code = ""; selectChoices.maggiorazioneCasoMorteStandard.description = "";
        properties.maggiorazioneCasoMorteStandardProperty.code = "63"; properties.maggiorazioneCasoMorteStandardProperty.value = "";
        properties.maggiorazioneCasoMorteStandardPrestazioneProperty.value = ""; properties.maggiorazioneCasoMorteStandardPrestazioneProperty.stringList = [
          { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "Min. %:", valueLabelReadonly: false, valueLabelFix: true},
          { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "Max. %:", valueLabelReadonly: false, valueLabelFix: true},
          { value: "", showSign: true, valueSign: "€", valueSignReadonly: false, valueSignLeft: true, showLabel: true, valueLabel: "Max. €:", valueLabelReadonly: false, valueLabelFix: true}
        ];
        properties.costoMaggiorazioneCasoMorteStandardProperty.value = ""; properties.costoMaggiorazioneCasoMorteStandardProperty.valueSign = "%";
      }

      if (!isMaggiorazioneCasoMortePerInfortunio) {
        selectChoices.maggiorazioneCasoMortePerInfortunio.code = "65"; selectChoices.maggiorazioneCasoMortePerInfortunio.description = vm.ND;
        properties.maggiorazioneCasoMortePerInfortunioProperty.code = "65"; properties.maggiorazioneCasoMortePerInfortunioProperty.value = vm.ND;
        properties.maggiorazioneCasoMortePerInfortunioPrestazioneProperty.value = vm.ND;
      } else if (isChangedMaggiorazioneCasoMortePerInfortunio) {
        selectChoices.maggiorazioneCasoMortePerInfortunio.code = ""; selectChoices.maggiorazioneCasoMortePerInfortunio.description = "";
        properties.maggiorazioneCasoMortePerInfortunioProperty.code = "65"; properties.maggiorazioneCasoMortePerInfortunioProperty.value = "";
        properties.maggiorazioneCasoMortePerInfortunioPrestazioneProperty.value = "";
      }

      if (!isMaggiorazioneCasoMortePerIncidenteStradale) {
        selectChoices.maggiorazioneCasoMortePerIncidenteStradale.code = "67"; selectChoices.maggiorazioneCasoMortePerIncidenteStradale.description = vm.ND;
        properties.maggiorazioneCasoMortePerIncidenteStradaleProperty.code = "67"; properties.maggiorazioneCasoMortePerIncidenteStradaleProperty.value = vm.ND;
        properties.maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty.value = vm.ND;
      } else if (isChangedMaggiorazioneCasoMortePerIncidenteStradale) {
        selectChoices.maggiorazioneCasoMortePerIncidenteStradale.code = ""; selectChoices.maggiorazioneCasoMortePerIncidenteStradale.description = "";
        properties.maggiorazioneCasoMortePerIncidenteStradaleProperty.code = "67"; properties.maggiorazioneCasoMortePerIncidenteStradaleProperty.value = "";
        properties.maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty.value = "";
      }

      if (!isMaggiorazioneCasoMortePerMinusvalenza) {
        selectChoices.maggiorazioneCasoMortePerMinusvalenza.code = "69"; selectChoices.maggiorazioneCasoMortePerMinusvalenza.description = vm.ND;
        properties.maggiorazioneCasoMortePerMinusvalenzaProperty.code = "69"; properties.maggiorazioneCasoMortePerMinusvalenzaProperty.value = vm.ND;
        properties.maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty.value = vm.ND;
      } else if (isChangedMaggiorazioneCasoMortePerMinusvalenza) {
        selectChoices.maggiorazioneCasoMortePerMinusvalenza.code = ""; selectChoices.maggiorazioneCasoMortePerMinusvalenza.description = "";
        properties.maggiorazioneCasoMortePerMinusvalenzaProperty.code = "69"; properties.maggiorazioneCasoMortePerMinusvalenzaProperty.value = "";
        properties.maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty.value = "";
      }

      if (!isTCMStandAlone) {
        selectChoices.TCMStandAlone.code = "71"; selectChoices.TCMStandAlone.description = vm.ND;
        properties.TCMStandAloneProperty.code = "71"; properties.TCMStandAloneProperty.value = vm.ND;
        properties.TCMStandAlonePrestazioneProperty.value = vm.ND;
      } else if (isChangedTCMStandAlone) {
        selectChoices.TCMStandAlone.code = ""; selectChoices.TCMStandAlone.description = "";
        properties.TCMStandAloneProperty.code = "71"; properties.TCMStandAloneProperty.value = "";
        properties.TCMStandAlonePrestazioneProperty.value = "";
      }
      
      if (!isLongTermCare) {
        selectChoices.longTermCare.code = "73"; selectChoices.longTermCare.description = vm.ND;
        properties.longTermCareProperty.code = "73"; properties.longTermCareProperty.value = vm.ND;
        properties.longTermCarePrestazioneProperty.value = vm.ND;
      } else if (isChangedLongTermCare) {
        selectChoices.longTermCare.code = ""; selectChoices.longTermCare.description = "";
        properties.longTermCareProperty.code = "73"; properties.longTermCareProperty.value = "";
        properties.longTermCarePrestazioneProperty.value = "";
      }

      if (!isDreadDisease) {
        selectChoices.dreadDisease.code = "75"; selectChoices.dreadDisease.description = vm.ND;
        properties.dreadDiseaseProperty.code = "75"; properties.dreadDiseaseProperty.value = vm.ND;
        properties.dreadDiseasePrestazioneProperty.value = vm.ND;
      } else if (isChangedDreadDisease) {
        selectChoices.dreadDisease.code = ""; selectChoices.dreadDisease.description = "";
        properties.dreadDiseaseProperty.code = "75"; properties.dreadDiseaseProperty.value = "";
        properties.dreadDiseasePrestazioneProperty.value = "";
      }

      if (!isInvaliditaInabilita) {
        selectChoices.invaliditaInabilita.code = "77"; selectChoices.invaliditaInabilita.description = vm.ND;
        properties.invaliditaInabilitaProperty.code = "77"; properties.invaliditaInabilitaProperty.value = vm.ND;
        properties.invaliditaInabilitaPrestazioneProperty.value = vm.ND;
      } else if (isChangedInvaliditaInabilita) {
        selectChoices.invaliditaInabilita.code = ""; selectChoices.invaliditaInabilita.description = "";
        properties.invaliditaInabilitaProperty.code = "77"; properties.invaliditaInabilitaProperty.value = "";
        properties.invaliditaInabilitaPrestazioneProperty.value = "";
      }

      if (!isAltreGaranzieAssicurative) {
        properties.altreGaranzieAssicurativeProperty.value = vm.ND;
      } else if (isChangedAltreGaranzieAssicurative) {
        properties.altreGaranzieAssicurativeProperty.value = "";
      }
    },
    isTipologiaBonusIngressoPercentualeFissa() {
      let isPercentualeFissa = false;
      if (selectChoices.tipologiaBonusIngresso.code == "81.1") {
        isPercentualeFissa = true;
      }
      return isPercentualeFissa;
    },
    isTipologiaBonusIngressoFasceCumuloPremiVersati() {
      let isFasceCumuloPremiVersati = false;
      if (selectChoices.tipologiaBonusIngresso.code == "81.2") {
        isFasceCumuloPremiVersati = true;
      }
      return isFasceCumuloPremiVersati;
    },
    isTipologiaBonusIngressoFasceScaglioniCumuloPremiVersati() {
      let isFasceScaglioniCumuloPremiVersati = false;
      if (selectChoices.tipologiaBonusIngresso.code == "81.3") {
        isFasceScaglioniCumuloPremiVersati = true;
      }
      return isFasceScaglioniCumuloPremiVersati;
    },
    isTipologiaBonusIngressoFascePremiVersatiAnnui() {
      let isFascePremiVersatiAnnui = false;
      if (selectChoices.tipologiaBonusIngresso.code == "81.4") {
        isFascePremiVersatiAnnui = true;
      }
      return isFascePremiVersatiAnnui;
    },
    isTipologiaBonusIngressoFascePatrimonioPotenziale() {
      let isFascePatrimonioPotenziale = false;
      if (selectChoices.tipologiaBonusIngresso.code == "81.5") {
        isFascePatrimonioPotenziale = true;
      }
      return isFascePatrimonioPotenziale;
    },
    isTipologiaBonusIngressoAltro() {
      let isAltro = false;
      if (selectChoices.tipologiaBonusIngresso.code == "81.6") {
        isAltro = true;
      }
      return isAltro;
    },
    isTipologiaBonusIngressoNonRiconosciuto() {
      let isNonRiconosciuto = false;
      if (selectChoices.tipologiaBonusIngresso.code == "81.7") {
        isNonRiconosciuto = true;
      }
      return isNonRiconosciuto;
    },
    changeTipologiaBonusIngresso() {
      const vm = this as any;

      properties.bonusIngressoProperty.value = "";
      properties.bonusIngressoProperty.valueSign = "";
      properties.bonusIngressoProperty.rangeValuesFlex = [];

      if (vm.isTipologiaBonusIngressoPercentualeFissa()) {
        properties.bonusIngressoProperty.valueSign = "%";
      }

      if (vm.isTipologiaBonusIngressoFasceCumuloPremiVersati() ||
          vm.isTipologiaBonusIngressoFasceScaglioniCumuloPremiVersati() ||
          vm.isTipologiaBonusIngressoFascePremiVersatiAnnui() ||
          vm.isTipologiaBonusIngressoFascePatrimonioPotenziale()) {
        properties.bonusIngressoProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
      }

      if (vm.isTipologiaBonusIngressoNonRiconosciuto()) {
        properties.bonusIngressoProperty.value = "Non riconosciuto";
      }
    },
    isTipologiaBonusFedeltaPercentualeCapitale() {
      let isPercentualeCapitale = false;
      if (selectChoices.tipologiaBonusFedelta.code == "83.1") {
        isPercentualeCapitale = true;
      }
      return isPercentualeCapitale;
    },
    isTipologiaBonusFedeltaPercentualePremiVersati() {
      let isPercentualePremiVersati = false;
      if (selectChoices.tipologiaBonusFedelta.code == "83.2") {
        isPercentualePremiVersati = true;
      }
      return isPercentualePremiVersati;
    },
    isTipologiaBonusFedeltaPercentualePremioRicorrente() {
      let isPercentualePremioRicorrente = false;
      if (selectChoices.tipologiaBonusFedelta.code == "83.3") {
        isPercentualePremioRicorrente = true;
      }
      return isPercentualePremioRicorrente;
    },
    isTipologiaBonusFedeltaAltro() {
      let isAltro = false;
      if (selectChoices.tipologiaBonusFedelta.code == "83.4") {
        isAltro = true;
      }
      return isAltro;
    },
    isTipologiaBonusFedeltaNonRiconosciuto() {
      let isNonRiconosciuto = false;
      if (selectChoices.tipologiaBonusFedelta.code == "83.5") {
        isNonRiconosciuto = true;
      }
      return isNonRiconosciuto;
    },
    changeTipologiaBonusFedelta() {
      const vm = this as any;

      properties.bonusFedeltaProperty.value = "";
      properties.bonusFedeltaProperty.rangeValuesFlex = [];

      if (vm.isTipologiaBonusFedeltaPercentualeCapitale() ||
          vm.isTipologiaBonusFedeltaPercentualePremiVersati() ||
          vm.isTipologiaBonusFedeltaPercentualePremioRicorrente()) {
        properties.bonusFedeltaProperty.rangeValuesFlex = vm.createNewRangeValuesFlexAnnoPerc();
      }

      if (vm.isTipologiaBonusFedeltaNonRiconosciuto()) {
        properties.bonusFedeltaProperty.value = "Non riconosciuto";
      }
    },
    isTipologiaCaricamentoPICPercentualeFissa() {
      let isPercentualeFissa = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.1") {
        isPercentualeFissa = true;
      }
      return isPercentualeFissa;
    },
    isTipologiaCaricamentoPICFasceCumuloPremiVersati() {
      let isFasceCumuloPremiVersati = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.2") {
        isFasceCumuloPremiVersati = true;
      }
      return isFasceCumuloPremiVersati;
    },
    isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersati() {
      let isFasceScaglioniCumuloPremiVersati = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.3") {
        isFasceScaglioniCumuloPremiVersati = true;
      }
      return isFasceScaglioniCumuloPremiVersati;
    },
    isTipologiaCaricamentoPICFascePremiVersatiAnnui() {
      let isFascePremiVersatiAnnui = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.4") {
        isFascePremiVersatiAnnui = true;
      }
      return isFascePremiVersatiAnnui;
    },
    isTipologiaCaricamentoPICPercentualeFunzioneDelTempo() {
      let isPercentualeFunzioneDelTempo = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.5") {
        isPercentualeFunzioneDelTempo = true;
      }
      return isPercentualeFunzioneDelTempo;
    },
    isTipologiaCaricamentoPICFasceCumuloPremiVersatiFunzioneDelTempo() {
      let isFasceCumuloPremiVersatiFunzioneDelTempo = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.6") {
        isFasceCumuloPremiVersatiFunzioneDelTempo = true;
      }
      return isFasceCumuloPremiVersatiFunzioneDelTempo;
    },
    isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersatiFunzioneDelTempo() {
      let isFasceScaglioniCumuloPremiVersatiFunzioneDelTempo = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.7") {
        isFasceScaglioniCumuloPremiVersatiFunzioneDelTempo = true;
      }
      return isFasceScaglioniCumuloPremiVersatiFunzioneDelTempo;
    },
    isTipologiaCaricamentoPICFascePremiVersatiAnnuiFunzioneDelTempo() {
      let isFascePremiVersatiAnnuiFunzioneDelTempo = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.8") {
        isFascePremiVersatiAnnuiFunzioneDelTempo = true;
      }
      return isFascePremiVersatiAnnuiFunzioneDelTempo;
    },
    isTipologiaCaricamentoPICFascePatrimonioPotenziale() {
      let isFascePatrimonioPotenziale = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.9") {
        isFascePatrimonioPotenziale = true;
      }
      return isFascePatrimonioPotenziale;
    },
    isTipologiaCaricamentoPICFascePatrimonioPotenzialeEFasceCumuloPremiVersati() {
      let isFascePatrimonioPotenzialeEFasceCumuloPremiVersati = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.10") {
        isFascePatrimonioPotenzialeEFasceCumuloPremiVersati = true;
      }
      return isFascePatrimonioPotenzialeEFasceCumuloPremiVersati;
    },
    isTipologiaCaricamentoPICFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti() {
      let isFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.11") {
        isFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti = true;
      }
      return isFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti;
    },
    isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataContrattuale() {
      let isPercentualeFunzioneDellaDurataContrattuale = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.12") {
        isPercentualeFunzioneDellaDurataContrattuale = true;
      }
      return isPercentualeFunzioneDellaDurataContrattuale;
    },
    isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataPianoPagamentoPremi() {
      let isPercentualeFunzioneDellaDurataPianoPagamentoPremi = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.13") {
        isPercentualeFunzioneDellaDurataPianoPagamentoPremi = true;
      }
      return isPercentualeFunzioneDellaDurataPianoPagamentoPremi;
    },
    isTipologiaCaricamentoPICFasceImportoTotalePianoPagamentoPremi() {
      let isFasceImportoTotalePianoPagamentoPremi = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.14") {
        isFasceImportoTotalePianoPagamentoPremi = true;
      }
      return isFasceImportoTotalePianoPagamentoPremi;
    },
    isTipologiaCaricamentoPICAltro() {
      let isAltro = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.15") {
        isAltro = true;
      }
      return isAltro;
    },
    isTipologiaCaricamentoPICNonApplicato() {
      let isNonApplicato = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86.16") {
        isNonApplicato = true;
      }
      return isNonApplicato;
    },
    isTipologiaCaricamentoPICND() {
      const vm = this as any;

      let isND = false;
      if (selectChoices.tipologiaCaricamentoPIC.code == "86" &&
          selectChoices.tipologiaCaricamentoPIC.description == vm.ND) {
        isND = true;
      }
      return isND;
    },
    initTipologiaCaricamentoPIC() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precTipologiaCaricamentoPIC === undefined) {
        vm.precTipologiaCaricamentoPIC = selectChoices.tipologiaCaricamentoPIC.code;
      }
    },
    changeTipologiaCaricamentoPIC() {
      const vm = this as any;

      const isTipologiaCaricamentoPICND = vm.isTipologiaCaricamentoPICND();
      const isTipologiaCaricamentoPICPercentualeFissa = vm.isTipologiaCaricamentoPICPercentualeFissa();
      const isTipologiaCaricamentoPICFasceCumuloPremiVersati = vm.isTipologiaCaricamentoPICFasceCumuloPremiVersati();
      const isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersati = vm.isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersati();
      const isTipologiaCaricamentoPICFascePremiVersatiAnnui = vm.isTipologiaCaricamentoPICFascePremiVersatiAnnui();
      const isTipologiaCaricamentoPICPercentualeFunzioneDelTempo = vm.isTipologiaCaricamentoPICPercentualeFunzioneDelTempo();
      const isTipologiaCaricamentoPICFasceCumuloPremiVersatiFunzioneDelTempo = vm.isTipologiaCaricamentoPICFasceCumuloPremiVersatiFunzioneDelTempo();
      const isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersatiFunzioneDelTempo = vm.isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersatiFunzioneDelTempo();
      const isTipologiaCaricamentoPICFascePremiVersatiAnnuiFunzioneDelTempo = vm.isTipologiaCaricamentoPICFascePremiVersatiAnnuiFunzioneDelTempo();
      const isTipologiaCaricamentoPICFascePatrimonioPotenziale = vm.isTipologiaCaricamentoPICFascePatrimonioPotenziale();
      const isTipologiaCaricamentoPICFascePatrimonioPotenzialeEFasceCumuloPremiVersati = vm.isTipologiaCaricamentoPICFascePatrimonioPotenzialeEFasceCumuloPremiVersati();
      const isTipologiaCaricamentoPICFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti = vm.isTipologiaCaricamentoPICFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti();
      const isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataContrattuale = vm.isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataContrattuale();
      const isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataPianoPagamentoPremi = vm.isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataPianoPagamentoPremi();
      const isTipologiaCaricamentoPICFasceImportoTotalePianoPagamentoPremi = vm.isTipologiaCaricamentoPICFasceImportoTotalePianoPagamentoPremi();
      const isTipologiaCaricamentoPICAltro = vm.isTipologiaCaricamentoPICAltro();
      const isTipologiaCaricamentoPICNonApplicato = vm.isTipologiaCaricamentoPICNonApplicato();

      const isChangedTipologiaCaricamentoPIC = vm.precTipologiaCaricamentoPIC != selectChoices.tipologiaCaricamentoPIC.code;

      vm.precTipologiaCaricamentoPIC = selectChoices.tipologiaCaricamentoPIC.code;

      if (isChangedTipologiaCaricamentoPIC) {
        properties.caricamentoPICProperty.value = "";
        properties.caricamentoPICProperty.valueSign = "";
        properties.caricamentoPICProperty.rangeValuesFlex = [];

        if (isTipologiaCaricamentoPICND) {
          properties.caricamentoPICProperty.value = vm.ND;
        } else if (isTipologiaCaricamentoPICPercentualeFissa) {
          properties.caricamentoPICProperty.valueSign = "%";
        } else if (isTipologiaCaricamentoPICFasceCumuloPremiVersati ||
          isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersati ||
          isTipologiaCaricamentoPICFascePremiVersatiAnnui ||
          isTipologiaCaricamentoPICFascePatrimonioPotenziale ||
          isTipologiaCaricamentoPICFasceImportoTotalePianoPagamentoPremi) {
          properties.caricamentoPICProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        } else if (isTipologiaCaricamentoPICPercentualeFunzioneDelTempo) {
          properties.caricamentoPICProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        } else if (isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataContrattuale ||
          isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataPianoPagamentoPremi) {
          properties.caricamentoPICProperty.rangeValuesFlex = vm.createNewRangeValuesFlexAnniPerc();
        } else if (isTipologiaCaricamentoPICFasceCumuloPremiVersatiFunzioneDelTempo ||
          isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersatiFunzioneDelTempo) {
          properties.caricamentoPICProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloPremi();
        } else if (isTipologiaCaricamentoPICFascePremiVersatiAnnuiFunzioneDelTempo) {
          properties.caricamentoPICProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        } else if (isTipologiaCaricamentoPICFascePatrimonioPotenzialeEFasceCumuloPremiVersati) {
          properties.caricamentoPICProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexPatrimonioPotenzialeCumuloPremi();
        } else if (isTipologiaCaricamentoPICFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti) {
          properties.caricamentoPICProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexPatrimonioPotenzialeVersamentiFuturiPrevisti();
        } else if (isTipologiaCaricamentoPICNonApplicato) {
          properties.caricamentoPICProperty.value = "Non applicato";
        }
      }

      if (vm.isRetrocessioneCaricamentoND()) {
        properties.retrocessioneCaricamentoProperty.value = vm.ND;
        properties.retrocessioneCaricamentoProperty.stringList = [];
      } else if (properties.retrocessioneCaricamentoProperty.value == vm.ND) {
        properties.retrocessioneCaricamentoProperty.value = "";
        properties.retrocessioneCaricamentoProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      }
    },
    isTipologiaCaricamentoPACPercentualeFissa() {
      let isPercentualeFissa = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.1") {
        isPercentualeFissa = true;
      }
      return isPercentualeFissa;
    },
    isTipologiaCaricamentoPACFasceCumuloPremiVersati() {
      let isFasceCumuloPremiVersati = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.2") {
        isFasceCumuloPremiVersati = true;
      }
      return isFasceCumuloPremiVersati;
    },
    isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersati() {
      let isFasceScaglioniCumuloPremiVersati = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.3") {
        isFasceScaglioniCumuloPremiVersati = true;
      }
      return isFasceScaglioniCumuloPremiVersati;
    },
    isTipologiaCaricamentoPACFascePremiVersatiAnnui() {
      let isFascePremiVersatiAnnui = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.4") {
        isFascePremiVersatiAnnui = true;
      }
      return isFascePremiVersatiAnnui;
    },
    isTipologiaCaricamentoPACPercentualeFunzioneDelTempo() {
      let isPercentualeFunzioneDelTempo = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.5") {
        isPercentualeFunzioneDelTempo = true;
      }
      return isPercentualeFunzioneDelTempo;
    },
    isTipologiaCaricamentoPACFasceCumuloPremiVersatiFunzioneDelTempo() {
      let isFasceCumuloPremiVersatiFunzioneDelTempo = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.6") {
        isFasceCumuloPremiVersatiFunzioneDelTempo = true;
      }
      return isFasceCumuloPremiVersatiFunzioneDelTempo;
    },
    isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersatiFunzioneDelTempo() {
      let isFasceScaglioniCumuloPremiVersatiFunzioneDelTempo = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.7") {
        isFasceScaglioniCumuloPremiVersatiFunzioneDelTempo = true;
      }
      return isFasceScaglioniCumuloPremiVersatiFunzioneDelTempo;
    },
    isTipologiaCaricamentoPACFascePremiVersatiAnnuiFunzioneDelTempo() {
      let isFascePremiVersatiAnnuiFunzioneDelTempo = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.8") {
        isFascePremiVersatiAnnuiFunzioneDelTempo = true;
      }
      return isFascePremiVersatiAnnuiFunzioneDelTempo;
    },
    isTipologiaCaricamentoPACFascePatrimonioPotenziale() {
      let isFascePatrimonioPotenziale = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.9") {
        isFascePatrimonioPotenziale = true;
      }
      return isFascePatrimonioPotenziale;
    },
    isTipologiaCaricamentoPACFascePatrimonioPotenzialeEFasceCumuloPremiVersati() {
      let isFascePatrimonioPotenzialeEFasceCumuloPremiVersati = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.10") {
        isFascePatrimonioPotenzialeEFasceCumuloPremiVersati = true;
      }
      return isFascePatrimonioPotenzialeEFasceCumuloPremiVersati;
    },
    isTipologiaCaricamentoPACFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti() {
      let isFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.11") {
        isFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti = true;
      }
      return isFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti;
    },
    isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataContrattuale() {
      let isPercentualeFunzioneDellaDurataContrattuale = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.12") {
        isPercentualeFunzioneDellaDurataContrattuale = true;
      }
      return isPercentualeFunzioneDellaDurataContrattuale;
    },
    isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataPianoPagamentoPremi() {
      let isPercentualeFunzioneDellaDurataPianoPagamentoPremi = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.13") {
        isPercentualeFunzioneDellaDurataPianoPagamentoPremi = true;
      }
      return isPercentualeFunzioneDellaDurataPianoPagamentoPremi;
    },
    isTipologiaCaricamentoPACFasceImportoTotalePianoPagamentoPremi() {
      let isFasceImportoTotalePianoPagamentoPremi = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.14") {
        isFasceImportoTotalePianoPagamentoPremi = true;
      }
      return isFasceImportoTotalePianoPagamentoPremi;
    },
    isTipologiaCaricamentoPACAltro() {
      let isAltro = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.15") {
        isAltro = true;
      }
      return isAltro;
    },
    isTipologiaCaricamentoPACNonApplicato() {
      let isNonApplicato = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88.16") {
        isNonApplicato = true;
      }
      return isNonApplicato;
    },
    isTipologiaCaricamentoPACND() {
      const vm = this as any;

      let isND = false;
      if (selectChoices.tipologiaCaricamentoPAC.code == "88" &&
          selectChoices.tipologiaCaricamentoPAC.description == vm.ND) {
        isND = true;
      }
      return isND;
    },
    initTipologiaCaricamentoPAC() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precTipologiaCaricamentoPAC === undefined) {
        vm.precTipologiaCaricamentoPAC = selectChoices.tipologiaCaricamentoPAC.code;
      }      
    },
    changeTipologiaCaricamentoPAC() {
      const vm = this as any;

      const isTipologiaCaricamentoPACND = vm.isTipologiaCaricamentoPACND();
      const isTipologiaCaricamentoPACPercentualeFissa = vm.isTipologiaCaricamentoPACPercentualeFissa();
      const isTipologiaCaricamentoPACFasceCumuloPremiVersati = vm.isTipologiaCaricamentoPACFasceCumuloPremiVersati();
      const isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersati = vm.isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersati();
      const isTipologiaCaricamentoPACFascePremiVersatiAnnui = vm.isTipologiaCaricamentoPACFascePremiVersatiAnnui();
      const isTipologiaCaricamentoPACPercentualeFunzioneDelTempo = vm.isTipologiaCaricamentoPACPercentualeFunzioneDelTempo();
      const isTipologiaCaricamentoPACFasceCumuloPremiVersatiFunzioneDelTempo = vm.isTipologiaCaricamentoPACFasceCumuloPremiVersatiFunzioneDelTempo();
      const isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersatiFunzioneDelTempo = vm.isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersatiFunzioneDelTempo();
      const isTipologiaCaricamentoPACFascePremiVersatiAnnuiFunzioneDelTempo = vm.isTipologiaCaricamentoPACFascePremiVersatiAnnuiFunzioneDelTempo();
      const isTipologiaCaricamentoPACFascePatrimonioPotenziale = vm.isTipologiaCaricamentoPACFascePatrimonioPotenziale();
      const isTipologiaCaricamentoPACFascePatrimonioPotenzialeEFasceCumuloPremiVersati = vm.isTipologiaCaricamentoPACFascePatrimonioPotenzialeEFasceCumuloPremiVersati();
      const isTipologiaCaricamentoPACFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti = vm.isTipologiaCaricamentoPACFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti();
      const isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataContrattuale = vm.isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataContrattuale();
      const isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataPianoPagamentoPremi = vm.isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataPianoPagamentoPremi();
      const isTipologiaCaricamentoPACFasceImportoTotalePianoPagamentoPremi = vm.isTipologiaCaricamentoPACFasceImportoTotalePianoPagamentoPremi();
      const isTipologiaCaricamentoPACAltro = vm.isTipologiaCaricamentoPACAltro();
      const isTipologiaCaricamentoPACNonApplicato = vm.isTipologiaCaricamentoPACNonApplicato();

      const isChangedTipologiaCaricamentoPAC = vm.precTipologiaCaricamentoPAC != selectChoices.tipologiaCaricamentoPAC.code;

      vm.precTipologiaCaricamentoPAC = selectChoices.tipologiaCaricamentoPAC.code;

      if (isChangedTipologiaCaricamentoPAC) {
        properties.caricamentoPACProperty.value = "";
        properties.caricamentoPACProperty.valueSign = "";
        properties.caricamentoPACProperty.rangeValuesFlex = [];

        if (isTipologiaCaricamentoPACND) {
          properties.caricamentoPACProperty.value = vm.ND;
        } else if (isTipologiaCaricamentoPACPercentualeFissa) {
          properties.caricamentoPACProperty.valueSign = "%";
        } else if (isTipologiaCaricamentoPACFasceCumuloPremiVersati ||
          isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersati ||
          isTipologiaCaricamentoPACFascePremiVersatiAnnui ||
          isTipologiaCaricamentoPACFascePatrimonioPotenziale ||
          isTipologiaCaricamentoPACFasceImportoTotalePianoPagamentoPremi) {
          properties.caricamentoPACProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        } else if (isTipologiaCaricamentoPACPercentualeFunzioneDelTempo) {
          properties.caricamentoPACProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        } else if (isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataContrattuale ||
          isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataPianoPagamentoPremi) {
          properties.caricamentoPACProperty.rangeValuesFlex = vm.createNewRangeValuesFlexAnniPerc();
        } else if (isTipologiaCaricamentoPACFasceCumuloPremiVersatiFunzioneDelTempo ||
          isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersatiFunzioneDelTempo) {
          properties.caricamentoPACProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloPremi();
        } else if (isTipologiaCaricamentoPACFascePremiVersatiAnnuiFunzioneDelTempo) {
          properties.caricamentoPACProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        } else if (isTipologiaCaricamentoPACFascePatrimonioPotenzialeEFasceCumuloPremiVersati) {
          properties.caricamentoPACProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexPatrimonioPotenzialeCumuloPremi();
        } else if (isTipologiaCaricamentoPACFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti) {
          properties.caricamentoPACProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexPatrimonioPotenzialeVersamentiFuturiPrevisti();
        } else if (isTipologiaCaricamentoPACNonApplicato) {
          properties.caricamentoPACProperty.value = "Non applicato";
        }
      }

      if (vm.isRetrocessioneCaricamentoND()) {
        properties.retrocessioneCaricamentoProperty.value = vm.ND;
        properties.retrocessioneCaricamentoProperty.stringList = [];
      } else if (properties.retrocessioneCaricamentoProperty.value == vm.ND) {
        properties.retrocessioneCaricamentoProperty.value = "";
        properties.retrocessioneCaricamentoProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      }
    },
    isProdCommercio() {
      const vm = this as any;
      if (selectChoices.prodCommercio.code == '8.1') {
        return true;
      } else if (selectChoices.prodCommercio.code == '8.2') {
        return false;
      }
      return undefined;
    },
    initProdCommercio() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precFlagProdCommercio === undefined) {
        vm.precFlagProdCommercio = vm.isProdCommercio();
      }
    },
    changeProdCommercio() {
      const vm = this as any;

      const isChangedProdCommercio = vm.precFlagProdCommercio != vm.isProdCommercio();

      vm.precFlagProdCommercio = vm.isProdCommercio();

      if (isChangedProdCommercio) {
        if (vm.isProdCommercio()) {
          properties.fineCommProperty.value = vm.ND;
          properties.fineCommProperty.dateValue = null;
        } else {
          properties.fineCommProperty.value = "";
          properties.fineCommProperty.dateValue = null;
        }
      }
    },
    isTipologiaPremioPIC() {
      let isPIC = false;
      if (selectChoices.tipologiaPremio.code == "11.1") {
        isPIC = true;
      }
      return isPIC;
    },
    isTipologiaPremioPAC() {
      let isPAC = false;
      if (selectChoices.tipologiaPremio.code == "11.2") {
        isPAC = true;
      }
      return isPAC;
    },
    isTipologiaPremioPICePAC() {
      let isPICePAC = false;
      if (selectChoices.tipologiaPremio.code == "11.3") {
        isPICePAC = true;
      }
      return isPICePAC;
    },
    isTipologiaPremioPICoPAC() {
      let isPICoPAC = false;
      if (selectChoices.tipologiaPremio.code == "11.4") {
        isPICoPAC = true;
      }
      return isPICoPAC;
    },
    isTipologiaPremioPICeventualePAC() {
      let isPICeventualePAC = false;
      if (selectChoices.tipologiaPremio.code == "11.5") {
        isPICeventualePAC = true;
      }
      return isPICeventualePAC;
    },
    isTipologiaPremioPACeventualePIC() {
      let isPACeventualePIC = false;
      if (selectChoices.tipologiaPremio.code == "11.6") {
        isPACeventualePIC = true;
      }
      return isPACeventualePIC;
    },    
    initTipologiaPremio() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precFlagTipologiaPremio.PIC === undefined) {
        vm.precFlagTipologiaPremio.PIC = vm.isTipologiaPremioPIC();
      }
      if (vm.precFlagTipologiaPremio.PAC === undefined) {
        vm.precFlagTipologiaPremio.PAC = vm.isTipologiaPremioPAC();
      }
      if (vm.precFlagTipologiaPremio.PICePAC === undefined) {
        vm.precFlagTipologiaPremio.PICePAC = vm.isTipologiaPremioPICePAC();
      }
      if (vm.precFlagTipologiaPremio.PICoPAC === undefined) {
        vm.precFlagTipologiaPremio.PICoPAC = vm.isTipologiaPremioPICoPAC();
      }
      if (vm.precFlagTipologiaPremio.PICeventualePAC === undefined) {
        vm.precFlagTipologiaPremio.PICeventualePAC = vm.isTipologiaPremioPICeventualePAC();
      }
      if (vm.precFlagTipologiaPremio.PACeventualePIC === undefined) {
        vm.precFlagTipologiaPremio.PACeventualePIC = vm.isTipologiaPremioPACeventualePIC();
      }
    },
    changeTipologiaPremio() {
      const vm = this as any;

      const isPIC = vm.isTipologiaPremioPIC();
      const isPAC = vm.isTipologiaPremioPAC();
      const isPICePAC = vm.isTipologiaPremioPICePAC();
      const isPICoPAC = vm.isTipologiaPremioPICoPAC();
      const isPICeventualePAC = vm.isTipologiaPremioPICeventualePAC();
      const isPACeventualePIC = vm.isTipologiaPremioPACeventualePIC();

      const isChangedPIC = vm.precFlagTipologiaPremio.PIC != isPIC;
      const isChangedPAC = vm.precFlagTipologiaPremio.PAC != isPAC;
      const isChangedPICePAC = vm.precFlagTipologiaPremio.PICePAC != isPICePAC;
      const isChangedPICoPAC = vm.precFlagTipologiaPremio.PICoPAC != isPICoPAC;
      const isChangedPICeventualePAC = vm.precFlagTipologiaPremio.PICeventualePAC != isPICeventualePAC;
      const isChangedPACeventualePIC = vm.precFlagTipologiaPremio.PACeventualePIC != isPACeventualePIC;

      vm.precFlagTipologiaPremio.PIC = isPIC;
      vm.precFlagTipologiaPremio.PAC = isPAC;
      vm.precFlagTipologiaPremio.PICePAC = isPICePAC;
      vm.precFlagTipologiaPremio.PICoPAC = isPICoPAC;
      vm.precFlagTipologiaPremio.PICeventualePAC = isPICeventualePAC;
      vm.precFlagTipologiaPremio.PACeventualePIC = isPACeventualePIC;

      if (isChangedPIC ||
          isChangedPAC ||
          isChangedPICePAC ||
          isChangedPICoPAC ||
          isChangedPICeventualePAC ||
          isChangedPACeventualePIC) {
        properties.durataPianoPagamentoPremiProperty.value = "";
        properties.importoMinPremioUnicoProperty.value = ""; properties.importoMinPremioUnicoProperty.valueSign = "€";
        properties.importoMaxPremioUnicoProperty.value = ""; properties.importoMaxPremioUnicoProperty.valueSign = "€";
        properties.importoMinPremioRicAnnuoProperty.value = ""; properties.importoMinPremioRicAnnuoProperty.valueSign = "€";
        properties.importoMaxPremioRicAnnuoProperty.value = ""; properties.importoMaxPremioRicAnnuoProperty.valueSign = "€";

        properties.caricamentoPICProperty.value = "";
        properties.caricamentoPICProperty.valueSign = "";
        properties.caricamentoPICProperty.rangeValuesFlex = [];

        properties.caricamentoPACProperty.value = "";
        properties.caricamentoPACProperty.valueSign = "";
        properties.caricamentoPACProperty.rangeValuesFlex = [];
      }

      if (vm.isTipologiaPremioPIC()) {
        properties.durataPianoPagamentoPremiProperty.value = vm.ND;
        properties.importoMinPremioRicAnnuoProperty.value = vm.ND; properties.importoMinPremioRicAnnuoProperty.valueSign = "";
        properties.importoMaxPremioRicAnnuoProperty.value = vm.ND; properties.importoMaxPremioRicAnnuoProperty.valueSign = "";
        selectChoices.tipologiaCaricamentoPAC.code = "88"; selectChoices.tipologiaCaricamentoPAC.description = vm.ND;
        properties.tipologiaCaricamentoPACProperty.code = "88"; properties.tipologiaCaricamentoPACProperty.value = vm.ND;
        properties.caricamentoPACProperty.value = vm.ND;
      } else if (vm.isTipologiaPremioPAC()) {
        properties.importoMinPremioUnicoProperty.value = vm.ND; properties.importoMinPremioUnicoProperty.valueSign = "";
        properties.importoMaxPremioUnicoProperty.value = vm.ND; properties.importoMaxPremioUnicoProperty.valueSign = "";
        selectChoices.tipologiaCaricamentoPIC.code = "86"; selectChoices.tipologiaCaricamentoPIC.description = vm.ND;        
        properties.tipologiaCaricamentoPICProperty.code = "86"; properties.tipologiaCaricamentoPICProperty.value = vm.ND;
        properties.caricamentoPICProperty.value = vm.ND;
      }
    },
    changeTipologiaCommissioneGestioneSeparata() {
      const vm = this as any;

      const isTipologiaCommGSPercentualeFissa = vm.isTipologiaCommGSPercentualeFissa();
      const isTipologiaCommGSFasceCumuloCapitale = vm.isTipologiaCommGSFasceCumuloCapitale();
      const isTipologiaCommGSFasceScaglioniCumuloCapitale = vm.isTipologiaCommGSFasceScaglioniCumuloCapitale();
      const isTipologiaCommGSFascePremiVersatiAnnui = vm.isTipologiaCommGSFascePremiVersatiAnnui();
      const isTipologiaCommGSPercentualeFunzioneDelTempo = vm.isTipologiaCommGSPercentualeFunzioneDelTempo();
      const isTipologiaCommGSFasceCumuloCapitaleFunzioneDelTempo = vm.isTipologiaCommGSFasceCumuloCapitaleFunzioneDelTempo();
      const isTipologiaCommGSFasceScaglioniCumuloCapitaleFunzioneDelTempo = vm.isTipologiaCommGSFasceScaglioniCumuloCapitaleFunzioneDelTempo();
      const isTipologiaCommGSFascePremiVersatiAnnuiFunzioneDelTempo = vm.isTipologiaCommGSFascePremiVersatiAnnuiFunzioneDelTempo();
      const isTipologiaCommGSPercentualeDelRendimentoGS = vm.isTipologiaCommGSPercentualeDelRendimentoGS();
      const isTipologiaCommGSPercentualeFunzioneDelRendimentoGS = vm.isTipologiaCommGSPercentualeFunzioneDelRendimentoGS();
      const isTipologiaCommGSAltro = vm.isTipologiaCommGSAltro();

      properties.commissioneGestioneSeparataProperty.value = "";
      properties.commissioneGestioneSeparataProperty.valueSign = "";
      properties.commissioneGestioneSeparataProperty.stringList = [];
      properties.commissioneGestioneSeparataProperty.rangeValuesFlex = [];

      if (isTipologiaCommGSPercentualeFissa) {
        properties.commissioneGestioneSeparataProperty.valueSign = "%";
      } else if (isTipologiaCommGSFasceCumuloCapitale ||
        isTipologiaCommGSFasceScaglioniCumuloCapitale ||
        isTipologiaCommGSFascePremiVersatiAnnui) {
        properties.commissioneGestioneSeparataProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
      } else if (isTipologiaCommGSPercentualeFunzioneDelTempo) {
        properties.commissioneGestioneSeparataProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
      } else if (isTipologiaCommGSFasceCumuloCapitaleFunzioneDelTempo ||
        isTipologiaCommGSFasceScaglioniCumuloCapitaleFunzioneDelTempo) {
        properties.commissioneGestioneSeparataProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
      } else if (isTipologiaCommGSFascePremiVersatiAnnuiFunzioneDelTempo) {
        properties.commissioneGestioneSeparataProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
      } else if (isTipologiaCommGSPercentualeDelRendimentoGS) {
        properties.commissioneGestioneSeparataProperty.stringList = [
          { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "", valueLabelReadonly: false, valueLabelFix: true},
          { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "Commissione Min.", valueLabelReadonly: false, valueLabelFix: true},
        ];
      } else if (isTipologiaCommGSPercentualeFunzioneDelRendimentoGS) {
        properties.commissioneGestioneSeparataProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromPercToPercPerc();
      }
    },
    isTipologiaCommGSPercentualeFissa() {
      let isPercentualeFissa = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.1") {
        isPercentualeFissa = true;
      }
      return isPercentualeFissa;
    },
    isTipologiaCommGSFasceCumuloCapitale() {
      let isFasceCumuloCapitale = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.2") {
        isFasceCumuloCapitale = true;
      }
      return isFasceCumuloCapitale;
    },
    isTipologiaCommGSFasceScaglioniCumuloCapitale() {
      let isFasceScaglioniCumuloCapitale = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.3") {
        isFasceScaglioniCumuloCapitale = true;
      }
      return isFasceScaglioniCumuloCapitale;
    },
    isTipologiaCommGSFascePremiVersatiAnnui() {
      let isFascePremiVersatiAnnui = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.4") {
        isFascePremiVersatiAnnui = true;
      }
      return isFascePremiVersatiAnnui;
    },
    isTipologiaCommGSPercentualeFunzioneDelTempo() {
      let isPercentualeFunzioneDelTempo = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.5") {
        isPercentualeFunzioneDelTempo = true;
      }
      return isPercentualeFunzioneDelTempo;
    },
    isTipologiaCommGSFasceCumuloCapitaleFunzioneDelTempo() {
      let isFasceCumuloCapitaleFunzioneDelTempo = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.6") {
        isFasceCumuloCapitaleFunzioneDelTempo = true;
      }
      return isFasceCumuloCapitaleFunzioneDelTempo;
    },
    isTipologiaCommGSFasceScaglioniCumuloCapitaleFunzioneDelTempo() {
      let isFasceScaglioniCumuloCapitaleFunzioneDelTempo = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.7") {
        isFasceScaglioniCumuloCapitaleFunzioneDelTempo = true;
      }
      return isFasceScaglioniCumuloCapitaleFunzioneDelTempo;
    },
    isTipologiaCommGSFascePremiVersatiAnnuiFunzioneDelTempo() {
      let isFascePremiVersatiAnnuiFunzioneDelTempo = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.8") {
        isFascePremiVersatiAnnuiFunzioneDelTempo = true;
      }
      return isFascePremiVersatiAnnuiFunzioneDelTempo;
    },
    isTipologiaCommGSPercentualeDelRendimentoGS() {
      let isPercentualeDelRendimentoGS = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.9") {
        isPercentualeDelRendimentoGS = true;
      }
      return isPercentualeDelRendimentoGS;
    },
    isTipologiaCommGSPercentualeFunzioneDelRendimentoGS() {
      let isPercentualeFunzioneDelRendimentoGS = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.10") {
        isPercentualeFunzioneDelRendimentoGS = true;
      }
      return isPercentualeFunzioneDelRendimentoGS;
    },
    isTipologiaCommGSAltro() {
      let isAltro = false;
      if (selectChoices.tipologiaCommissioneGestioneSeparata.code == "91.11") {
        isAltro = true;
      }
      return isAltro;
    },
    changeTipologiaCommissioneFondiInterni() {
      const vm = this as any;

      const isTipologiaCommFIPercentualeFissa = vm.isTipologiaCommFIPercentualeFissa();
      const isTipologiaCommFIFasceCumuloCapitale = vm.isTipologiaCommFIFasceCumuloCapitale();
      const isTipologiaCommFIFasceScaglioniCumuloCapitale = vm.isTipologiaCommFIFasceScaglioniCumuloCapitale();
      const isTipologiaCommFIFascePremiVersatiAnnui = vm.isTipologiaCommFIFascePremiVersatiAnnui();
      const isTipologiaCommFIPercentualeFunzioneDelTempo = vm.isTipologiaCommFIPercentualeFunzioneDelTempo();
      const isTipologiaCommFIFasceCumuloCapitaleFunzioneDelTempo = vm.isTipologiaCommFIFasceCumuloCapitaleFunzioneDelTempo();
      const isTipologiaCommFIFasceScaglioniCumuloCapitaleFunzioneDelTempo = vm.isTipologiaCommFIFasceScaglioniCumuloCapitaleFunzioneDelTempo();
      const isTipologiaCommFIFascePremiVersatiAnnuiFunzioneDelTempo = vm.isTipologiaCommFIFascePremiVersatiAnnuiFunzioneDelTempo();
      const isTipologiaCommFIAltro = vm.isTipologiaCommFIAltro();

      properties.commissioneFondiInterniAzionariProperty.value = "";
      properties.commissioneFondiInterniAzionariProperty.valueSign = "";
      properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = [];

      properties.commissioneFondiInterniObbligazionariProperty.value = "";
      properties.commissioneFondiInterniObbligazionariProperty.valueSign = "";
      properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = [];

      properties.commissioneFondiInterniBilanciatiProperty.value = "";
      properties.commissioneFondiInterniBilanciatiProperty.valueSign = "";
      properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = [];

      properties.commissioneFondiInterniFlessibiliProperty.value = "";
      properties.commissioneFondiInterniFlessibiliProperty.valueSign = "";
      properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = [];

      properties.commissioneFondiInterniMonetariProperty.value = "";
      properties.commissioneFondiInterniMonetariProperty.valueSign = "";
      properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = [];

      if (!vm.isTipologiaFondiInterniAzionari()) {
        properties.commissioneFondiInterniAzionariProperty.value = vm.ND;
      } else {
        if (isTipologiaCommFIPercentualeFissa) {
          properties.commissioneFondiInterniAzionariProperty.valueSign = "%";
        } else if (isTipologiaCommFIFasceCumuloCapitale ||
          isTipologiaCommFIFasceScaglioniCumuloCapitale ||
          isTipologiaCommFIFascePremiVersatiAnnui) {
          properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        } else if (isTipologiaCommFIPercentualeFunzioneDelTempo) {
          properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        } else if (isTipologiaCommFIFasceCumuloCapitaleFunzioneDelTempo ||
          isTipologiaCommFIFasceScaglioniCumuloCapitaleFunzioneDelTempo) {
          properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        } else if (isTipologiaCommFIFascePremiVersatiAnnuiFunzioneDelTempo) {
          properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        }
      }

      if (!vm.isTipologiaFondiInterniObbligazionari()) {
        properties.commissioneFondiInterniObbligazionariProperty.value = vm.ND;
      } else {
        if (isTipologiaCommFIPercentualeFissa) {
          properties.commissioneFondiInterniObbligazionariProperty.valueSign = "%";
        } else if (isTipologiaCommFIFasceCumuloCapitale ||
          isTipologiaCommFIFasceScaglioniCumuloCapitale ||
          isTipologiaCommFIFascePremiVersatiAnnui) {
          properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        } else if (isTipologiaCommFIPercentualeFunzioneDelTempo) {
          properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        } else if (isTipologiaCommFIFasceCumuloCapitaleFunzioneDelTempo ||
          isTipologiaCommFIFasceScaglioniCumuloCapitaleFunzioneDelTempo) {
          properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        } else if (isTipologiaCommFIFascePremiVersatiAnnuiFunzioneDelTempo) {
          properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        }
      }

      if (!vm.isTipologiaFondiInterniBilanciati()) {
        properties.commissioneFondiInterniBilanciatiProperty.value = vm.ND;
      } else {
        if (isTipologiaCommFIPercentualeFissa) {
          properties.commissioneFondiInterniBilanciatiProperty.valueSign = "%";
        } else if (isTipologiaCommFIFasceCumuloCapitale ||
          isTipologiaCommFIFasceScaglioniCumuloCapitale ||
          isTipologiaCommFIFascePremiVersatiAnnui) {
          properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        } else if (isTipologiaCommFIPercentualeFunzioneDelTempo) {
          properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        } else if (isTipologiaCommFIFasceCumuloCapitaleFunzioneDelTempo ||
          isTipologiaCommFIFasceScaglioniCumuloCapitaleFunzioneDelTempo) {
          properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        } else if (isTipologiaCommFIFascePremiVersatiAnnuiFunzioneDelTempo) {
          properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        }
      }

      if (!vm.isTipologiaFondiInterniFlessibili()) {
        properties.commissioneFondiInterniFlessibiliProperty.value = vm.ND;
      } else {
        if (isTipologiaCommFIPercentualeFissa) {
          properties.commissioneFondiInterniFlessibiliProperty.valueSign = "%";
        } else if (isTipologiaCommFIFasceCumuloCapitale ||
          isTipologiaCommFIFasceScaglioniCumuloCapitale ||
          isTipologiaCommFIFascePremiVersatiAnnui) {
          properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        } else if (isTipologiaCommFIPercentualeFunzioneDelTempo) {
          properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        } else if (isTipologiaCommFIFasceCumuloCapitaleFunzioneDelTempo ||
          isTipologiaCommFIFasceScaglioniCumuloCapitaleFunzioneDelTempo) {
          properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        } else if (isTipologiaCommFIFascePremiVersatiAnnuiFunzioneDelTempo) {
          properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        }
      }

      if (!vm.isTipologiaFondiInterniMonetari()) {
        properties.commissioneFondiInterniMonetariProperty.value = vm.ND;
      } else {
        if (isTipologiaCommFIPercentualeFissa) {
          properties.commissioneFondiInterniMonetariProperty.valueSign = "%";
        } else if (isTipologiaCommFIFasceCumuloCapitale ||
          isTipologiaCommFIFasceScaglioniCumuloCapitale ||
          isTipologiaCommFIFascePremiVersatiAnnui) {
          properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        } else if (isTipologiaCommFIPercentualeFunzioneDelTempo) {
          properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        } else if (isTipologiaCommFIFasceCumuloCapitaleFunzioneDelTempo ||
          isTipologiaCommFIFasceScaglioniCumuloCapitaleFunzioneDelTempo) {
          properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        } else if (isTipologiaCommFIFascePremiVersatiAnnuiFunzioneDelTempo) {
          properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        }
      }
    },
    isTipologiaCommFIEmpty() {
      let isEmpty = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93" ||
          selectChoices.tipologiaCommissioneFondiInterni.code == "") {
        isEmpty = true;
      }
      return isEmpty;
    },    
    isTipologiaCommFIPercentualeFissa() {
      let isPercentualeFissa = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.1") {
        isPercentualeFissa = true;
      }
      return isPercentualeFissa;
    },
    isTipologiaCommFIFasceCumuloCapitale() {
      let isFasceCumuloCapitale = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.2") {
        isFasceCumuloCapitale = true;
      }
      return isFasceCumuloCapitale;
    },
    isTipologiaCommFIFasceScaglioniCumuloCapitale() {
      let isFasceScaglioniCumuloCapitale = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.3") {
        isFasceScaglioniCumuloCapitale = true;
      }
      return isFasceScaglioniCumuloCapitale;
    },
    isTipologiaCommFIFascePremiVersatiAnnui() {
      let isFascePremiVersatiAnnui = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.4") {
        isFascePremiVersatiAnnui = true;
      }
      return isFascePremiVersatiAnnui;
    },
    isTipologiaCommFIPercentualeFunzioneDelTempo() {
      let isPercentualeFunzioneDelTempo = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.5") {
        isPercentualeFunzioneDelTempo = true;
      }
      return isPercentualeFunzioneDelTempo;
    },
    isTipologiaCommFIFasceCumuloCapitaleFunzioneDelTempo() {
      let isFasceCumuloCapitaleFunzioneDelTempo = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.6") {
        isFasceCumuloCapitaleFunzioneDelTempo = true;
      }
      return isFasceCumuloCapitaleFunzioneDelTempo;
    },
    isTipologiaCommFIFasceScaglioniCumuloCapitaleFunzioneDelTempo() {
      let isFasceScaglioniCumuloCapitaleFunzioneDelTempo = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.7") {
        isFasceScaglioniCumuloCapitaleFunzioneDelTempo = true;
      }
      return isFasceScaglioniCumuloCapitaleFunzioneDelTempo;
    },
    isTipologiaCommFIFascePremiVersatiAnnuiFunzioneDelTempo() {
      let isFascePremiVersatiAnnuiFunzioneDelTempo = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.8") {
        isFascePremiVersatiAnnuiFunzioneDelTempo = true;
      }
      return isFascePremiVersatiAnnuiFunzioneDelTempo;
    },
    isTipologiaCommFIAltro() {
      let isAltro = false;
      if (selectChoices.tipologiaCommissioneFondiInterni.code == "93.9") {
        isAltro = true;
      }
      return isAltro;
    },
    //
    isTipologiaFondiInterniAzionari() {
      let isAzionari = false;
      for (let ts of selectChoices.tipologiaFondiInterni as any){
        if (ts.code == "37.1") {
          isAzionari = true;
          break;
        }
      }
      return isAzionari;
    },
    isTipologiaFondiInterniObbligazionari() {
      let isObbligazionari = false;
      for (let ts of selectChoices.tipologiaFondiInterni as any){
        if (ts.code == "37.2") {
          isObbligazionari = true;
          break;
        }
      }
      return isObbligazionari;
    },
    isTipologiaFondiInterniBilanciati() {
      let isBilanciati = false;
      for (let ts of selectChoices.tipologiaFondiInterni as any){
        if (ts.code == "37.3") {
          isBilanciati = true;
          break;
        }
      }
      return isBilanciati;
    },
    isTipologiaFondiInterniFlessibili() {
      let isFlessibili = false;
      for (let ts of selectChoices.tipologiaFondiInterni as any){
        if (ts.code == "37.4") {
          isFlessibili = true;
          break;
        }
      }
      return isFlessibili;
    },
    isTipologiaFondiInterniMonetari() {
      let isMonetari = false;
      for (let ts of selectChoices.tipologiaFondiInterni as any){
        if (ts.code == "37.5") {
          isMonetari = true;
          break;
        }
      }
      return isMonetari;
    },
    initTipologiaFondiInterni() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precFlagTipologiaFondiInterni.azionari === undefined) {
        vm.precFlagTipologiaFondiInterni.azionari = vm.isTipologiaFondiInterniAzionari();
      }
      if (vm.precFlagTipologiaFondiInterni.obbligazionari === undefined) {
        vm.precFlagTipologiaFondiInterni.obbligazionari = vm.isTipologiaFondiInterniObbligazionari();
      }
      if (vm.precFlagTipologiaFondiInterni.bilanciati === undefined) {
        vm.precFlagTipologiaFondiInterni.bilanciati = vm.isTipologiaFondiInterniBilanciati();
      }
      if (vm.precFlagTipologiaFondiInterni.flessibili === undefined) {
        vm.precFlagTipologiaFondiInterni.flessibili = vm.isTipologiaFondiInterniFlessibili();
      }
      if (vm.precFlagTipologiaFondiInterni.monetari === undefined) {
        vm.precFlagTipologiaFondiInterni.monetari = vm.isTipologiaFondiInterniMonetari();
      }
    },
    changeTipologiaFondiInterni() {
      const vm = this as any;

      const isChangedAzionari = vm.precFlagTipologiaFondiInterni.azionari != vm.isTipologiaFondiInterniAzionari();
      const isChangedObbligazionari = vm.precFlagTipologiaFondiInterni.obbligazionari != vm.isTipologiaFondiInterniObbligazionari();
      const isChangedBilanciati = vm.precFlagTipologiaFondiInterni.bilanciati != vm.isTipologiaFondiInterniBilanciati();
      const isChangedFlessibili = vm.precFlagTipologiaFondiInterni.flessibili != vm.isTipologiaFondiInterniFlessibili();
      const isChangedMonetari = vm.precFlagTipologiaFondiInterni.monetari != vm.isTipologiaFondiInterniMonetari();

      vm.precFlagTipologiaFondiInterni.azionari = vm.isTipologiaFondiInterniAzionari();
      vm.precFlagTipologiaFondiInterni.obbligazionari = vm.isTipologiaFondiInterniObbligazionari();
      vm.precFlagTipologiaFondiInterni.bilanciati = vm.isTipologiaFondiInterniBilanciati();
      vm.precFlagTipologiaFondiInterni.flessibili = vm.isTipologiaFondiInterniFlessibili();
      vm.precFlagTipologiaFondiInterni.monetari = vm.isTipologiaFondiInterniMonetari();

      if (!vm.isTipologiaFondiInterniAzionari()) {
        properties.commissioneFondiInterniAzionariProperty.value = vm.ND;
        properties.commissioneFondiInterniAzionariProperty.valueSign = "";
        properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = [];
      } else if (isChangedAzionari) {
        properties.commissioneFondiInterniAzionariProperty.value = "";
        properties.commissioneFondiInterniAzionariProperty.valueSign = "";
        properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = [];
      }

      if (!vm.isTipologiaFondiInterniObbligazionari()) {
        properties.commissioneFondiInterniObbligazionariProperty.value = vm.ND;
        properties.commissioneFondiInterniObbligazionariProperty.valueSign = "";
        properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = [];
      } else if (isChangedObbligazionari) {
        properties.commissioneFondiInterniObbligazionariProperty.value = "";
        properties.commissioneFondiInterniObbligazionariProperty.valueSign = "";
        properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = [];
      }

      if (!vm.isTipologiaFondiInterniBilanciati()) {
        properties.commissioneFondiInterniBilanciatiProperty.value = vm.ND;
        properties.commissioneFondiInterniBilanciatiProperty.valueSign = "";
        properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = [];
      } else if (isChangedBilanciati) {
        properties.commissioneFondiInterniBilanciatiProperty.value = "";
        properties.commissioneFondiInterniBilanciatiProperty.valueSign = "";
        properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = [];
      }

      if (!vm.isTipologiaFondiInterniFlessibili()) {
        properties.commissioneFondiInterniFlessibiliProperty.value = vm.ND;
        properties.commissioneFondiInterniFlessibiliProperty.valueSign = "";
        properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = [];
      } else if (isChangedFlessibili) {
        properties.commissioneFondiInterniFlessibiliProperty.value = "";
        properties.commissioneFondiInterniFlessibiliProperty.valueSign = "";
        properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = [];
      }

      if (!vm.isTipologiaFondiInterniMonetari()) {
        properties.commissioneFondiInterniMonetariProperty.value = vm.ND;
        properties.commissioneFondiInterniMonetariProperty.valueSign = "";
        properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = [];
      } else if (isChangedMonetari) {
        properties.commissioneFondiInterniMonetariProperty.value = "";
        properties.commissioneFondiInterniMonetariProperty.valueSign = "";
        properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = [];
      }
    },
    isTipologiaSpeseGestPolOICRETFEmpty() {
      let isEmpty = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100" ||
          selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "") {
        isEmpty = true;
      }
      return isEmpty;
    },    
    isTipologiaSpeseGestPolOICRETFPercentualeFissa() {
      let isPercentualeFissa = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.1") {
        isPercentualeFissa = true;
      }
      return isPercentualeFissa;
    },
    isTipologiaSpeseGestPolOICRETFFasceCumuloCapitale() {
      let isFasceCumuloCapitale = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.2") {
        isFasceCumuloCapitale = true;
      }
      return isFasceCumuloCapitale;
    },
    isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitale() {
      let isFasceScaglioniCumuloCapitale = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.3") {
        isFasceScaglioniCumuloCapitale = true;
      }
      return isFasceScaglioniCumuloCapitale;
    },
    isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnui() {
      let isFascePremiVersatiAnnui = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.4") {
        isFascePremiVersatiAnnui = true;
      }
      return isFascePremiVersatiAnnui;
    },
    isTipologiaSpeseGestPolOICRETFPercentualeFunzioneDelTempo() {
      let isPercentualeFunzioneDelTempo = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.5") {
        isPercentualeFunzioneDelTempo = true;
      }
      return isPercentualeFunzioneDelTempo;
    },
    isTipologiaSpeseGestPolOICRETFFasceCumuloCapitaleFunzioneDelTempo() {
      let isFasceCumuloCapitaleFunzioneDelTempo = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.6") {
        isFasceCumuloCapitaleFunzioneDelTempo = true;
      }
      return isFasceCumuloCapitaleFunzioneDelTempo;
    },
    isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitaleFunzioneDelTempo() {
      let isFasceScaglioniCumuloCapitaleFunzioneDelTempo = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.7") {
        isFasceScaglioniCumuloCapitaleFunzioneDelTempo = true;
      }
      return isFasceScaglioniCumuloCapitaleFunzioneDelTempo;
    },
    isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnuiFunzioneDelTempo() {
      let isFascePremiVersatiAnnuiFunzioneDelTempo = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.8") {
        isFascePremiVersatiAnnuiFunzioneDelTempo = true;
      }
      return isFascePremiVersatiAnnuiFunzioneDelTempo;
    },
    isTipologiaSpeseGestPolOICRETFAltro() {
      let isAltro = false;
      if (selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code == "100.9") {
        isAltro = true;
      }
      return isAltro;
    },
    changeTipologiaSpeseGestionePolizzaOICRETF() {
      const vm = this as any;

      const isTipologiaSpeseGestPolOICRETFPercentualeFissa = vm.isTipologiaSpeseGestPolOICRETFPercentualeFissa();
      const isTipologiaSpeseGestPolOICRETFFasceCumuloCapitale = vm.isTipologiaSpeseGestPolOICRETFFasceCumuloCapitale();
      const isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitale = vm.isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitale();
      const isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnui = vm.isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnui();
      const isTipologiaSpeseGestPolOICRETFPercentualeFunzioneDelTempo = vm.isTipologiaSpeseGestPolOICRETFPercentualeFunzioneDelTempo();
      const isTipologiaSpeseGestPolOICRETFFasceCumuloCapitaleFunzioneDelTempo = vm.isTipologiaSpeseGestPolOICRETFFasceCumuloCapitaleFunzioneDelTempo();
      const isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitaleFunzioneDelTempo = vm.isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitaleFunzioneDelTempo();
      const isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnuiFunzioneDelTempo = vm.isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnuiFunzioneDelTempo();
      const isTipologiaSpeseGestPolOICRETFAltro = vm.isTipologiaSpeseGestPolOICRETFAltro();

      properties.speseGestionePolizzaOICRETFAzionariProperty.value = "";
      properties.speseGestionePolizzaOICRETFAzionariProperty.valueSign = "";
      properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = [];

      properties.speseGestionePolizzaOICRETFObbligazionariProperty.value = "";
      properties.speseGestionePolizzaOICRETFObbligazionariProperty.valueSign = "";
      properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = [];

      properties.speseGestionePolizzaOICRETFBilanciatiProperty.value = "";
      properties.speseGestionePolizzaOICRETFBilanciatiProperty.valueSign = "";
      properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = [];

      properties.speseGestionePolizzaOICRETFFlessibiliProperty.value = "";
      properties.speseGestionePolizzaOICRETFFlessibiliProperty.valueSign = "";
      properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = [];

      properties.speseGestionePolizzaOICRETFMonetariProperty.value = "";
      properties.speseGestionePolizzaOICRETFMonetariProperty.valueSign = "";
      properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = [];

      if (isTipologiaSpeseGestPolOICRETFPercentualeFissa) {
        properties.speseGestionePolizzaOICRETFAzionariProperty.valueSign = "%";
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.valueSign = "%";
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.valueSign = "%";
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.valueSign = "%";
        properties.speseGestionePolizzaOICRETFMonetariProperty.valueSign = "%";
      } else if (isTipologiaSpeseGestPolOICRETFFasceCumuloCapitale ||
        isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitale ||
        isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnui) {
        properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
        properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromEuroToEuroPerc();
      } else if (isTipologiaSpeseGestPolOICRETFPercentualeFunzioneDelTempo) {
        properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
        properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = vm.createNewRangeValuesFlexFromAnniToAnniPerc();
      } else if (isTipologiaSpeseGestPolOICRETFFasceCumuloCapitaleFunzioneDelTempo ||
        isTipologiaSpeseGestPolOICRETFFasceScaglioniCumuloCapitaleFunzioneDelTempo) {
        properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
        properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoCumuloCapitale();
      } else if (isTipologiaSpeseGestPolOICRETFFascePremiVersatiAnnuiFunzioneDelTempo) {
        properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
        properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = vm.createNewNestedRangeValuesFlexTempoPremiAnnui();
      }
    },
    isApplicazioneCommissioniOverperformance() {
      if (selectChoices.applicazioneCommissioniOverperformance.code == '107.2') {
        return false;
      }
      return true;
    },
    changeApplicazioneCommissioniOverperformance() {
      const vm = this as any;

      properties.commissioniOverperformanceProperty.value = "";

      if (!vm.isApplicazioneCommissioniOverperformance()) {
        properties.commissioniOverperformanceProperty.value = "Non applicate";
      }
    },
    isApplicazioneCommissioniUscitaStandard() {
      if (selectChoices.applicazioneCommissioniUscita.code == '110.1') {
        return true;
      }
      return false;
    },
    isApplicazioneCommissioniUscitaNonStandard() {
      if (selectChoices.applicazioneCommissioniUscita.code == '110.2') {
        return true;
      }
      return false;
    },
    isApplicazioneCommissioniUscitaNonApplicate() {
      if (selectChoices.applicazioneCommissioniUscita.code == '110.3') {
        return true;
      }
      return false;
    },
    changeApplicazioneCommissioniUscita() {
      const vm = this as any;

      const isApplicazioneCommissioniUscitaStandard = vm.isApplicazioneCommissioniUscitaStandard();
      const isApplicazioneCommissioniUscitaNonStandard = vm.isApplicazioneCommissioniUscitaNonStandard();
      const isApplicazioneCommissioniUscitaNonApplicate = vm.isApplicazioneCommissioniUscitaNonApplicate();

      properties.commissioniUscitaProperty.value = "";
      properties.commissioniUscitaProperty.stringList = [];

      if (isApplicazioneCommissioniUscitaStandard) {
        properties.commissioniUscitaProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Nel 1° anno" }];
      } else if (isApplicazioneCommissioniUscitaNonStandard) {
        // do nothing.
      } else if (isApplicazioneCommissioniUscitaNonApplicate) {
        properties.commissioniUscitaProperty.value = "Non applicate";
      }
    },
    isRetrocessioneCaricamentoND() {
      const vm = this as any;

      const checkND = !(vm.isTipologiaCaricamentoPICPercentualeFissa() ||
      vm.isTipologiaCaricamentoPICFasceCumuloPremiVersati() ||
      vm.isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersati() ||
      vm.isTipologiaCaricamentoPICFascePremiVersatiAnnui() ||
      vm.isTipologiaCaricamentoPICPercentualeFunzioneDelTempo() ||
      vm.isTipologiaCaricamentoPICFasceCumuloPremiVersatiFunzioneDelTempo() ||
      vm.isTipologiaCaricamentoPICFasceScaglioniCumuloPremiVersatiFunzioneDelTempo() ||
      vm.isTipologiaCaricamentoPICFascePremiVersatiAnnuiFunzioneDelTempo() ||
      vm.isTipologiaCaricamentoPICFascePatrimonioPotenziale() ||
      vm.isTipologiaCaricamentoPICFascePatrimonioPotenzialeEFasceCumuloPremiVersati() ||
      vm.isTipologiaCaricamentoPICFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti() ||
      vm.isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataContrattuale() ||
      vm.isTipologiaCaricamentoPICPercentualeFunzioneDellaDurataPianoPagamentoPremi() ||
      vm.isTipologiaCaricamentoPICFasceImportoTotalePianoPagamentoPremi() ||
      vm.isTipologiaCaricamentoPICAltro() ||
      vm.isTipologiaCaricamentoPACPercentualeFissa() ||
      vm.isTipologiaCaricamentoPACFasceCumuloPremiVersati() ||
      vm.isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersati() ||
      vm.isTipologiaCaricamentoPACFascePremiVersatiAnnui() ||
      vm.isTipologiaCaricamentoPACPercentualeFunzioneDelTempo() ||
      vm.isTipologiaCaricamentoPACFasceCumuloPremiVersatiFunzioneDelTempo() ||
      vm.isTipologiaCaricamentoPACFasceScaglioniCumuloPremiVersatiFunzioneDelTempo() ||
      vm.isTipologiaCaricamentoPACFascePremiVersatiAnnuiFunzioneDelTempo() ||
      vm.isTipologiaCaricamentoPACFascePatrimonioPotenziale() ||
      vm.isTipologiaCaricamentoPACFascePatrimonioPotenzialeEFasceCumuloPremiVersati() ||
      vm.isTipologiaCaricamentoPACFasceCumuloPremiVersatiEFasceVersamentiFuturiPrevisti() ||
      vm.isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataContrattuale() ||
      vm.isTipologiaCaricamentoPACPercentualeFunzioneDellaDurataPianoPagamentoPremi() ||
      vm.isTipologiaCaricamentoPACFasceImportoTotalePianoPagamentoPremi() ||
      vm.isTipologiaCaricamentoPACAltro());

      return checkND;
    },
    printStringListItem(item: any) {
      const vm = this as any;

      let spacing = '';
      if (item.valueSign !== undefined && item.valueSign !== null) {
        spacing = (item.valueSignLeft || item.valueSign.indexOf('ann')) >= 0 ? ' ' : '';
      }

      let stringListItem = (item.valueLabel !== undefined && !vm.isEmptyOrSpaces(item.valueLabel) ? item.valueLabel + " " : "");
      if (item.valueSignLeft) {
        stringListItem += item.valueSign + spacing + item.value;
      } else {
        stringListItem += item.value + spacing + item.valueSign;
      }

      return stringListItem;
    },
    printRangeValuesFlexItem(item: any, rangeValuesFlex: any) {
      const vm = this as any;

      let spaceLabel = " ";
      if (rangeValuesFlex !== undefined && rangeValuesFlex !== null) {
        if (rangeValuesFlex[0].label !== undefined && !vm.isEmptyOrSpaces(rangeValuesFlex[0].label) && vm.isEmptyOrSpaces(item.label)) {
          spaceLabel = " ".repeat(rangeValuesFlex[0].label.length + 1);
        }
      }
      const label = (item.label !== undefined && item.label !== null) ? item.label + spaceLabel : "";

      let spacingFrom = undefined;
      if (item.fromSign !== undefined && item.fromSign !== null) {
        spacingFrom = item.fromSignLeft || item.fromSign.indexOf('ann') >= 0 ? ' ' : '';
      }

      let spacingTo = undefined;
      if (item.toSign !== undefined && item.toSign !== null) {
        spacingTo = item.toSignLeft || item.toSign.indexOf('ann') >= 0 ? ' ' : '';
      }

      const from = item.fromSignLeft ? item.fromSign + spacingFrom + item.from : item.from + spacingFrom + item.fromSign;
      const to = item.toSignLeft ? item.toSign + spacingTo + item.to : item.to + spacingTo + item.toSign;
      let value = undefined;
      if (item.showValue && item.valueSign !== null) {
        const spacingValue = item.valueSignLeft || item.valueSign.indexOf('ann') >= 0 ? ' ' : '';
        value = item.valueSignLeft ? item.valueSign + spacingValue + item.value : item.value + spacingValue + item.valueSign;
      }

      const retValue = label + from + " " + item.fromToOperator + " " + to + (item.showValue ? (" " + item.toValueOperator + " " + value) : "");

      return retValue;
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    //
    valorizzaTendine() {
      const vm = this as any;

      //
      properties.piuVersioniProperty.code = selectChoices.piuVersioni.code;
      properties.piuVersioniProperty.value = selectChoices.piuVersioni.description;
      properties.compagniaProperty.code = selectChoices.compagnia.code;
      properties.compagniaProperty.value = selectChoices.compagnia.description;
      properties.compagniaProperty.extCode = selectChoices.compagnia.extCode;
      properties.mercatoProperty.values = selectChoices.mercato;
      properties.canaleProperty.values = selectChoices.canale;
      properties.distributoriProperty.values = selectChoices.distributori;
      properties.tipologiaProdottoProperty.code = selectChoices.tipologiaProdotto.code;
      properties.tipologiaProdottoProperty.value = selectChoices.tipologiaProdotto.description;
      properties.tipologiaSottostantiProperty.values = selectChoices.tipologiaSottostanti;
      properties.prodCommercioProperty.code = selectChoices.prodCommercio.code;
      properties.prodCommercioProperty.value = selectChoices.prodCommercio.description;
      properties.tipologiaPremioProperty.code = selectChoices.tipologiaPremio.code;
      properties.tipologiaPremioProperty.value = selectChoices.tipologiaPremio.description;
      properties.rendMinGarantitoProperty.code = selectChoices.rendMinGarantito.code;
      properties.rendMinGarantitoProperty.value = selectChoices.rendMinGarantito.description;
      properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty.code = selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali.code;
      properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty.value = selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali.description;
      properties.fondoUtiliProperty.code = selectChoices.fondoUtili.code;
      properties.fondoUtiliProperty.value = selectChoices.fondoUtili.description;
      properties.tipologiaFondiInterniProperty.values = selectChoices.tipologiaFondiInterni;
      properties.numOICRETFProperty.code = selectChoices.numOICRETF.code;
      properties.numOICRETFProperty.value = selectChoices.numOICRETF.description;
      properties.presenzaProtezioneCapitaleProperty.code = selectChoices.presenzaProtezioneCapitale.code;
      properties.presenzaProtezioneCapitaleProperty.value = selectChoices.presenzaProtezioneCapitale.description;
      properties.opzioniContrattualiTipologiaProperty.values = selectChoices.opzioniContrattualiTipologia;
      properties.garanzieAssicurativeTipologiaProperty.values = selectChoices.garanzieAssicurativeTipologia;
      properties.maggiorazioneCasoMorteStandardProperty.code = selectChoices.maggiorazioneCasoMorteStandard.code;
      properties.maggiorazioneCasoMorteStandardProperty.value = selectChoices.maggiorazioneCasoMorteStandard.description;
      properties.maggiorazioneCasoMortePerInfortunioProperty.code = selectChoices.maggiorazioneCasoMortePerInfortunio.code;
      properties.maggiorazioneCasoMortePerInfortunioProperty.value = selectChoices.maggiorazioneCasoMortePerInfortunio.description;
      properties.maggiorazioneCasoMortePerIncidenteStradaleProperty.code = selectChoices.maggiorazioneCasoMortePerIncidenteStradale.code;
      properties.maggiorazioneCasoMortePerIncidenteStradaleProperty.value = selectChoices.maggiorazioneCasoMortePerIncidenteStradale.description;
      properties.maggiorazioneCasoMortePerMinusvalenzaProperty.code = selectChoices.maggiorazioneCasoMortePerMinusvalenza.code;
      properties.maggiorazioneCasoMortePerMinusvalenzaProperty.value = selectChoices.maggiorazioneCasoMortePerMinusvalenza.description;
      properties.TCMStandAloneProperty.code = selectChoices.TCMStandAlone.code;
      properties.TCMStandAloneProperty.value = selectChoices.TCMStandAlone.description;
      properties.longTermCareProperty.code = selectChoices.longTermCare.code;
      properties.longTermCareProperty.value = selectChoices.longTermCare.description;
      properties.dreadDiseaseProperty.code = selectChoices.dreadDisease.code;
      properties.dreadDiseaseProperty.value = selectChoices.dreadDisease.description;
      properties.invaliditaInabilitaProperty.code = selectChoices.invaliditaInabilita.code;
      properties.invaliditaInabilitaProperty.value = selectChoices.invaliditaInabilita.description;
      properties.tipologiaBonusIngressoProperty.code = selectChoices.tipologiaBonusIngresso.code;
      properties.tipologiaBonusIngressoProperty.value = selectChoices.tipologiaBonusIngresso.description;
      properties.tipologiaBonusFedeltaProperty.code = selectChoices.tipologiaBonusFedelta.code;
      properties.tipologiaBonusFedeltaProperty.value = selectChoices.tipologiaBonusFedelta.description;
      properties.tipologiaCaricamentoPICProperty.code = selectChoices.tipologiaCaricamentoPIC.code;
      properties.tipologiaCaricamentoPICProperty.value = selectChoices.tipologiaCaricamentoPIC.description;
      properties.tipologiaCaricamentoPACProperty.code = selectChoices.tipologiaCaricamentoPAC.code;
      properties.tipologiaCaricamentoPACProperty.value = selectChoices.tipologiaCaricamentoPAC.description;
      properties.tipologiaCommissioneGestioneSeparataProperty.code = selectChoices.tipologiaCommissioneGestioneSeparata.code;
      properties.tipologiaCommissioneGestioneSeparataProperty.value = selectChoices.tipologiaCommissioneGestioneSeparata.description;
      properties.tipologiaCommissioneFondiInterniProperty.code = selectChoices.tipologiaCommissioneFondiInterni.code;
      properties.tipologiaCommissioneFondiInterniProperty.value = selectChoices.tipologiaCommissioneFondiInterni.description;
      properties.tipologiaSpeseGestionePolizzaOICRETFProperty.code = selectChoices.tipologiaSpeseGestionePolizzaOICRETF.code;
      properties.tipologiaSpeseGestionePolizzaOICRETFProperty.value = selectChoices.tipologiaSpeseGestionePolizzaOICRETF.description;
      properties.applicazioneCommissioniOverperformanceProperty.code = selectChoices.applicazioneCommissioniOverperformance.code;
      properties.applicazioneCommissioniOverperformanceProperty.value = selectChoices.applicazioneCommissioniOverperformance.description;      
      properties.applicazioneCommissioniUscitaProperty.code = selectChoices.applicazioneCommissioniUscita.code;
      properties.applicazioneCommissioniUscitaProperty.value = selectChoices.applicazioneCommissioniUscita.description;
    },
    cleanAllProperties() {
      const vm = this as any;

      //
      properties.prodottoProperty.value = "";
      properties.codProdottoProperty.value = "";
      properties.piuVersioniProperty.code = ""; properties.piuVersioniProperty.value = "";
      properties.codProdCollegatiProperty.value = "";
      properties.compagniaProperty.code = ""; properties.compagniaProperty.value = ""; properties.compagniaProperty.extCode = "";
      properties.mercatoProperty.values = [];
      properties.canaleProperty.values = [];
      properties.distributoriProperty.values = [];
      properties.tipologiaProdottoProperty.code = ""; properties.tipologiaProdottoProperty.value = "";
      properties.tipologiaSottostantiProperty.values = [];
      properties.prodCommercioProperty.code = ""; properties.prodCommercioProperty.value = "";
      properties.inizioCommProperty.value = ""; properties.inizioCommProperty.dateValue = null;
      properties.fineCommProperty.value = ""; properties.fineCommProperty.dateValue = null;
      properties.edizioneDIPAggProperty.value = ""; properties.edizioneDIPAggProperty.dateValue = null;
      properties.tipologiaPremioProperty.code = ""; properties.tipologiaPremioProperty.value = "";
      properties.durataContrattoProperty.value = "";
      properties.durataPianoPagamentoPremiProperty.value = "";
      properties.importoMinPremioUnicoProperty.value = ""; vm.importoMinPremioUnicoProperty.valueSign = "€";
      properties.importoMaxPremioUnicoProperty.value = ""; vm.importoMaxPremioUnicoProperty.valueSign = "€";
      properties.importoMinPremioRicAnnuoProperty.value = ""; vm.importoMinPremioRicAnnuoProperty.valueSign = "€";
      properties.importoMaxPremioRicAnnuoProperty.value = ""; vm.importoMaxPremioRicAnnuoProperty.valueSign = "€";
      properties.targetMarketProperty.value = "";
      properties.orizzonteTemporaleSuggeritoProperty.value = ""; properties.orizzonteTemporaleSuggeritoProperty.stringList = [{ value: "", valueSign: "anni", valueLabel: "Min." }, { value: "", valueSign: "anni", valueLabel: "Max." }];
      properties.indicatoreSinteticoRischioProperty.value = ""; properties.indicatoreSinteticoRischioProperty.stringList = [{ value: "", valueSign: "", valueLabel: "Min." }, { value: "", valueSign: "", valueLabel: "Max." }];
      properties.reductionInYieldCostiIngressoProperty.value = ""; properties.reductionInYieldCostiIngressoProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      properties.reductionInYieldCostiUscitaProperty.value = ""; properties.reductionInYieldCostiUscitaProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      properties.reductionInYieldCostiCorrentiProperty.value = ""; properties.reductionInYieldCostiCorrentiProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      properties.assetAllocationProperty.value = "";
      properties.invMinGestioneSeparataProperty.value = ""; properties.invMinGestioneSeparataProperty.valueSign = "%";
      properties.invMaxGestioneSeparataProperty.value = ""; properties.invMaxGestioneSeparataProperty.valueSign = "%";
      properties.gestioneSeparataProperty.value = "";
      properties.ultimoRendCertGestioneSeparataProperty.value = ""; properties.ultimoRendCertGestioneSeparataProperty.valueSign = "%";
      properties.annoRendCertGestioneSeparataProperty.value = "";
      properties.rendMinGarantitoProperty.code = ""; properties.rendMinGarantitoProperty.value = "";
      properties.rendMinGarantitoMisuraProperty.value = "";
      properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty.code = ""; properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty.value = "";
      properties.consolidamentoAnnuoRivalutazioniContrattualiProperty.value = "";
      properties.fondoUtiliProperty.code = ""; properties.fondoUtiliProperty.value = "";
      properties.invMinRamoIIIProperty.value = ""; properties.invMinRamoIIIProperty.valueSign = "%";
      properties.invMaxRamoIIIProperty.value = ""; properties.invMaxRamoIIIProperty.valueSign = "%";
      properties.numFondiInterniProperty.value = "";
      properties.tipologiaFondiInterniProperty.values = [];
      properties.numOICRETFProperty.code = ""; properties.numOICRETFProperty.value = "";
      properties.presenzaProtezioneCapitaleProperty.code = ""; properties.presenzaProtezioneCapitaleProperty.value = "";
      properties.protezioneCapitaleProperty.value = "";
      properties.opzioniContrattualiTipologiaProperty.values = [];
      properties.cedolaProperty.value = "";
      properties.decumuloProperty.value = "";
      properties.renditaProperty.value = "";
      properties.stopLossProperty.value = "";
      properties.takeProfitProperty.value = "";
      properties.progressiveInvestmentProperty.value = "";
      properties.automaticRebalanceProperty.value = "";
      properties.downtrendOpportunityProperty.value = "";
      properties.lifeCycleProperty.value = "";
      properties.switchProperty.value = "";
      properties.altreOpzioniContrattualiProperty.value = "";
      properties.garanzieAssicurativeTipologiaProperty.values = [];
      properties.maggiorazioneCasoMorteStandardProperty.code = ""; properties.maggiorazioneCasoMorteStandardProperty.value = "";
      properties.maggiorazioneCasoMorteStandardPrestazioneProperty.value = "";
      properties.maggiorazioneCasoMorteStandardPrestazioneProperty.stringList = [
        { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "Min. %:", valueLabelReadonly: false, valueLabelFix: true},
        { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "Max. %:", valueLabelReadonly: false, valueLabelFix: true},
        { value: "", showSign: true, valueSign: "€", valueSignReadonly: false, valueSignLeft: true, showLabel: true, valueLabel: "Max. €:", valueLabelReadonly: false, valueLabelFix: true}
      ];
      properties.maggiorazioneCasoMortePerInfortunioProperty.code = ""; properties.maggiorazioneCasoMortePerInfortunioProperty.value = "";
      properties.maggiorazioneCasoMortePerInfortunioPrestazioneProperty.value = "";
      properties.maggiorazioneCasoMortePerIncidenteStradaleProperty.code = ""; properties.maggiorazioneCasoMortePerIncidenteStradaleProperty.value = "";
      properties.maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty.value = "";
      properties.maggiorazioneCasoMortePerMinusvalenzaProperty.code = ""; properties.maggiorazioneCasoMortePerMinusvalenzaProperty.value = "";
      properties.maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty.value = "";
      properties.TCMStandAloneProperty.code = ""; properties.TCMStandAloneProperty.value = "";
      properties.TCMStandAlonePrestazioneProperty.value = "";
      properties.longTermCareProperty.code = ""; properties.longTermCareProperty.value = "";
      properties.longTermCarePrestazioneProperty.value = "";
      properties.dreadDiseaseProperty.code = ""; properties.dreadDiseaseProperty.value = "";
      properties.dreadDiseasePrestazioneProperty.value = "";
      properties.invaliditaInabilitaProperty.code = ""; properties.invaliditaInabilitaProperty.value = "";
      properties.invaliditaInabilitaProperty.value = "";
      properties.altreGaranzieAssicurativeProperty.value = "";
      properties.tipologiaBonusIngressoProperty.code = ""; properties.tipologiaBonusIngressoProperty.value = "";
      properties.bonusIngressoProperty.value = ""; properties.bonusIngressoProperty.valueSign = "";
      properties.bonusIngressoProperty.rangeValuesFlex = [];
      properties.bonusFedeltaProperty.value = "";
      properties.bonusFedeltaProperty.rangeValuesFlex = [];
      properties.speseEmissioneProperty.value = ""; properties.speseEmissioneProperty.valueSign = "€";
      properties.tipologiaCaricamentoPICProperty.code = ""; properties.tipologiaCaricamentoPICProperty.value = "";
      properties.caricamentoPICProperty.value = ""; properties.caricamentoPICProperty.valueSign = "";
      properties.caricamentoPICProperty.rangeValuesFlex = [];
      properties.tipologiaCaricamentoPACProperty.code = ""; properties.tipologiaCaricamentoPACProperty.value = "";
      properties.caricamentoPACProperty.value = ""; properties.caricamentoPACProperty.valueSign = "";
      properties.caricamentoPACProperty.rangeValuesFlex = [];
      properties.caricamentoProperty.value = ""; properties.caricamentoProperty.valueSign = "€";
      properties.tipologiaCommissioneGestioneSeparataProperty.code = ""; properties.tipologiaCommissioneGestioneSeparataProperty.value = "";
      properties.commissioneGestioneSeparataProperty.value = ""; properties.commissioneGestioneSeparataProperty.valueSign = "";
      properties.commissioneGestioneSeparataProperty.stringList = [
        { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "", valueLabelReadonly: false, valueLabelFix: true},
        { value: "", showSign: true, valueSign: "%", valueSignReadonly: false, valueSignLeft: false, showLabel: true, valueLabel: "Commissione Min.", valueLabelReadonly: false, valueLabelFix: true},
      ];
      properties.commissioneGestioneSeparataProperty.rangeValuesFlex = [];
      properties.tipologiaCommissioneFondiInterniProperty.code = ""; properties.tipologiaCommissioneFondiInterniProperty.value = "";
      properties.commissioneFondiInterniAzionariProperty.value = ""; properties.commissioneFondiInterniAzionariProperty.valueSign = "";
      properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = [];
      properties.commissioneFondiInterniObbligazionariProperty.value = ""; properties.commissioneFondiInterniObbligazionariProperty.valueSign = "";
      properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = [];
      properties.commissioneFondiInterniBilanciatiProperty.value = ""; properties.commissioneFondiInterniBilanciatiProperty.valueSign = "";
      properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = [];
      properties.commissioneFondiInterniFlessibiliProperty.value = ""; properties.commissioneFondiInterniFlessibiliProperty.valueSign = "";
      properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = [];
      properties.commissioneFondiInterniMonetariProperty.value = ""; properties.commissioneFondiInterniMonetariProperty.valueSign = "";
      properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = [];
      properties.commissioneSottostantiFondiInterniProperty.value = ""; properties.commissioneSottostantiFondiInterniProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Max." }];
      properties.tipologiaSpeseGestionePolizzaOICRETFProperty.code = ""; properties.tipologiaSpeseGestionePolizzaOICRETFProperty.value = "";
      properties.speseGestionePolizzaOICRETFAzionariProperty.value = ""; properties.speseGestionePolizzaOICRETFAzionariProperty.valueSign = ""; properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = [];
      properties.speseGestionePolizzaOICRETFObbligazionariProperty.value = ""; properties.speseGestionePolizzaOICRETFObbligazionariProperty.valueSign = ""; properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = [];
      properties.speseGestionePolizzaOICRETFBilanciatiProperty.value = ""; properties.speseGestionePolizzaOICRETFBilanciatiProperty.valueSign = ""; properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = [];
      properties.speseGestionePolizzaOICRETFFlessibiliProperty.value = ""; properties.speseGestionePolizzaOICRETFFlessibiliProperty.valueSign = ""; properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = [];
      properties.speseGestionePolizzaOICRETFMonetariProperty.value = ""; properties.speseGestionePolizzaOICRETFMonetariProperty.valueSign = ""; properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = [];
      properties.commissioneOICRETFProperty.value = ""; properties.commissioneOICRETFProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
      properties.applicazioneCommissioniOverperformanceProperty.code = ""; properties.applicazioneCommissioniOverperformanceProperty.value = "";
      properties.commissioniOverperformanceProperty.value = "";
      properties.costoMaggiorazioneCasoMorteStandardProperty.value = ""; properties.costoMaggiorazioneCasoMorteStandardProperty.valueSign = "%";
      properties.riscattoProperty.value = "";
      properties.applicazioneCommissioniUscitaProperty.code = ""; properties.applicazioneCommissioniUscitaProperty.value = "";
      properties.commissioniUscitaProperty.value = ""; properties.commissioniUscitaProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Nel 1° anno" }];
      properties.altriCostiProperty.value = "";
      properties.retrocessioneCaricamentoProperty.value = ""; properties.retrocessioneCaricamentoProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      properties.retrocessioneGestioneSeparataProperty.value = ""; properties.retrocessioneGestioneSeparataProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      properties.retrocessioneRamoIIIProperty.value = ""; properties.retrocessioneRamoIIIProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
      properties.noteProperty.value = "";

      //
      selectChoices.piuVersioni = { code: "", description: "" };
      selectChoices.compagnia = { code: "", description: "", extCode: "" };
      selectChoices.mercato = []; // multiselect
      selectChoices.canale = []; // multiselect
      selectChoices.tipologiaProdotto = { code: "", description: "" };
      selectChoices.tipologiaSottostanti = []; // multiselect
      selectChoices.prodCommercio = { code: "", description: "" };
      selectChoices.tipologiaPremio = { code: "", description: "" };
      selectChoices.rendMinGarantito = { code: "", description: "" };
      selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali = { code: "", description: "" };
      selectChoices.fondoUtili = { code: "", description: "" };
      selectChoices.tipologiaFondiInterni = [];
      selectChoices.numOICRETF = { code: "", description: "" };
      selectChoices.presenzaProtezioneCapitale = { code: "", description: "" };
      selectChoices.opzioniContrattualiTipologia = [];
      selectChoices.garanzieAssicurativeTipologia = [];
      selectChoices.maggiorazioneCasoMorteStandard = { code: "", description: "" };
      selectChoices.maggiorazioneCasoMortePerInfortunio = { code: "", description: "" };
      selectChoices.maggiorazioneCasoMortePerIncidenteStradale = { code: "", description: "" };
      selectChoices.maggiorazioneCasoMortePerMinusvalenza = { code: "", description: "" };
      selectChoices.TCMStandAlone = { code: "", description: "" };
      selectChoices.longTermCare = { code: "", description: "" };
      selectChoices.dreadDisease = { code: "", description: "" };
      selectChoices.invaliditaInabilita = { code: "", description: "" };
      selectChoices.tipologiaBonusIngresso = { code: "", description: "" };
      selectChoices.tipologiaBonusFedelta = { code: "", description: "" };
      selectChoices.tipologiaCaricamentoPIC = { code: "", description: "" };
      selectChoices.tipologiaCaricamentoPAC = { code: "", description: "" };
      selectChoices.tipologiaCommissioneGestioneSeparata = { code: "", description: "" };
      selectChoices.tipologiaCommissioneFondiInterni = { code: "", description: "" };
      selectChoices.tipologiaSpeseGestionePolizzaOICRETF = { code: "", description: "" };
      selectChoices.applicazioneCommissioniOverperformance = { code: "", description: "" };
      selectChoices.applicazioneCommissioniUscita = { code: "", description: "" };
    },
    createNewRangeValuesFlexFromEuroToEuroPerc() {
      let r = [
        {
          order: 0,
          label: "",
          from: "",
          fromSign: "€",
          fromSignLeft: true,
          fromToOperator: "-",
          to: "",
          toSign: "€",
          toSignLeft: true,
          toValueOperator: "=",
          showValue: true,
          value: "",
          valueSign: "%",
          valueSignLeft: false,
          rangeValuesFlex: []
        }
      ];

      return r;
    },
    createNewRangeValuesFlexAnnoPerc() {
      let r = [
        {
          order: 0,
          label: "",
          from: "",
          fromSign: "anno",
          fromSignLeft: false,
          fromToOperator: "=",
          to: "",
          toSign: "%",
          toSignLeft: false,
          toValueOperator: "",
          showValue: false,
          value: "",
          valueSign: "",
          valueSignLeft: false,
        }
      ];

      return r;
    },
    createNewRangeValuesFlexAnniPerc() {
      let r = [
        {
          order: 0,
          label: "",
          from: "",
          fromSign: "anni",
          fromSignLeft: false,
          fromToOperator: "=",
          to: "",
          toSign: "%",
          toSignLeft: false,
          toValueOperator: "",
          showValue: false,
          value: "",
          valueSign: "",
          valueSignLeft: false,
        }
      ];

      return r;
    },
    createNewRangeValuesFlexFromAnniToAnniPerc() {
      let r = [
        {
          order: 0,
          label: "",
          from: "",
          fromSign: "anni",
          fromSignLeft: false,
          fromToOperator: "-",
          to: "",
          toSign: "anni",
          toSignLeft: false,
          toValueOperator: "=",
          showValue: true,
          value: "",
          valueSign: "%",
          valueSignLeft: false,
          rangeValuesFlex: []
        }
      ];

      return r;
    },
    createNewRangeValuesFlexFromPercToPercPerc() {
      let r = [
        {
          order: 0,
          label: "",
          from: "",
          fromSign: "%",
          fromSignLeft: false,
          fromToOperator: "-",
          to: "",
          toSign: "%",
          toSignLeft: false,
          toValueOperator: "=",
          showValue: true,
          value: "",
          valueSign: "%",
          valueSignLeft: false,
          rangeValuesFlex: []
        }
      ];

      return r;
    },
    createNewNestedRangeValuesFlexTempoCumuloCapitale() {
      let r = [
        {
          order: 0,
          label: "Tempo:",
          from: "",
          fromSign: "anni",
          fromSignLeft: false,
          fromToOperator: "-",
          to: "",
          toSign: "anni",
          toSignLeft: false,
          toValueOperator: "",
          showValue: false,
          value: "",
          valueSign: "",
          valueSignLeft: false,
          rangeValuesFlex: [
            {
              order: 0,
              label: "Cumulo capitale:",
              from: "",
              fromSign: "€",
              fromSignLeft: true,
              fromToOperator: "-",
              to: "",
              toSign: "€",
              toSignLeft: true,
              toValueOperator: "=",
              showValue: true,
              value: "",
              valueSign: "%",
              valueSignLeft: false
            }
          ]
        }
      ];

      return r;
    },
    createNewNestedRangeValuesFlexTempoCumuloPremi() {
      let r = [
        {
          order: 0,
          label: "Tempo:",
          from: "",
          fromSign: "anni",
          fromSignLeft: false,
          fromToOperator: "-",
          to: "",
          toSign: "anni",
          toSignLeft: false,
          toValueOperator: "",
          showValue: false,
          value: "",
          valueSign: "",
          valueSignLeft: false,
          rangeValuesFlex: [          
            {
              order: 0,
              label: "Cumulo premi:",
              from: "",
              fromSign: "€",
              fromSignLeft: true,
              fromToOperator: "-",
              to: "",
              toSign: "€",
              toSignLeft: true,
              toValueOperator: "=",
              showValue: true,
              value: "",
              valueSign: "%",
              valueSignLeft: false
            }
          ]
        }
      ];

      return r;
    },
    createNewNestedRangeValuesFlexTempoPremiAnnui() {
      let r = [
        {
          order: 0,
          label: "Tempo:",
          from: "",
          fromSign: "anni",
          fromSignLeft: false,
          fromToOperator: "-",
          to: "",
          toSign: "anni",
          toSignLeft: false,
          toValueOperator: "",
          showValue: false,
          value: "",
          valueSign: "",
          valueSignLeft: false,
          rangeValuesFlex: [          
            {
              order: 0,
              label: "Premi annui:",
              from: "",
              fromSign: "€",
              fromSignLeft: true,
              fromToOperator: "-",
              to: "",
              toSign: "€",
              toSignLeft: true,
              toValueOperator: "=",
              showValue: true,
              value: "",
              valueSign: "%",
              valueSignLeft: false
            }
          ]
        }
      ];

      return r;
    },
    createNewNestedRangeValuesFlexPatrimonioPotenzialeCumuloPremi() {
      let r = [
        {
          order: 0,
          label: "Patrimonio potenziale:",
          from: "",
          fromSign: "€",
          fromSignLeft: true,
          fromToOperator: "-",
          to: "",
          toSign: "€",
          toSignLeft: true,
          toValueOperator: "",
          showValue: false,
          value: "",
          valueSign: "",
          valueSignLeft: false,
          rangeValuesFlex: [          
            {
              order: 0,
              label: "Cumulo premi:",
              from: "",
              fromSign: "€",
              fromSignLeft: true,
              fromToOperator: "-",
              to: "",
              toSign: "€",
              toSignLeft: true,
              toValueOperator: "=",
              showValue: true,
              value: "",
              valueSign: "%",
              valueSignLeft: false
            }
          ]
        }
      ];

      return r;
    },
    createNewNestedRangeValuesFlexPatrimonioPotenzialeVersamentiFuturiPrevisti() {
      let r = [
        {
          order: 0,
          label: "Versamenti futuri previsti:",
          from: "",
          fromSign: "€",
          fromSignLeft: true,
          fromToOperator: "-",
          to: "",
          toSign: "€",
          toSignLeft: true,
          toValueOperator: "",
          showValue: false,
          value: "",
          valueSign: "",
          valueSignLeft: false,
          rangeValuesFlex: [          
            {
              order: 0,
              label: "Cumulo premi:",
              from: "",
              fromSign: "€",
              fromSignLeft: true,
              fromToOperator: "-",
              to: "",
              toSign: "€",
              toSignLeft: true,
              toValueOperator: "=",
              showValue: true,
              value: "",
              valueSign: "%",
              valueSignLeft: false
            }
          ]
        }
      ];

      return r;
    },
    setPropertiesDefaultCode() {
      return null; //codice fittizio per non generare errore in fase di compilazione
    },
    prefillCodeValue: function(property: any, propCode: string, propValue: string, choices: any, options: any [], propExtCode: string) {
      property.code = propCode;
      property.value = propValue;
      if (propCode != undefined && propCode.match(/\./)) {
        const v = options.find((o: any) => o.code === propCode);
        if (propExtCode === undefined) {
          choices = { code: propCode, description: v ? v.description : propValue };
        } else {
          choices = { code: propCode, description: v ? v.description : propValue, extCode: propExtCode };
        }
      } else if (propCode != undefined && propCode.length > 0) {
        if (propExtCode === undefined) {
          choices = { code: propCode, description: propValue };
        } else {
          choices = { code: propCode, description: propValue, extCode: propExtCode };
        }
      } else {
        if (propExtCode === undefined) {
          choices = { code: '', description: '' };
        } else {
          choices = { code: '', description: '' , extCode: propExtCode };
        }
      }

      return choices;
    },
    prefillValues: function(property: any, values: any [], choices: any, options: any []) {
      property.values = values;
      if (values.length > 0) {
        choices = [];
        for (let i = 0; i < values.length; i++) {
          const v = options.find((o: any) => o.code === values[i].code);
          choices.push({ code: v.code, description: v.description});
        }
      } else {
        choices = [];
      }

      return choices;
    },
    prefillProperties: async function() {
      const vm = this as any;

      // se si arriva da Database.vue bisogna prefillare i campi
      if (vm.productIdSelected != undefined) {
        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .getProduct(vm.productIdSelected)
          .then(handleResponse)
          .then((result: any) => {
            let get = function(key: string, code: string) {
              let res = undefined;
              const regexCode = /^([0-9]+)([a-z]*)/i;
              let codePrefix = undefined;
              let codeSuffix = undefined;
              const codeMatch = regexCode.exec(code);
              let re: any = undefined;
              if (codeMatch) {
                codePrefix = codeMatch[1] || "";
                codeSuffix = codeMatch[2] || "";
                re = new RegExp(`^${codePrefix}\\.[0-9]${codeSuffix}`);
              }
              const p = result.properties.find((p: any) => {
                let match = false;
                const equals = p.code === code;
                if (!equals && re != undefined) {
                  match = re.test(p.code);
                }

                return equals || match;
              });
              if (p != undefined) {
                res = p[key];
              }
              return res;
            }

            const prodotto = get("value", codes.prodottoProperty);
            const piuVersioniCode = get("code", codes.piuVersioniProperty);
            const piuVersioniValue = get("value", codes.piuVersioniProperty);
            const codProdottiCollegati = get("value", codes.codProdCollegatiProperty);
            const compagniaCode = get("code", codes.compagniaProperty);
            const compagniaValue = get("value", codes.compagniaProperty);
            const compagniaExtCode = get("extCode", codes.compagniaProperty);
            const mercatoValues = get("values", codes.mercatoProperty);
            const canaleValues = get("values", codes.canaleProperty);
            const distributoriValues = get("values", codes.distributoriProperty);
            const tipologiaProdottoCode = get("code", codes.tipologiaProdottoProperty);
            const tipologiaProdottoValue = get("value", codes.tipologiaProdottoProperty);
            const tipologiaSottostantiValues = get("values", codes.tipologiaSottostantiProperty);
            const prodCommercioCode = get("code", codes.prodCommercioProperty);
            const prodCommercioValue = get("value", codes.prodCommercioProperty);
            const inizioComm = get("value", codes.inizioCommProperty);
            const fineComm = get("value", codes.fineCommProperty);
            const edizioneDIPAgg = get("value", codes.edizioneDIPAggProperty);
            const tipologiaPremioCode = get("code", codes.tipologiaPremioProperty);
            const tipologiaPremioValue = get("value", codes.tipologiaPremioProperty);
            const durataContrattuale = get("value", codes.durataContrattoProperty);
            const durataPianoPagamentoPremi = get("value", codes.durataPianoPagamentoPremiProperty);
            const importoMinPremioUnicoValue = get("value", codes.importoMinPremioUnicoProperty);
            const importoMinPremioUnicoValueSign = get("valueSign", codes.importoMinPremioUnicoProperty);
            const importoMaxPremioUnicoValue = get("value", codes.importoMaxPremioUnicoProperty);
            const importoMaxPremioUnicoValueSign = get("valueSign", codes.importoMaxPremioUnicoProperty);
            const importoMinPremioRicAnnuoValue = get("value", codes.importoMinPremioRicAnnuoProperty);
            const importoMinPremioRicAnnuoValueSign = get("valueSign", codes.importoMinPremioRicAnnuoProperty);
            const importoMaxPremioRicAnnuoValue = get("value", codes.importoMaxPremioRicAnnuoProperty);
            const importoMaxPremioRicAnnuoValueSign = get("valueSign", codes.importoMaxPremioRicAnnuoProperty);
            const targetMarket = get("value", codes.targetMarketProperty);
            const orizzonteTemporaleSuggerito = get("value", codes.orizzonteTemporaleSuggeritoProperty);
            const orizzonteTemporaleSuggeritoStringList = get("stringList", codes.orizzonteTemporaleSuggeritoProperty);
            const indicatoreSinteticoRischio = get("value", codes.indicatoreSinteticoRischioProperty);
            const indicatoreSinteticoRischioStringList = get("stringList", codes.indicatoreSinteticoRischioProperty);
            const reductionInYieldCostiIngresso = get("value", codes.reductionInYieldCostiIngressoProperty);
            const reductionInYieldCostiIngressoStringList = get("stringList", codes.reductionInYieldCostiIngressoProperty);
            const reductionInYieldCostiUscita = get("value", codes.reductionInYieldCostiUscitaProperty);
            const reductionInYieldCostiUscitaStringList = get("stringList", codes.reductionInYieldCostiUscitaProperty);
            const reductionInYieldCostiCorrenti = get("value", codes.reductionInYieldCostiCorrentiProperty);
            const reductionInYieldCostiCorrentiStringList = get("stringList", codes.reductionInYieldCostiCorrentiProperty);
            const assetAllocation = get("value", codes.assetAllocationProperty);
            const invMinGestioneSeparataValue = get("value", codes.invMinGestioneSeparataProperty);
            const invMinGestioneSeparataValueSign = get("valueSign", codes.invMinGestioneSeparataProperty);
            const invMaxGestioneSeparataValue = get("value", codes.invMaxGestioneSeparataProperty);
            const invMaxGestioneSeparataValueSign = get("valueSign", codes.invMaxGestioneSeparataProperty);
            const gestioneSeparata = get("value", codes.gestioneSeparataProperty);
            const ultimoRendCertGestioneSeparataValue = get("value", codes.ultimoRendCertGestioneSeparataProperty);
            const ultimoRendCertGestioneSeparataValueSign = get("valueSign", codes.ultimoRendCertGestioneSeparataProperty);
            const annoRendCertGestioneSeparata = get("value", codes.annoRendCertGestioneSeparataProperty);
            const rendMinGarantitoCode = get("code", codes.rendMinGarantitoProperty);
            const rendMinGarantitoValue = get("value", codes.rendMinGarantitoProperty);
            const rendMinGarantitoMisura = get("value", codes.rendMinGarantitoMisuraProperty);
            const presenzaConsolidamentoAnnuoRivalutazioniContrattualiCode = get("code", codes.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty);
            const presenzaConsolidamentoAnnuoRivalutazioniContrattualiValue = get("value", codes.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty);
            const consolidamentoAnnuoRivalutazioniContrattuali = get("value", codes.consolidamentoAnnuoRivalutazioniContrattualiProperty);
            const fondoUtiliCode = get("code", codes.fondoUtiliProperty);
            const fondoUtiliValue = get("value", codes.fondoUtiliProperty);
            const invMinRamoIIIValue = get("value", codes.invMinRamoIIIProperty);
            const invMinRamoIIIValueSign = get("valueSign", codes.invMinRamoIIIProperty);
            const invMaxRamoIIIValue = get("value", codes.invMaxRamoIIIProperty);
            const invMaxRamoIIIValueSign = get("valueSign", codes.invMaxRamoIIIProperty);
            const numFondiInterni = get("value", codes.numFondiInterniProperty);
            const tipologiaFondiInterniValue = get("value", codes.tipologiaFondiInterniProperty);
            const tipologiaFondiInterniValues = get("values", codes.tipologiaFondiInterniProperty);
            const numOICRETFCode = get("code", codes.numOICRETFProperty);
            const numOICRETFValue = get("value", codes.numOICRETFProperty);
            const presenzaProtezioneCapitaleCode = get("code", codes.presenzaProtezioneCapitaleProperty);
            const presenzaProtezioneCapitaleValue = get("value", codes.presenzaProtezioneCapitaleProperty);
            const protezioneCapitale = get("value", codes.protezioneCapitaleProperty);
            const opzioniContrattualiTipologiaValues = get("values", codes.opzioniContrattualiTipologiaProperty);
            const cedola = get("value", codes.cedolaProperty);
            const decumulo = get("value", codes.decumuloProperty);
            const rendita = get("value", codes.renditaProperty);
            const stopLoss = get("value", codes.stopLossProperty);
            const takeProfit = get("value", codes.takeProfitProperty);
            const progressiveInvestment = get("value", codes.progressiveInvestmentProperty);
            const automaticRebalance = get("value", codes.automaticRebalanceProperty);
            const downtrendOpportunity = get("value", codes.downtrendOpportunityProperty);
            const lifeCycle = get("value", codes.lifeCycleProperty);
            const switchVal = get("value", codes.switchProperty);
            const altreOpzioniContrattuali = get("value", codes.altreOpzioniContrattualiProperty);
            const garanzieAssicurativeTipologiaValues = get("values", codes.garanzieAssicurativeTipologiaProperty);
            const maggiorazioneCasoMorteStandardCode = get("code", codes.maggiorazioneCasoMorteStandardProperty);
            const maggiorazioneCasoMorteStandardValue = get("value", codes.maggiorazioneCasoMorteStandardProperty);
            const maggiorazioneCasoMorteStandardPrestazione = get("value", codes.maggiorazioneCasoMorteStandardPrestazioneProperty);
            const maggiorazioneCasoMorteStandardPrestazioneStringList = get("stringList", codes.maggiorazioneCasoMorteStandardPrestazioneProperty);
            const maggiorazioneCasoMortePerInfortunioCode = get("code", codes.maggiorazioneCasoMortePerInfortunioProperty);
            const maggiorazioneCasoMortePerInfortunioValue = get("value", codes.maggiorazioneCasoMortePerInfortunioProperty);
            const maggiorazioneCasoMortePerInfortunioPrestazione = get("value", codes.maggiorazioneCasoMortePerInfortunioPrestazioneProperty);
            const maggiorazioneCasoMortePerIncidenteStradaleCode = get("code", codes.maggiorazioneCasoMortePerIncidenteStradaleProperty);
            const maggiorazioneCasoMortePerIncidenteStradaleValue = get("value", codes.maggiorazioneCasoMortePerIncidenteStradaleProperty);
            const maggiorazioneCasoMortePerIncidenteStradalePrestazione = get("value", codes.maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty);
            const maggiorazioneCasoMortePerMinusvalenzaCode = get("code", codes.maggiorazioneCasoMortePerMinusvalenzaProperty);
            const maggiorazioneCasoMortePerMinusvalenzaValue = get("value", codes.maggiorazioneCasoMortePerMinusvalenzaProperty);
            const maggiorazioneCasoMortePerMinusvalenzaPrestazione = get("value", codes.maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty);
            const TCMStandAloneCode = get("code", codes.TCMStandAloneProperty);
            const TCMStandAloneValue = get("value", codes.TCMStandAloneProperty);
            const TCMStandAlonePrestazione = get("value", codes.TCMStandAlonePrestazioneProperty);
            const longTermCareCode = get("code", codes.longTermCareProperty);
            const longTermCareValue = get("value", codes.longTermCareProperty);
            const longTermCarePrestazione = get("value", codes.longTermCarePrestazioneProperty);
            const dreadDiseaseCode = get("code", codes.dreadDiseaseProperty);
            const dreadDiseaseValue = get("value", codes.dreadDiseaseProperty);
            const dreadDiseasePrestazione = get("value", codes.dreadDiseasePrestazioneProperty);            
            const invaliditaInabilitaCode = get("code", codes.invaliditaInabilitaProperty);
            const invaliditaInabilitaValue = get("value", codes.invaliditaInabilitaProperty);
            const invaliditaInabilitaPrestazione = get("value", codes.invaliditaInabilitaPrestazioneProperty);
            const altreGaranzieAssicurative = get("value", codes.altreGaranzieAssicurativeProperty);
            const tipologiaBonusIngressoCode = get("code", codes.tipologiaBonusIngressoProperty);
            const tipologiaBonusIngressoValue = get("value", codes.tipologiaBonusIngressoProperty);
            const bonusIngresso = get("value", codes.bonusIngressoProperty);
            const bonusIngressoValueSign = get("valueSign", codes.bonusIngressoProperty);
            const bonusIngressoRangeValuesFlex = get("rangeValuesFlex", codes.bonusIngressoProperty);
            const tipologiaBonusFedeltaCode = get("code", codes.tipologiaBonusFedeltaProperty);
            const tipologiaBonusFedeltaValue = get("value", codes.tipologiaBonusFedeltaProperty);
            const bonusFedelta = get("value", codes.bonusFedeltaProperty);
            const bonusFedeltaRangeValuesFlex = get("rangeValuesFlex", codes.bonusFedeltaProperty);
            const speseEmissioneValue = get("value", codes.speseEmissioneProperty);
            const speseEmissioneValueSign = get("valueSign", codes.speseEmissioneProperty);
            const tipologiaCaricamentoPICCode = get("code", codes.tipologiaCaricamentoPICProperty);
            const tipologiaCaricamentoPICValue = get("value", codes.tipologiaCaricamentoPICProperty);
            const caricamentoPICValue = get("value", codes.caricamentoPICProperty);
            const caricamentoPICValueSign = get("valueSign", codes.caricamentoPICProperty);
            const caricamentoPICRangeValuesFlex = get("rangeValuesFlex", codes.caricamentoPICProperty);
            const tipologiaCaricamentoPACCode = get("code", codes.tipologiaCaricamentoPACProperty);
            const tipologiaCaricamentoPACValue = get("value", codes.tipologiaCaricamentoPACProperty);
            const caricamentoPACValue = get("value", codes.caricamentoPACProperty);
            const caricamentoPACValueSign = get("valueSign", codes.caricamentoPACProperty);
            const caricamentoPACRangeValuesFlex = get("rangeValuesFlex", codes.caricamentoPACProperty);
            const caricamentoValue = get("value", codes.caricamentoProperty);
            const caricamentoValueSign = get("valueSign", codes.caricamentoProperty);
            const tipologiaCommissioneGestioneSeparataCode = get("code", codes.tipologiaCommissioneGestioneSeparataProperty);
            const tipologiaCommissioneGestioneSeparataValue = get("value", codes.tipologiaCommissioneGestioneSeparataProperty);
            const commissioneGestioneSeparataValue = get("value", codes.commissioneGestioneSeparataProperty);
            const commissioneGestioneSeparataValueSign = get("valueSign", codes.commissioneGestioneSeparataProperty);
            const commissioneGestioneSeparataStringList = get("stringList", codes.commissioneGestioneSeparataProperty);
            const commissioneGestioneSeparataRangeValuesFlex = get("rangeValuesFlex", codes.commissioneGestioneSeparataProperty);
            const tipologiaCommissioneFondiInterniCode = get("code", codes.tipologiaCommissioneFondiInterniProperty);
            const tipologiaCommissioneFondiInterniValue = get("value", codes.tipologiaCommissioneFondiInterniProperty);
            const commissioneFondiInterniAzionariValue = get("value", codes.commissioneFondiInterniAzionariProperty);
            const commissioneFondiInterniAzionariValueSign = get("valueSign", codes.commissioneFondiInterniAzionariProperty);
            const commissioneFondiInterniAzionariRangeValuesFlex = get("rangeValuesFlex", codes.commissioneFondiInterniAzionariProperty);
            const commissioneFondiInterniObbligazionariValue = get("value", codes.commissioneFondiInterniObbligazionariProperty);
            const commissioneFondiInterniObbligazionariValueSign = get("valueSign", codes.commissioneFondiInterniObbligazionariProperty);
            const commissioneFondiInterniObbligazionariRangeValuesFlex = get("rangeValuesFlex", codes.commissioneFondiInterniObbligazionariProperty);
            const commissioneFondiInterniBilanciatiValue = get("value", codes.commissioneFondiInterniBilanciatiProperty);
            const commissioneFondiInterniBilanciatiValueSign = get("valueSign", codes.commissioneFondiInterniBilanciatiProperty);
            const commissioneFondiInterniBilanciatiRangeValuesFlex = get("rangeValuesFlex", codes.commissioneFondiInterniBilanciatiProperty);
            const commissioneFondiInterniFlessibiliValue = get("value", codes.commissioneFondiInterniFlessibiliProperty);
            const commissioneFondiInterniFlessibiliValueSign = get("valueSign", codes.commissioneFondiInterniFlessibiliProperty);
            const commissioneFondiInterniFlessibiliRangeValuesFlex = get("rangeValuesFlex", codes.commissioneFondiInterniFlessibiliProperty);
            const commissioneFondiInterniMonetariValue = get("value", codes.commissioneFondiInterniMonetariProperty);
            const commissioneFondiInterniMonetariValueSign = get("valueSign", codes.commissioneFondiInterniMonetariProperty);
            const commissioneFondiInterniMonetariRangeValuesFlex = get("rangeValuesFlex", codes.commissioneFondiInterniMonetariProperty);
            const commissioneSottostantiFondiInterniValue = get("value", codes.commissioneSottostantiFondiInterniProperty);
            const commissioneSottostantiFondiInterniStringList = get("stringList", codes.commissioneSottostantiFondiInterniProperty);
            const tipologiaSpeseGestionePolizzaOICRETFCode = get("code", codes.tipologiaSpeseGestionePolizzaOICRETFProperty);
            const tipologiaSpeseGestionePolizzaOICRETFValue = get("value", codes.tipologiaSpeseGestionePolizzaOICRETFProperty);
            const speseGestionePolizzaOICRETFAzionariValue = get("value", codes.speseGestionePolizzaOICRETFAzionariProperty);
            const speseGestionePolizzaOICRETFAzionariValueSign = get("valueSign", codes.speseGestionePolizzaOICRETFAzionariProperty);
            const speseGestionePolizzaOICRETFAzionariRangeValuesFlex = get("rangeValuesFlex", codes.speseGestionePolizzaOICRETFAzionariProperty);
            const speseGestionePolizzaOICRETFObbligazionariValue = get("value", codes.speseGestionePolizzaOICRETFObbligazionariProperty);
            const speseGestionePolizzaOICRETFObbligazionariValueSign = get("valueSign", codes.speseGestionePolizzaOICRETFObbligazionariProperty);
            const speseGestionePolizzaOICRETFObbligazionariRangeValuesFlex = get("rangeValuesFlex", codes.speseGestionePolizzaOICRETFObbligazionariProperty);
            const speseGestionePolizzaOICRETFBilanciatiValue = get("value", codes.speseGestionePolizzaOICRETFBilanciatiProperty);
            const speseGestionePolizzaOICRETFBilanciatiValueSign = get("valueSign", codes.speseGestionePolizzaOICRETFBilanciatiProperty);
            const speseGestionePolizzaOICRETFBilanciatiRangeValuesFlex = get("rangeValuesFlex", codes.speseGestionePolizzaOICRETFBilanciatiProperty);
            const speseGestionePolizzaOICRETFFlessibiliValue = get("value", codes.speseGestionePolizzaOICRETFFlessibiliProperty);
            const speseGestionePolizzaOICRETFFlessibiliValueSign = get("valueSign", codes.speseGestionePolizzaOICRETFFlessibiliProperty);
            const speseGestionePolizzaOICRETFFlessibiliRangeValuesFlex = get("rangeValuesFlex", codes.speseGestionePolizzaOICRETFFlessibiliProperty);
            const speseGestionePolizzaOICRETFMonetariValue = get("value", codes.speseGestionePolizzaOICRETFMonetariProperty);
            const speseGestionePolizzaOICRETFMonetariValueSign = get("valueSign", codes.speseGestionePolizzaOICRETFMonetariProperty);
            const speseGestionePolizzaOICRETFMonetariRangeValuesFlex = get("rangeValuesFlex", codes.speseGestionePolizzaOICRETFMonetariProperty);
            const commissioneOICRETFValue = get("value", codes.commissioneOICRETFProperty);
            const commissioneOICRETFStringList = get("stringList", codes.commissioneOICRETFProperty);
            const applicazioneCommissioniOverperformanceCode = get("code", codes.applicazioneCommissioniOverperformanceProperty);
            const applicazioneCommissioniOverperformanceValue = get("value", codes.applicazioneCommissioniOverperformanceProperty);
            const commissioniOverperformance = get("value", codes.commissioniOverperformanceProperty);
            const costoMaggiorazioneCasoMorteStandardValue = get("value", codes.costoMaggiorazioneCasoMorteStandardProperty);
            const costoMaggiorazioneCasoMorteStandardValueSign = get("valueSign", codes.costoMaggiorazioneCasoMorteStandardProperty);
            const riscatto = get("value", codes.riscattoProperty);
            const applicazioneCommissioniUscitaCode = get("code", codes.applicazioneCommissioniUscitaProperty);
            const applicazioneCommissioniUscitaValue = get("value", codes.applicazioneCommissioniUscitaProperty);
            const commissioniUscitaValue = get("value", codes.commissioniUscitaProperty);
            const commissioniUscitaStringList = get("stringList", codes.commissioniUscitaProperty);
            const altriCosti = get("value", codes.altriCostiProperty);
            const retrocessioneCaricamentoValue = get("value", codes.retrocessioneCaricamentoProperty);
            const retrocessioneCaricamentoStringList = get("stringList", codes.retrocessioneCaricamentoProperty);
            const retrocessioneGestioneSeparataValue = get("value", codes.retrocessioneGestioneSeparataProperty);
            const retrocessioneGestioneSeparataStringList = get("stringList", codes.retrocessioneGestioneSeparataProperty);
            const retrocessioneRamoIIIValue = get("value", codes.retrocessioneRamoIIIProperty);
            const retrocessioneRamoIIIStringList = get("stringList", codes.retrocessioneRamoIIIProperty);
            const note = get("value", codes.noteProperty);
            const codProdotto = get("value", codes.codProdottoProperty);

            // prodotto
            properties.prodottoProperty.value = prodotto;
            // codProdotto
            properties.codProdottoProperty.value = codProdotto;
            // piuTariffe
            selectChoices.piuVersioni = vm.prefillCodeValue(properties.piuVersioniProperty, piuVersioniCode, piuVersioniValue, selectChoices.piuVersioni, vm.piuVersioniOptions);
            // prodotti collegati
            properties.codProdCollegatiProperty.value = codProdottiCollegati;
            // compagnia
            selectChoices.compagnia = vm.prefillCodeValue(properties.compagniaProperty, compagniaCode, compagniaValue, selectChoices.compagnia, vm.compagniaOptions, compagniaExtCode);
            // mercato
            selectChoices.mercato = vm.prefillValues(properties.mercatoProperty, mercatoValues, selectChoices.mercato, vm.mercatoOptions);
            // canale
            selectChoices.canale = vm.prefillValues(properties.canaleProperty, canaleValues, selectChoices.canale, vm.canaleOptions);
            // distributori
            selectChoices.distributori = vm.prefillValues(properties.distributoriProperty, distributoriValues, selectChoices.distributori, vm.distributoriOptions);
            // tipologia prodotto
            selectChoices.tipologiaProdotto = vm.prefillCodeValue(properties.tipologiaProdottoProperty, tipologiaProdottoCode, tipologiaProdottoValue, selectChoices.tipologiaProdotto, vm.tipologiaProdottoOptions);
            // tipologia sottostanti
            selectChoices.tipologiaSottostanti = vm.prefillValues(properties.tipologiaSottostantiProperty, tipologiaSottostantiValues, selectChoices.tipologiaSottostanti,vm.tipologiaSottostantiOptions);
            // prodotto in commercio
            selectChoices.prodCommercio = vm.prefillCodeValue(properties.prodCommercioProperty, prodCommercioCode, prodCommercioValue, selectChoices.prodCommercio, vm.prodCommercioOptions);
            // inizio commercializzazione
            properties.inizioCommProperty.value = inizioComm;
            properties.inizioCommProperty.dateValue = vm.dateFromString(inizioComm);
            // fine commercializzazione
            properties.fineCommProperty.value = fineComm;
            properties.fineCommProperty.dateValue = vm.dateFromString(fineComm);
            // edizione DIP aggiuntivo
            properties.edizioneDIPAggProperty.value = edizioneDIPAgg;
            properties.edizioneDIPAggProperty.dateValue = vm.dateFromString(edizioneDIPAgg);
            // tipologia premio
            selectChoices.tipologiaPremio = vm.prefillCodeValue(properties.tipologiaPremioProperty, tipologiaPremioCode, tipologiaPremioValue, selectChoices.tipologiaPremio, vm.tipologiaPremioOptions);
            // durata contrattuale
            properties.durataContrattoProperty.value = durataContrattuale;
            // durata piano pagamento premi
            properties.durataPianoPagamentoPremiProperty.value = durataPianoPagamentoPremi;
            // importo minimo del premio unico
            properties.importoMinPremioUnicoProperty.value = importoMinPremioUnicoValue;
            properties.importoMinPremioUnicoProperty.valueSign = importoMinPremioUnicoValueSign;
            // importo massimo del premio unico
            properties.importoMaxPremioUnicoProperty.value = importoMaxPremioUnicoValue;
            properties.importoMaxPremioUnicoProperty.valueSign = importoMaxPremioUnicoValueSign;
            // importo minimo del premio ricorrente (annuo)
            properties.importoMinPremioRicAnnuoProperty.value = importoMinPremioRicAnnuoValue;
            properties.importoMinPremioRicAnnuoProperty.valueSign = importoMinPremioRicAnnuoValueSign;
            // importo massimo del premio ricorrente (annuo)
            properties.importoMaxPremioRicAnnuoProperty.value = importoMaxPremioRicAnnuoValue;
            properties.importoMaxPremioRicAnnuoProperty.valueSign = importoMaxPremioRicAnnuoValueSign;
            // target market
            properties.targetMarketProperty.value = targetMarket;
            // orizzonte temporale suggerito
            properties.orizzonteTemporaleSuggeritoProperty.value = orizzonteTemporaleSuggerito;
            properties.orizzonteTemporaleSuggeritoProperty.stringList = orizzonteTemporaleSuggeritoStringList;
            // indicatore sintetico di rischio
            properties.indicatoreSinteticoRischioProperty.value = indicatoreSinteticoRischio;
            properties.indicatoreSinteticoRischioProperty.stringList = indicatoreSinteticoRischioStringList;
            // reduction in Yield - Costi di ingresso
            properties.reductionInYieldCostiIngressoProperty.value = reductionInYieldCostiIngresso;
            properties.reductionInYieldCostiIngressoProperty.stringList = reductionInYieldCostiIngressoStringList;
            // reduction in Yield - Costi di uscita
            properties.reductionInYieldCostiUscitaProperty.value = reductionInYieldCostiUscita;
            properties.reductionInYieldCostiUscitaProperty.stringList = reductionInYieldCostiUscitaStringList;
            // reduction in Yield - Costi correnti
            properties.reductionInYieldCostiCorrentiProperty.value = reductionInYieldCostiCorrenti;
            properties.reductionInYieldCostiCorrentiProperty.stringList = reductionInYieldCostiCorrentiStringList;
            // asset allocation
            properties.assetAllocationProperty.value = assetAllocation;
            // investimento minimo in Gestione Separata
            properties.invMinGestioneSeparataProperty.value = invMinGestioneSeparataValue;
            properties.invMinGestioneSeparataProperty.valueSign = invMinGestioneSeparataValueSign;
            // investimento massimo in Gestione Separata
            properties.invMaxGestioneSeparataProperty.value = invMaxGestioneSeparataValue;
            properties.invMaxGestioneSeparataProperty.valueSign = invMaxGestioneSeparataValueSign;
            // gestione separata
            properties.gestioneSeparataProperty.value = gestioneSeparata;
            // ultimo rendimento certificato Gestione Separata
            properties.ultimoRendCertGestioneSeparataProperty.value = ultimoRendCertGestioneSeparataValue;
            properties.ultimoRendCertGestioneSeparataProperty.valueSign = ultimoRendCertGestioneSeparataValueSign;
            // anno rendimento certificato Gestione Separata
            properties.annoRendCertGestioneSeparataProperty.value = annoRendCertGestioneSeparata;
            // rendimento minimo garantito (Gestione Separata)
            selectChoices.rendMinGarantito = vm.prefillCodeValue(properties.rendMinGarantitoProperty, rendMinGarantitoCode, rendMinGarantitoValue, selectChoices.rendMinGarantito, vm.rendMinGarantitoOptions);
            // rendimento minimo garantito - misura (Gestione Separata)
            properties.rendMinGarantitoMisuraProperty.value = rendMinGarantitoMisura;
            // presenza consolidamento annuo delle rivalutazioni contrattuali
            selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali = vm.prefillCodeValue(properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty, presenzaConsolidamentoAnnuoRivalutazioniContrattualiCode, presenzaConsolidamentoAnnuoRivalutazioniContrattualiValue, selectChoices.presenzaConsolidamentoAnnuoRivalutazioniContrattuali, vm.presenzaConsolidamentoAnnuoRivalutazioniContrattualiOptions);
            // consolidamento annuo delle rivalutazioni contrattuali
            properties.consolidamentoAnnuoRivalutazioniContrattualiProperty.value = consolidamentoAnnuoRivalutazioniContrattuali;
            // fondo utili
            selectChoices.fondoUtili = vm.prefillCodeValue(properties.fondoUtiliProperty, fondoUtiliCode, fondoUtiliValue, selectChoices.fondoUtili, vm.fondoUtiliOptions);
            // investimento minimo in Ramo III
            properties.invMinRamoIIIProperty.value = invMinRamoIIIValue;
            properties.invMinRamoIIIProperty.valueSign = invMinRamoIIIValueSign;
            // investimento massimo in Ramo III
            properties.invMaxRamoIIIProperty.value = invMaxRamoIIIValue;
            properties.invMaxRamoIIIProperty.valueSign = invMaxRamoIIIValueSign;
            // numero fondi interni
            properties.numFondiInterniProperty.value = numFondiInterni;
            // tipologia fondi interni
            properties.tipologiaFondiInterniProperty.value = tipologiaFondiInterniValue;
            selectChoices.tipologiaFondiInterni = vm.prefillValues(properties.tipologiaFondiInterniProperty, tipologiaFondiInterniValues, selectChoices.tipologiaFondiInterni,vm.tipologiaFondiInterniOptions);
            // numero OICR/ETF
            selectChoices.numOICRETF = vm.prefillCodeValue(properties.numOICRETFProperty, numOICRETFCode, numOICRETFValue, selectChoices.numOICRETF, vm.numOICRETFOptions);
            // presenza protezione del capitale
            selectChoices.presenzaProtezioneCapitale = vm.prefillCodeValue(properties.presenzaProtezioneCapitaleProperty, presenzaProtezioneCapitaleCode, presenzaProtezioneCapitaleValue, selectChoices.presenzaProtezioneCapitale, vm.presenzaProtezioneCapitaleOptions);
            // protezione del capitale
            properties.protezioneCapitaleProperty.value = protezioneCapitale;
            // opzioni contrattuali - tipologia
            selectChoices.opzioniContrattualiTipologia = vm.prefillValues(properties.opzioniContrattualiTipologiaProperty, opzioniContrattualiTipologiaValues, selectChoices.opzioniContrattualiTipologia, vm.opzioniContrattualiTipologiaOptions);
            // cedola
            properties.cedolaProperty.value = cedola;
            // decumulo
            properties.decumuloProperty.value = decumulo;
            // rendita
            properties.renditaProperty.value = rendita;
            // stopLoss
            properties.stopLossProperty.value = stopLoss;
            // takeProfit
            properties.takeProfitProperty.value = takeProfit;
            // progressiveInvestment
            properties.progressiveInvestmentProperty.value = progressiveInvestment;
            // automaticRebalance
            properties.automaticRebalanceProperty.value = automaticRebalance;
            // downtrendOpportunity
            properties.downtrendOpportunityProperty.value = downtrendOpportunity;
            // lifeCycle
            properties.lifeCycleProperty.value = lifeCycle;
            // switch
            properties.switchProperty.value = switchVal;
            // progressiveInvestment
            properties.altreOpzioniContrattualiProperty.value = altreOpzioniContrattuali;
            // garanzie assicurative - tipologia
            selectChoices.garanzieAssicurativeTipologia = vm.prefillValues(properties.garanzieAssicurativeTipologiaProperty, garanzieAssicurativeTipologiaValues, selectChoices.garanzieAssicurativeTipologia, vm.garanzieAssicurativeTipologiaOptions);
            // maggiorazione caso morte standard
            selectChoices.maggiorazioneCasoMorteStandard = vm.prefillCodeValue(properties.maggiorazioneCasoMorteStandardProperty, maggiorazioneCasoMorteStandardCode, maggiorazioneCasoMorteStandardValue, selectChoices.maggiorazioneCasoMorteStandard, vm.maggiorazioneCasoMorteStandardOptions);
            // maggiorazione caso morte standard - prestazione
            properties.maggiorazioneCasoMorteStandardPrestazioneProperty.value = maggiorazioneCasoMorteStandardPrestazione;
            properties.maggiorazioneCasoMorteStandardPrestazioneProperty.stringList = maggiorazioneCasoMorteStandardPrestazioneStringList;
            // maggiorazione caso morte per infortunio
            selectChoices.maggiorazioneCasoMortePerInfortunio = vm.prefillCodeValue(properties.maggiorazioneCasoMortePerInfortunioProperty, maggiorazioneCasoMortePerInfortunioCode, maggiorazioneCasoMortePerInfortunioValue, selectChoices.maggiorazioneCasoMortePerInfortunio, vm.maggiorazioneCasoMortePerInfortunioOptions);
            // maggiorazione caso morte per infortunio - prestazione
            properties.maggiorazioneCasoMortePerInfortunioPrestazioneProperty.value = maggiorazioneCasoMortePerInfortunioPrestazione;
            // maggiorazione caso morte per incidente stradale
            selectChoices.maggiorazioneCasoMortePerIncidenteStradale = vm.prefillCodeValue(properties.maggiorazioneCasoMortePerIncidenteStradaleProperty, maggiorazioneCasoMortePerIncidenteStradaleCode, maggiorazioneCasoMortePerIncidenteStradaleValue, selectChoices.maggiorazioneCasoMortePerIncidenteStradale, vm.maggiorazioneCasoMortePerIncidenteStradaleOptions);
            // maggiorazione caso morte per incidente stradale - prestazione
            properties.maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty.value = maggiorazioneCasoMortePerIncidenteStradalePrestazione;
            // maggiorazione caso morte per minusvalenza
            selectChoices.maggiorazioneCasoMortePerMinusvalenza = vm.prefillCodeValue(properties.maggiorazioneCasoMortePerMinusvalenzaProperty, maggiorazioneCasoMortePerMinusvalenzaCode, maggiorazioneCasoMortePerMinusvalenzaValue, selectChoices.maggiorazioneCasoMortePerMinusvalenza, vm.maggiorazioneCasoMortePerMinusvalenzaOptions);
            // maggiorazione caso morte per minusvalenza - prestazione
            properties.maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty.value = maggiorazioneCasoMortePerMinusvalenzaPrestazione;
            // TCM stand alone
            selectChoices.TCMStandAlone = vm.prefillCodeValue(properties.TCMStandAloneProperty, TCMStandAloneCode, TCMStandAloneValue, selectChoices.TCMStandAlone, vm.TCMStandAloneOptions);
            // TCM stand alone - prestazione
            properties.TCMStandAlonePrestazioneProperty.value = TCMStandAlonePrestazione;
            // long term care
            selectChoices.longTermCare = vm.prefillCodeValue(properties.longTermCareProperty, longTermCareCode, longTermCareValue, selectChoices.longTermCare, vm.longTermCareOptions);
            // long term care - prestazione
            properties.longTermCarePrestazioneProperty.value = longTermCarePrestazione;
            // dread disease
            selectChoices.dreadDisease = vm.prefillCodeValue(properties.dreadDiseaseProperty, dreadDiseaseCode, dreadDiseaseValue, selectChoices.dreadDisease, vm.dreadDiseaseOptions);
            // dread disease - prestazione
            properties.dreadDiseasePrestazioneProperty.value = dreadDiseasePrestazione;
            // invalidità/inabilità
            selectChoices.invaliditaInabilita = vm.prefillCodeValue(properties.invaliditaInabilitaProperty, invaliditaInabilitaCode, invaliditaInabilitaValue, selectChoices.invaliditaInabilita, vm.invaliditaInabilitaOptions);
            // invalidità/inabilità - prestazione
            properties.invaliditaInabilitaPrestazioneProperty.value = invaliditaInabilitaPrestazione;
            // invalidità/inabilità - prestazione
            properties.altreGaranzieAssicurativeProperty.value = altreGaranzieAssicurative;
            // tipologia bonus d’ingresso
            selectChoices.tipologiaBonusIngresso = vm.prefillCodeValue(properties.tipologiaBonusIngressoProperty, tipologiaBonusIngressoCode, tipologiaBonusIngressoValue, selectChoices.tipologiaBonusIngresso, vm.tipologiaBonusIngressoOptions);
            // bonus d’ingresso
            properties.bonusIngressoProperty.value = bonusIngresso;
            properties.bonusIngressoProperty.valueSign = bonusIngressoValueSign;
            properties.bonusIngressoProperty.rangeValuesFlex = bonusIngressoRangeValuesFlex;
            // tipologia bonus d’ingresso
            selectChoices.tipologiaBonusFedelta = vm.prefillCodeValue(properties.tipologiaBonusFedeltaProperty, tipologiaBonusFedeltaCode, tipologiaBonusFedeltaValue, selectChoices.tipologiaBonusFedelta, vm.tipologiaBonusFedeltaOptions);
            // bonus d’ingresso
            properties.bonusFedeltaProperty.value = bonusFedelta;
            properties.bonusFedeltaProperty.rangeValuesFlex = bonusFedeltaRangeValuesFlex;
            // spese di emissione
            properties.speseEmissioneProperty.value = speseEmissioneValue;
            properties.speseEmissioneProperty.valueSign = speseEmissioneValueSign;
            // tipologia caricamento PIC
            selectChoices.tipologiaCaricamentoPIC = vm.prefillCodeValue(properties.tipologiaCaricamentoPICProperty, tipologiaCaricamentoPICCode, tipologiaCaricamentoPICValue, selectChoices.tipologiaCaricamentoPIC, vm.tipologiaCaricamentoPICOptions);
            // caricamento PIC
            properties.caricamentoPICProperty.value = caricamentoPICValue;
            properties.caricamentoPICProperty.valueSign = caricamentoPICValueSign;
            properties.caricamentoPICProperty.rangeValuesFlex = caricamentoPICRangeValuesFlex;
            // tipologia caricamento PAC
            selectChoices.tipologiaCaricamentoPAC = vm.prefillCodeValue(properties.tipologiaCaricamentoPACProperty, tipologiaCaricamentoPACCode, tipologiaCaricamentoPACValue, selectChoices.tipologiaCaricamentoPAC, vm.tipologiaCaricamentoPACOptions);
            // caricamento PIC
            properties.caricamentoPACProperty.value = caricamentoPACValue;
            properties.caricamentoPACProperty.valueSign = caricamentoPACValueSign;
            properties.caricamentoPACProperty.rangeValuesFlex = caricamentoPACRangeValuesFlex;
            // caricamento (€)
            properties.caricamentoProperty.value = caricamentoValue;
            properties.caricamentoProperty.valueSign = caricamentoValueSign;
            // tipologia commissione gestione separata
            selectChoices.tipologiaCommissioneGestioneSeparata = vm.prefillCodeValue(properties.tipologiaCommissioneGestioneSeparataProperty, tipologiaCommissioneGestioneSeparataCode, tipologiaCommissioneGestioneSeparataValue, selectChoices.tipologiaCommissioneGestioneSeparata, vm.tipologiaCommissioneGestioneSeparataOptions);
            // commissione gestione separata
            properties.commissioneGestioneSeparataProperty.value = commissioneGestioneSeparataValue;
            properties.commissioneGestioneSeparataProperty.valueSign = commissioneGestioneSeparataValueSign;
            properties.commissioneGestioneSeparataProperty.stringList = commissioneGestioneSeparataStringList;
            properties.commissioneGestioneSeparataProperty.rangeValuesFlex = commissioneGestioneSeparataRangeValuesFlex;
            // tipologia commissione fondi interni
            selectChoices.tipologiaCommissioneFondiInterni = vm.prefillCodeValue(properties.tipologiaCommissioneFondiInterniProperty, tipologiaCommissioneFondiInterniCode, tipologiaCommissioneFondiInterniValue, selectChoices.tipologiaCommissioneFondiInterni, vm.tipologiaCommissioneFondiInterniOptions);
            // commissione fondi interni azionari
            properties.commissioneFondiInterniAzionariProperty.value = commissioneFondiInterniAzionariValue;
            properties.commissioneFondiInterniAzionariProperty.valueSign = commissioneFondiInterniAzionariValueSign;
            properties.commissioneFondiInterniAzionariProperty.rangeValuesFlex = commissioneFondiInterniAzionariRangeValuesFlex;
            // commissione fondi interni obbligazionari
            properties.commissioneFondiInterniObbligazionariProperty.value = commissioneFondiInterniObbligazionariValue;
            properties.commissioneFondiInterniObbligazionariProperty.valueSign = commissioneFondiInterniObbligazionariValueSign;
            properties.commissioneFondiInterniObbligazionariProperty.rangeValuesFlex = commissioneFondiInterniObbligazionariRangeValuesFlex;
            // commissione fondi interni bilanciati
            properties.commissioneFondiInterniBilanciatiProperty.value = commissioneFondiInterniBilanciatiValue;
            properties.commissioneFondiInterniBilanciatiProperty.valueSign = commissioneFondiInterniBilanciatiValueSign;
            properties.commissioneFondiInterniBilanciatiProperty.rangeValuesFlex = commissioneFondiInterniBilanciatiRangeValuesFlex;
            // commissione fondi interni flessibili
            properties.commissioneFondiInterniFlessibiliProperty.value = commissioneFondiInterniFlessibiliValue;
            properties.commissioneFondiInterniFlessibiliProperty.valueSign = commissioneFondiInterniFlessibiliValueSign;
            properties.commissioneFondiInterniFlessibiliProperty.rangeValuesFlex = commissioneFondiInterniFlessibiliRangeValuesFlex;
            // commissione fondi interni monetari
            properties.commissioneFondiInterniMonetariProperty.value = commissioneFondiInterniMonetariValue;
            properties.commissioneFondiInterniMonetariProperty.valueSign = commissioneFondiInterniMonetariValueSign;
            properties.commissioneFondiInterniMonetariProperty.rangeValuesFlex = commissioneFondiInterniMonetariRangeValuesFlex;
            // commissione sottostanti fondi interni
            properties.commissioneSottostantiFondiInterniProperty.value = commissioneSottostantiFondiInterniValue;
            properties.commissioneSottostantiFondiInterniProperty.stringList = commissioneSottostantiFondiInterniStringList;
            // tipologia spese gestione polizza (OICR/ETF)
            selectChoices.tipologiaSpeseGestionePolizzaOICRETF = vm.prefillCodeValue(properties.tipologiaSpeseGestionePolizzaOICRETFProperty, tipologiaSpeseGestionePolizzaOICRETFCode, tipologiaSpeseGestionePolizzaOICRETFValue, selectChoices.tipologiaSpeseGestionePolizzaOICRETF, vm.tipologiaSpeseGestionePolizzaOICRETFOptions);
            // spese gestione polizza OICR/ETF azionari
            properties.speseGestionePolizzaOICRETFAzionariProperty.value = speseGestionePolizzaOICRETFAzionariValue;
            properties.speseGestionePolizzaOICRETFAzionariProperty.valueSign = speseGestionePolizzaOICRETFAzionariValueSign;
            properties.speseGestionePolizzaOICRETFAzionariProperty.rangeValuesFlex = speseGestionePolizzaOICRETFAzionariRangeValuesFlex;
            // spese gestione polizza OICR/ETF obbligazionari
            properties.speseGestionePolizzaOICRETFObbligazionariProperty.value = speseGestionePolizzaOICRETFObbligazionariValue;
            properties.speseGestionePolizzaOICRETFObbligazionariProperty.valueSign = speseGestionePolizzaOICRETFObbligazionariValueSign;
            properties.speseGestionePolizzaOICRETFObbligazionariProperty.rangeValuesFlex = speseGestionePolizzaOICRETFObbligazionariRangeValuesFlex;
            // spese gestione polizza OICR/ETF bilanciati
            properties.speseGestionePolizzaOICRETFBilanciatiProperty.value = speseGestionePolizzaOICRETFBilanciatiValue;
            properties.speseGestionePolizzaOICRETFBilanciatiProperty.valueSign = speseGestionePolizzaOICRETFBilanciatiValueSign;
            properties.speseGestionePolizzaOICRETFBilanciatiProperty.rangeValuesFlex = speseGestionePolizzaOICRETFBilanciatiRangeValuesFlex;
            // spese gestione polizza OICR/ETF flessibili
            properties.speseGestionePolizzaOICRETFFlessibiliProperty.value = speseGestionePolizzaOICRETFFlessibiliValue;
            properties.speseGestionePolizzaOICRETFFlessibiliProperty.valueSign = speseGestionePolizzaOICRETFFlessibiliValueSign;
            properties.speseGestionePolizzaOICRETFFlessibiliProperty.rangeValuesFlex = speseGestionePolizzaOICRETFFlessibiliRangeValuesFlex;
            // spese gestione polizza OICR/ETF monetari
            properties.speseGestionePolizzaOICRETFMonetariProperty.value = speseGestionePolizzaOICRETFMonetariValue;
            properties.speseGestionePolizzaOICRETFMonetariProperty.valueSign = speseGestionePolizzaOICRETFMonetariValueSign;
            properties.speseGestionePolizzaOICRETFMonetariProperty.rangeValuesFlex = speseGestionePolizzaOICRETFMonetariRangeValuesFlex;
            // commissione OICR/ETF
            properties.commissioneOICRETFProperty.value = commissioneOICRETFValue;
            properties.commissioneOICRETFProperty.stringList = commissioneOICRETFStringList;
            // applicazione commissioni di overperformance
            selectChoices.applicazioneCommissioniOverperformance = vm.prefillCodeValue(properties.applicazioneCommissioniOverperformanceProperty, applicazioneCommissioniOverperformanceCode, applicazioneCommissioniOverperformanceValue, selectChoices.applicazioneCommissioniOverperformance, vm.applicazioneCommissioniOverperformanceOptions);
            // commissioni di overperformance
            properties.commissioniOverperformanceProperty.value = commissioniOverperformance;
            // costo maggiorazione caso morte standard (%)
            properties.costoMaggiorazioneCasoMorteStandardProperty.value = costoMaggiorazioneCasoMorteStandardValue;
            properties.costoMaggiorazioneCasoMorteStandardProperty.valueSign = costoMaggiorazioneCasoMorteStandardValueSign;
            // riscatto
            properties.riscattoProperty.value = riscatto;
            // applicazione commissioni di uscita
            selectChoices.applicazioneCommissioniUscita = vm.prefillCodeValue(properties.applicazioneCommissioniUscitaProperty, applicazioneCommissioniUscitaCode, applicazioneCommissioniUscitaValue, selectChoices.applicazioneCommissioniUscita, vm.applicazioneCommissioniUscitaOptions);
            // commissioni di uscita (%)
            properties.commissioniUscitaProperty.value = commissioniUscitaValue;
            properties.commissioniUscitaProperty.stringList = commissioniUscitaStringList;
            // altri costi
            properties.altriCostiProperty.value = altriCosti;
            // retrocessione caricamento
            properties.retrocessioneCaricamentoProperty.value = retrocessioneCaricamentoValue;
            properties.retrocessioneCaricamentoProperty.stringList = retrocessioneCaricamentoStringList;
            // retrocessione gestione separata
            properties.retrocessioneGestioneSeparataProperty.value = retrocessioneGestioneSeparataValue;
            properties.retrocessioneGestioneSeparataProperty.stringList = retrocessioneGestioneSeparataStringList;
            // retrocessione ramo III
            properties.retrocessioneRamoIIIProperty.value = retrocessioneRamoIIIValue;
            properties.retrocessioneRamoIIIProperty.stringList = retrocessioneRamoIIIStringList;
            // note
            properties.noteProperty.value = note;
          })
          .catch((e) => {
            console.error(e);
            vm.openModalError();
          })

        vm.stopLoading();
      } else {
        /*vm.changePiuVersioni();
        vm.changeTipologiaSottostanti();
        vm.changeProdCommercio();
        vm.changeTipologiaPremio();
        vm.changeRendMinGarantito();
        vm.changeTipologiaFondiInterni();
        */
      }

      vm.initPiuVersioni();
      vm.initTipologiaSottostanti();
      vm.initProdCommercio();
      vm.initOpzioniContrattualiTipologia();
      vm.initGaranzieAssicurativeTipologia();
      vm.initTipologiaPremio();
      vm.initRendMinGarantito();
      vm.initTipologiaFondiInterni();
      vm.initTipologiaCaricamentoPIC();
      vm.initTipologiaCaricamentoPAC();

      vm.changePiuVersioni();
      vm.changeTipologiaSottostanti();
      vm.changeProdCommercio();
      vm.changeOpzioniContrattualiTipologia();
      vm.changeGaranzieAssicurativeTipologia();
      vm.changeTipologiaPremio();
      vm.changeRendMinGarantito();
      vm.changeTipologiaFondiInterni();
      vm.changeTipologiaCaricamentoPIC();
      vm.changeTipologiaCaricamentoPAC();

      vm.stopLoading();
    },
    setDatePropertiesValue() {
      const vm = this as any;

      properties.inizioCommProperty.value = vm.formatDate(properties.inizioCommProperty.dateValue);
      if (properties.prodCommercioProperty.code == "8.2") {
        properties.fineCommProperty.value = vm.formatDate(properties.fineCommProperty.dateValue);
      }
      properties.edizioneDIPAggProperty.value = vm.formatDate(properties.edizioneDIPAggProperty.dateValue);
    },
    preparePropList() {
      const vm = this as any;

      Vue.set(properties.orizzonteTemporaleSuggeritoProperty, 'nodashed', true);
      Vue.set(properties.indicatoreSinteticoRischioProperty, 'nodashed', true);
      Vue.set(properties.reductionInYieldCostiIngressoProperty, 'nodashed', true);
      Vue.set(properties.reductionInYieldCostiUscitaProperty, 'nodashed', true);
      Vue.set(properties.reductionInYieldCostiCorrentiProperty, 'nodashed', true);
      Vue.set(properties.maggiorazioneCasoMorteStandardPrestazioneProperty, 'nodashed', true);
      Vue.set(properties.commissioneGestioneSeparataProperty, 'nodashed', true);
      Vue.set(properties.commissioneSottostantiFondiInterniProperty, 'nodashed', true);
      Vue.set(properties.commissioneOICRETFProperty, 'nodashed', true);
      Vue.set(properties.commissioniUscitaProperty, 'nodashed', true);
      Vue.set(properties.retrocessioneCaricamentoProperty, 'nodashed', true);
      Vue.set(properties.retrocessioneGestioneSeparataProperty, 'nodashed', true);
      Vue.set(properties.retrocessioneRamoIIIProperty, 'nodashed', true);      

      vm.setDatePropertiesValue();

      vm.propList = [
        properties.prodottoProperty,
        properties.piuVersioniProperty,
        properties.codProdCollegatiProperty,
        properties.compagniaProperty,
        properties.mercatoProperty,
        properties.canaleProperty,
        properties.distributoriProperty,
        properties.tipologiaProdottoProperty,
        properties.tipologiaSottostantiProperty,
        properties.prodCommercioProperty,
        properties.inizioCommProperty,
        properties.fineCommProperty,
        properties.edizioneDIPAggProperty,
        properties.tipologiaPremioProperty,
        properties.durataContrattoProperty,
        properties.durataPianoPagamentoPremiProperty,
        properties.importoMinPremioUnicoProperty,
        properties.importoMaxPremioUnicoProperty,
        properties.importoMinPremioRicAnnuoProperty,
        properties.importoMaxPremioRicAnnuoProperty,
        properties.targetMarketProperty,
        properties.orizzonteTemporaleSuggeritoProperty,
        properties.indicatoreSinteticoRischioProperty,
        properties.reductionInYieldCostiIngressoProperty,
        properties.reductionInYieldCostiUscitaProperty,
        properties.reductionInYieldCostiCorrentiProperty,
        properties.assetAllocationProperty,
        properties.invMinGestioneSeparataProperty,
        properties.invMaxGestioneSeparataProperty,
        properties.gestioneSeparataProperty,
        properties.ultimoRendCertGestioneSeparataProperty,
        properties.annoRendCertGestioneSeparataProperty,
        properties.rendMinGarantitoProperty,
        properties.rendMinGarantitoMisuraProperty,
        properties.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty,
        properties.consolidamentoAnnuoRivalutazioniContrattualiProperty,
        properties.fondoUtiliProperty,
        properties.invMinRamoIIIProperty,
        properties.invMaxRamoIIIProperty,
        properties.numFondiInterniProperty,
        properties.tipologiaFondiInterniProperty,
        properties.numOICRETFProperty,
        properties.presenzaProtezioneCapitaleProperty,
        properties.protezioneCapitaleProperty,
        properties.opzioniContrattualiTipologiaProperty,
        properties.cedolaProperty,
        properties.decumuloProperty,
        properties.renditaProperty,
        properties.stopLossProperty,
        properties.takeProfitProperty,
        properties.progressiveInvestmentProperty,
        properties.automaticRebalanceProperty,
        properties.downtrendOpportunityProperty,
        properties.lifeCycleProperty,
        properties.switchProperty,
        properties.altreOpzioniContrattualiProperty,
        properties.garanzieAssicurativeTipologiaProperty,
        properties.maggiorazioneCasoMorteStandardProperty,
        properties.maggiorazioneCasoMorteStandardPrestazioneProperty,
        properties.maggiorazioneCasoMortePerInfortunioProperty,
        properties.maggiorazioneCasoMortePerInfortunioPrestazioneProperty,
        properties.maggiorazioneCasoMortePerIncidenteStradaleProperty,
        properties.maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty,
        properties.maggiorazioneCasoMortePerMinusvalenzaProperty,
        properties.maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty,
        properties.TCMStandAloneProperty,
        properties.TCMStandAlonePrestazioneProperty,
        properties.longTermCareProperty,
        properties.longTermCarePrestazioneProperty,
        properties.dreadDiseaseProperty,
        properties.dreadDiseasePrestazioneProperty,
        properties.invaliditaInabilitaProperty,
        properties.invaliditaInabilitaPrestazioneProperty,
        properties.altreGaranzieAssicurativeProperty,
        properties.tipologiaBonusIngressoProperty,
        properties.bonusIngressoProperty,
        properties.tipologiaBonusFedeltaProperty,
        properties.bonusFedeltaProperty,
        properties.speseEmissioneProperty,
        properties.tipologiaCaricamentoPICProperty,
        properties.caricamentoPICProperty,
        properties.tipologiaCaricamentoPACProperty,
        properties.caricamentoPACProperty,
        properties.caricamentoProperty,
        properties.tipologiaCommissioneGestioneSeparataProperty,
        properties.commissioneGestioneSeparataProperty,
        properties.tipologiaCommissioneFondiInterniProperty,
        properties.commissioneFondiInterniAzionariProperty,
        properties.commissioneFondiInterniObbligazionariProperty,
        properties.commissioneFondiInterniBilanciatiProperty,
        properties.commissioneFondiInterniFlessibiliProperty,
        properties.commissioneFondiInterniMonetariProperty,
        properties.commissioneSottostantiFondiInterniProperty,
        properties.tipologiaSpeseGestionePolizzaOICRETFProperty,
        properties.speseGestionePolizzaOICRETFAzionariProperty,
        properties.speseGestionePolizzaOICRETFObbligazionariProperty,
        properties.speseGestionePolizzaOICRETFBilanciatiProperty,
        properties.speseGestionePolizzaOICRETFFlessibiliProperty,
        properties.speseGestionePolizzaOICRETFMonetariProperty,
        properties.commissioneOICRETFProperty,
        properties.applicazioneCommissioniOverperformanceProperty,
        properties.commissioniOverperformanceProperty,
        properties.costoMaggiorazioneCasoMorteStandardProperty,
        properties.riscattoProperty,
        properties.applicazioneCommissioniUscitaProperty,
        properties.commissioniUscitaProperty,
        properties.altriCostiProperty,
        properties.retrocessioneCaricamentoProperty,
        properties.retrocessioneGestioneSeparataProperty,
        properties.retrocessioneRamoIIIProperty,
        properties.noteProperty,
        properties.codProdottoProperty,
      ];
    },
    inserisciProdotto: async function() {
      const vm = this as any;
      vm.startLoading();
      let productId = undefined;

      if (vm.productIdSelected === undefined) {
        let nuovoProdotto = {} as any;
        nuovoProdotto = await vm.registraProdotto();
        if (nuovoProdotto == undefined) {
          vm.stopLoading();
          vm.openModalError();
        } else {
          productId = nuovoProdotto.productId;
        }
      } else {
        productId = vm.productIdSelected;
      }

      if (productId === undefined) {
        vm.stopLoading();
        vm.openModalError();
      } else {
        //FINE FUNZIONI DI MAPPING
        vm.valorizzaTendine();

        vm.setDatePropertiesValue();

        vm.setPropertiesDefaultCode();

        vm.preparePropList();

        const serviceCallReturnValue = await requestService
          .addProductPropertyList({
            productId: productId,
            propertyList: vm.propList
          })
          .then(handleResponse)
          .then((result: any) => {
            if (!isNil(result.productId)) {
              vm.esitoRegistrazione = "Registrazione avvenuta con successo";
            } else {
              vm.esitoRegistrazione = "Registrazione KO";
            }

            return result.productId;
          })
          .catch(() => {
            vm.openModalError();
          });

        vm.stopLoading();

        vm.closeModalConfirm();

        vm.openModalConfirmOutcome();
      }
    },
    registraProdotto: async function() {
      const cc = this.customCategory || 'protezione-investimento';
      return requestService.initProductWithCustomCategory(categories.VITA_INVESTIMENTO, cc).then(handleResponse);
    },
    selectedFile: function(fileList: any[]) {
      if (!fileList.length) return;
      this.massiveFile = fileList[0];
    },
    uploadMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.uploadMassive(categories.VITA_INVESTIMENTO, vm.massiveFile)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          if (result !== undefined) {
            vm.massiveLoaded = true;
            vm.massiveResult = result;
          } else {
            vm.closeModalMassivo();
            vm.openModalError("Non è stato possibile caricare il file.");
          }
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile caricare il file.");
        });
    },
    confirmMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.confirmMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Prodotti caricati.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile confermare i dati caricati.");
        });
    },
    deleteMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.deleteMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Caricamento massivo annullato.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.closeModalMassivo();
        });
    },
    printVersatileValues(property: any) {
      const vm = this as any;

      const noDashed = (property.nodashed === undefined || property.nodashed === null) ? false : property.nodashed;

      let isPrintStringList = false;
      if (property.type == propertyTypes.STRING_LIST) {
        isPrintStringList = true;
      } else if (property.stringList !== undefined && property.stringList !== null) {
        if (property.stringList.length > 0) {
          isPrintStringList = true;
        }
      }

      let printableValue = "";
      let tooltipValue = "";
      if (property.type == propertyTypes.VALUES) {
        if (property.values.length > 0) {
          //property.values.sort(vm._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            printableValue = item.description;
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + item.description + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + item.description + "</li>";
            }).join("");

            printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class='dashed'>" + tooltipLi + "</ul></div>";
            }
          }
        } else {
          printableValue = property.value;
        }
      } else if (isPrintStringList) {
        if (property.value !== "") {
          printableValue = property.value;
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          printableValue = vm.printStringListItem(item);
        } else if (noDashed === undefined || !noDashed) {
          const maxLi = 3;
          let liCounter = 0;
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            let valueLabel = (item.valueLabel !== undefined && !vm.isEmptyOrSpaces(item.valueLabel) ) ? item.valueLabel + " " : "";
            liCounter++;
            if (liCounter < maxLi) {
              li += "<li>" + valueLabel + item.value + item.valueSign + "</li>";
            } else if (liCounter == maxLi) {
              li += "<li>" + '...' + "</li>";
            }
            return "<li>" + valueLabel + item.value + item.valueSign + "</li>";
          }).join("");

          printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
          if (liCounter >= maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
          }
        } else if (noDashed) {
          let equalValues = (property.stringList.length == 2 && property.stringList[0].value == property.stringList[1].value && property.stringList[0].valueSign == property.stringList[1].valueSign);
          if (equalValues) {
            if (property.stringList[0].valueSignLeft) {
              printableValue = property.stringList[0].valueSign + " " + property.stringList[0].value;
            } else {
              printableValue = property.stringList[0].value + property.stringList[0].valueSign;
            }
          } else {
            const li = property.stringList.map(function(item: any) {
              return "<li>" + vm.printStringListItem(item) + "</li>";
            }).join("");
            printableValue = "<ul class='nodashed'>" + li + "</ul>";
          }
        }
      } else if (property.type == propertyTypes.RANGE_FLEX) {
        let isNestedRangeValuesFlex = false;

        if (property.rangeValuesFlex.length > 0) {
          const maxLi = 3;
          let liCounter = 0;
          let liItemsPV = "";
          let liItemsTV = "";
          property.rangeValuesFlex.forEach((item: any) => {
            liCounter++;

            const label = (item.label !== undefined && !vm.isEmptyOrSpaces(item.label)) ? item.label + " " : "";

            const spacingFrom = item.fromSignLeft || item.fromSign.indexOf('ann') >= 0 ? ' ' : '';
            const from = item.fromSignLeft ? item.fromSign + spacingFrom + item.from : item.from + spacingFrom + item.fromSign;
            
            const spacingTo = item.toSignLeft || item.toSign.indexOf('ann') >= 0 ? ' ' : '';
            const to = item.toSignLeft ? item.toSign + spacingTo + item.to : item.to + spacingTo + item.toSign;

            let value = undefined;
            if (item.showValue) {
              const spacingValue = item.valueSignLeft || item.valueSign.indexOf('ann') >= 0 ? ' ' : '';
              value = item.valueSignLeft ? item.valueSign + spacingValue + item.value : item.value + spacingValue + item.valueSign;
            }
            // liItem
            let liItem =  label + from + " " + item.fromToOperator + " " + to;
            if (value !== undefined) {
              liItem +=  " " + item.toValueOperator + " " + value;
            }
            // printableValue
            if (liCounter < maxLi) {
              liItemsPV += "<li>" + liItem + "</li>";
            } else if (liCounter == maxLi) {
              liItemsPV += "<li>" + '...' + "</li>";
            }
            // tooltipValue
            liItemsTV += "<li>" + liItem + "</li>";

            // L2
            let liItemsPVL2 = "";
            let liItemsTVL2 = "";
            const noDashSpace = "&nbsp;&nbsp;&nbsp;&nbsp;";
            if (item.rangeValuesFlex !== undefined && item.rangeValuesFlex !== null) {
              if (item.rangeValuesFlex.length > 0) {
                isNestedRangeValuesFlex = true;

                item.rangeValuesFlex.forEach(function(itemL2: any) {
                  liCounter++;

                  const isLabelL2 = (itemL2.label !== undefined && !vm.isEmptyOrSpaces(itemL2.label));
                  const labelL2 = isLabelL2 ? "-&nbsp;&nbsp;" + itemL2.label + " " : "";

                  const spacingFromL2 = itemL2.fromSignLeft || itemL2.fromSign.indexOf('ann') >= 0 ? ' ' : '';
                  const fromL2 = itemL2.fromSignLeft ? itemL2.fromSign + spacingFromL2 + itemL2.from : itemL2.from + spacingFromL2 + itemL2.fromSign;

                  const spacingToL2 = itemL2.toSignLeft || itemL2.toSign.indexOf('ann') >= 0 ? ' ' : '';
                  const toL2 = itemL2.toSignLeft ? itemL2.toSign + spacingToL2 + itemL2.to : itemL2.to + spacingToL2 + itemL2.toSign;

                  let valueL2 = undefined;
                  if (itemL2.showValue) {
                    const spacingValueL2 = itemL2.valueSignLeft || itemL2.valueSign.indexOf('ann') >= 0 ? ' ' : '';
                    valueL2 = itemL2.valueSignLeft ? itemL2.valueSign + spacingValueL2 + itemL2.value : itemL2.value + spacingValueL2 + itemL2.valueSign;
                  }
                  let liItemL2 = fromL2 + " " + itemL2.fromToOperator + " " + toL2;
                  if (valueL2 !== undefined) {
                    liItemL2 +=  " " + itemL2.toValueOperator + " " + valueL2;
                  }
                  // printableValue L2
                  if (liCounter < maxLi) {
                    if (isLabelL2 && liCounter < maxLi) {
                      liItemsPVL2 += isLabelL2 ? "<li>" + labelL2 + "</li>" : "";
                      liCounter++;
                    }
                  }
                  if (liCounter < maxLi) {
                    liItemsPVL2 += "<li>" + noDashSpace + liItemL2 + "</li>";
                  } else if (liCounter == maxLi) {
                    liItemsPVL2 += "<li>" + '...' + "</li>";
                  }
                  // tooltipValue L2
                  liItemsTVL2 += isLabelL2 ? "<li>" + labelL2 + "</li>" : "";
                  liItemsTVL2 += "<li>" + noDashSpace + liItemL2 + "</li>";
                });

                liItemsPV += "<div><ul class='nodashed'>" + liItemsPVL2 + "</ul></div>";

                liItemsTV += "<div><ul class=\"nodashed\">" + liItemsTVL2 + "</ul></div>";
              }
            }
          });

          let dashClass = "nodashed";
          if (isNestedRangeValuesFlex) {
            dashClass = "dashed";
          }

          printableValue = "<div><ul class='" + dashClass +  "'>" + liItemsPV + "</ul></div>";
          if (liCounter >= maxLi) {
            tooltipValue = "<div><ul class=\"" + dashClass + "\">" + liItemsTV + "</ul></div>";
          }
        } else {
          if (property.valueSign !== undefined && property.valueSign !== null) {
            if (property.valueSign.length > 0) {
              printableValue = property.value + property.valueSign;
            }
          }
          if (printableValue === undefined || vm.isEmptyOrSpaces(printableValue)) {
            printableValue = property.value;
          }
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          printableValue = property.value;
        }
      } else {
        const maxCharsPerRow = 40;
        const maxRows = 1;
        let printedRows = 0;
        let flagDots = false;
        if (property.value !== undefined && property.value !== null) {
          if (property.value.length > maxCharsPerRow) {

            for (let i = 0; i < property.value.length && printedRows < maxRows;) {
              let endIndex = Math.min(i+maxCharsPerRow, property.value.length);
              let dots = "";
              if (printedRows+1 == maxRows) {
                dots = "...";
                flagDots = true;
              }
              printableValue += "<div>" + property.value.substring(i, endIndex) + dots + "</div>";
              i += maxCharsPerRow;
              printedRows += 1;
            }

            if (flagDots) {
              tooltipValue = property.value;
            }
          } else {
            if (property.valueSign !== undefined && !vm.isEmptyOrSpaces(property.valueSign)) {
              if (property.valueSign.length > 0) {
                printableValue = property.value + property.valueSign;
              }
            } else {
              printableValue = property.value;
            }
          }
        }
      }

      if (tooltipValue !== undefined && !vm.isEmptyOrSpaces(tooltipValue)) {
        printableValue = tooltipValue;
      }

      printableValue = printableValue.replace(/\n/g, "<br />");

      return printableValue;
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    _compare: function(a: any, b: any) {
      const aCode = a.code;
      const bCode = b.code;
      if (aCode === undefined || bCode === undefined) {
        if (bCode !== undefined) {
          return -1;
        }
        if (aCode !== undefined) {
          return 1;
        }
        return 0;
      }

      let aSplit = aCode.split(".");
      let bSplit = bCode.split(".");
      if (aSplit.length > 1 && bSplit.length > 1) {
        let aPre = parseInt(aSplit[0]);
        let aPost = parseInt(aSplit[1]);
  
        let bPre = parseInt(bSplit[0]);
        let bPost = parseInt(bSplit[1]);

        if (aPre == bPre) {
          if (aPost < bPost) {
            return -1;
          }
          if (aPost > bPost) {
            return 1;
          }
          return 0;
        } else if (aPre < bPre) {
          return -1;
        } else {
          return 1;
        }
      }

      if (aCode < bCode) {
        return -1;
      }
      if (aCode > bCode) {
        return 1;
      }
      return 0;
    },
    isAdmin: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isAdminView = vm.loggedUser.roles.indexOf('admin-view') >= 0;
      return isAdmin || isAdminView;
    },
    massivo: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isMassivo = vm.loggedUser.roles.indexOf('massivo') >= 0;

      return isAdmin || isMassivo;
    },
  },
  created() {
    const vm = this as any;

    vm.cleanAllProperties();

    vm.prefillProperties();
  },
  mounted() {
    const vm = this as any;
    if (!vm.loggedUser) {
      vm.home();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('vita-investimento') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.home();
      }
    }
  },
  destroyed() {
    const vm = this as any;
    //vm.stopLoading();
    vm.closeModalError();
  }
});
